<template>
  <div class="message-list-history">
    <vue-element-loading :active="!loadingGetDataMessageList" />
    <div class="container-message">
      <div class="loader" v-if="loadingOnScroll"></div>
      <div class="messager" ref="messager" v-cloak>
        <!-- pinned -->
        <pin-message ref="pinMessage" @scroll-message="scrollToMessage($event)" />
        <!-- end-pinned -->
        <!-- body chat -->
        <div class="chat-content custom-scroll-bar transition"
             @scroll="scrollChatContent($event)"
             id="chat-content">
          <div class="chat-wrapper" v-if="convensationExisted">
            <div v-observe-visibility="reachedEndOfListForMessage"/>
            <div :id="'message-' + mess.id" class="message-item wide" v-for="(mess, index) in messageList"
                 :key="mess.id" v-if="shouldRenderMessageAtIndex(mess, index)"
                 :set = "display_name = mess.sender && mess.sender.display_name || mess.sender && mess.sender.name"
                 :class="[
                   mess.type === MESSAGE_CHAT_TYPE.SYSTEM || mess.type === MESSAGE_CHAT_TYPE.ANNOUNCEMENT ? 'item-center' : (mess.sender && mess.sender.id === user.id  ? 'item-mine' : 'item-opposite'),
                   mess.text === TEXT_CHAT_SYSTEM.POLL_VOTE ? 'poll-vote-activity-item' : '',
                   isMessageActionsOpen(mess.id) ? 'message-item--actions-open' : ''
                 ]">
              <div class="dmnXwr" v-if="checkShowTime(mess, index)">
                {{ getTimeCreated(mess.created_at, 'HH:mm, DD MMMM, YYYY') }}
              </div>

              <div class="message" v-bind:class="checkMessageInBlock(mess, index) ? '' : 'mb-5px'">
                <div class="message-sender"
                     :class="mess.sender && mess.sender.id !== user.id  ? 'message-user-info userInfoPopover' : ''"
                     v-if="mess.type !== MESSAGE_CHAT_TYPE.SYSTEM && mess.type !== MESSAGE_CHAT_TYPE.ANNOUNCEMENT">
                  <div class="block-avatar" v-if="$store.state.chat.chatGroupSelected.type === 'BOT'">
                    <image-template
                      class="app-avatar app-avatar--user mr-2 cursor-pointer"
                      :size="'small'"
                      :image="chatGroupSelected.avatar"
                      :thumbnail="chatGroupSelected.thumbnail"
                      :name="chatGroupSelected.name"
                      img-type="group"
                    />
                  </div>
                  <div class="block-avatar" v-else
                       v-on:mouseenter="onMouseoverUserInfo($event, mess)"
                       v-on:mouseleave="onMouseleaveUserInfo">
                    <image-template
                      v-if="mess.sender && mess.sender.id !== user.id && checkShowAvatar(mess, index)"
                      class="app-avatar app-avatar--user mr-2 cursor-pointer"
                      :size="'small'"
                      :image="mess.sender.avatar_url"
                      :thumbnail="mess.sender.thumbnail"
                      :name="chatSenderDisplayName(mess.sender)"
                    />
                  </div>
                </div>

                <template v-if="mess.type === MESSAGE_CHAT_TYPE.SYSTEM">
                  <div class="message-body message-body--poll-vote-activity" v-if="mess.text === TEXT_CHAT_SYSTEM.POLL_VOTE">
                    <div v-if="shouldShowPollVoteExpandButton(index)" class="poll-vote-expand-row">
                      <button
                        type="button"
                        class="poll-vote-expand-btn"
                        @click.stop="expandPollVoteGroup(pollVoteRunGroupKey(index))"
                      >
                        Xem thêm
                      </button>
                    </div>
                    <poll-vote-activity-message
                      :mess="mess"
                      :current-user-id="user.id"
                      @open-poll="openPollVoteModal"
                    />
                  </div>
                  <div class="message-body" v-else>
                    <div class="messenger__action-note-detail" v-if="mess.text === TEXT_CHAT_SYSTEM.CREATE_USER_CHAT">
                      <div class="new-conversation"></div>
                    </div>
                    <div class="messenger__action-note-detail" v-else-if="mess.text === TEXT_CHAT_SYSTEM.APPROVE_JOIN_GROUP">
                      <span class="icon-action-note">
                        <img :src="getImageTypeSystem(mess)" alt="icon-action-note" class="mr-10px">
                      </span>
                      <div class="action-note-content">
                        <span class="text-400-default" v-html="getApproveJoinGroupText(mess)"></span>
                      </div>
                    </div>
                    <div class="messenger__action-note-detail" v-else>
                      <span class="icon-action-note">
                        <img :src="getImageTypeSystem(mess)" alt="icon-action-note" class="mr-10px">
                      </span>
                      <div class="action-note-content">
                        <div class="action-note-content">
                          <span class="text-400-medium" href="">{{ mess.sender.id === user.id ? 'Bạn' : mess.sender.name }}</span>
                          <span class="text-400-default" v-html=getTextTypeSystem(mess)></span>
                          <span @click="showListAddMember(mess.system_note)"
                            v-if="(mess.text === TEXT_CHAT_SYSTEM.ADD_USER_GROUP || mess.text === TEXT_CHAT_SYSTEM.REMOVE_USER) &&
                                systemNoteHasMultipleMembers(mess)" class="other-member">
                                 và {{ systemNoteMemberCount(mess) - 1 }} người khác
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <div class="message-body" :class="messageBodyRowClass(mess)">
                    <div class="message-content-wrapper" :class="mess.poll && mess.poll.id ? 'poll-message-wrapper' : ''">
                      <div class="message-delete-status" v-if="mess.delete_status === 2">
                        <div class="message_recall" style="padding-top: 6px !important; padding-bottom: 6px !important;">
                          <div class="sender-name mb-2px" v-if="checkShowSenderName(mess, index)">
                            <span>{{ display_name }}</span></div>
                          <span class="text-400-default"><i>Tin nhắn đã được thu hồi</i></span>
                          <div class="content-display-timestamp" v-if="!checkMessageInBlock(mess, index)">
                            <span>{{ getMessageTime(mess) }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="message-media"
                           :class="{
                            action_type_history : !checkMessageInBlock(mess, index) && mess.type !== MESSAGE_CHAT_TYPE.TEXT && mess.type !== MESSAGE_CHAT_TYPE.ANNOUNCEMENT,
                            replyMessager: mess.reply_to_msg !== null
                           }"
                           v-if="mess.delete_status == null || mess.delete_status == 1">
                        <div class="message-action">
                          <div class="message-reaction">
                            <div class="full-radius message-text-action" style="overflow: hidden;">
                              <template v-if="mess.forward_msg_id">
                                <share-message-content :mess = mess :user = user />
                              </template>
                              <template v-if="mess.type === MESSAGE_CHAT_TYPE.TEXT">
                                <template v-if="mess.poll && mess.poll.id">
                                    <poll-message-content
                                      :mess="mess"></poll-message-content>
                                </template>
                                <template v-else>
                                  <div class="messageReply" v-if="mess.reply_to_msg !== null"
                                      @click="scrollToMessage(mess.reply_to_msg.id)">
                                    <reply-chat-content :mess = mess :user = user />
                                  </div>
                                  <div class="message-text full-radius"
                                     :class="isOnlyOneEmoji(mess.text) ? 'isOnlyEmoji' : ''">
                                  <div class="sender-name" v-if="checkShowSenderName(mess, index) && mess.reply_to_msg == null">
                                    <span>{{ display_name }}</span></div>
                                  <div class="content-display">
                                    <tag-chat-content :mess="tagContentChat(mess)"></tag-chat-content>
                                    <div
                                        :class="{
                                          'emoji' : isOnlyOneEmoji(mess.text),
                                          'text-400-default neutral_1 wb-break-word' : !isOnlyOneEmoji(mess.text),
                                          'report-ckeditor' : mess.tag_list !== null
                                        }"
                                        v-html=getMessageText(mess)></div>
                                  </div>
                                  <div v-if="mess.link_metadata != null">
                                    <div class="metadata-message" :set="metadata = JSON.parse(mess.link_metadata)">
                                      <div v-if="!!metadata.title">
                                        <div class="container-linkmetadata" :class="mess.status_message === 'sending' && typeof mess.status_message !== 'undefined' ? 'loading-holder' : ''">
                                          <a target="_blank" :href="mess.status_message === 'sending' && typeof mess.status_message !== 'undefined' ? '#' : metadata.url" class="container-metadata">
                                            <div class="metadata-image loader-shimmer">
                                              <img :src="metadata.image || '/img/link.png'" alt="app-thumbnail">
                                            </div>
                                            <div class="metadata-content">
                                                <p class="title text-1-line loader-shimmer">{{ metadata.title }}</p>
                                                <p class="description text-2-line loader-shimmer">{{ metadata.description }}</p>
                                                <p class="domain text-1-line loader-shimmer" v-if="metadata.url && metadata.url != '/' ">{{ metadata.url }}</p>
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="emojis" v-if="sumEmoji(mess.reaction_stats) > 0"
                                       @click="$modal.show('reaction-message-detail-modal', {message_id : mess.id})">
                                    <div v-for="(emoji_icon, icon) in mess.reaction_stats" v-if="emoji_icon > 0"
                                         :key="icon" class="emoji-wrapper">
                                      <span class="mr-2px text-400-medium neutral_3">{{ emoji_icon }}</span>
                                      <div :class="'reaction-' + icon" class="emoji_icon"></div>
                                    </div>
                                  </div>
                                  <div class="content-display-timestamp">
                                    <span v-if="mess.history_message !== null">
                                      <span :class="(isAdmin === true || $store.state.chat.chatGroupSelected.type === 'USER') ? 'cursor-pointer hover-link' : ''"
                                            @click="openModalMessageHistory(mess)">Đã chỉnh sửa</span>
                                      <span v-if="!checkMessageInBlock(mess, index)">・</span>
                                    </span>
                                    <span v-if="!checkMessageInBlock(mess, index)">{{ getMessageTime(mess) }}</span>
                                  </div>
                                </div>
                                </template>
                              </template>

                              <template v-if="mess.type === MESSAGE_CHAT_TYPE.ANNOUNCEMENT">
                                <div class="message-text full-radius announcement-center-card">
                                  <div class="announcement-center-card__top-row">
                                    <div class="announcement-center-card__top-left">
                                      <span class="announcement-center-card__kind">THÔNG BÁO</span>
                                      <span
                                        v-if="mess.announcement && mess.announcement.expires_at"
                                        class="announcement-center-card__status-badge"
                                        :class="{ 'announcement-center-card__status-badge--expired': announcementIsExpiredLive(mess) }"
                                      >{{ announcementExpiryBadgeText(mess) }}</span>
                                    </div>
                                    <div
                                      v-if="mess.status_message === 'done' || typeof mess.status_message === 'undefined'"
                                      class="announcement-center-card__inline-actions"
                                    >
                                      <div class="announcement-center-card__action-bar">
                                        <div class="popup reaction-message emoticon mr-2px announcement-center-card__popup-anchor">
                                          <div
                                            class="action"
                                            @click.stop="dropDown.emoji === mess.id ? hideDropDown() : dropDownAction(mess.id, 'emoji')"
                                          >
                                            <img class="icon_history_action" src="/img/chat/heart.svg" alt="">
                                          </div>
                                          <Transition name="slide-fade">
                                            <div
                                              class="actionPopup emojis announcement-center-card__emoji-popup"
                                              v-click-outside="hideDropDown"
                                              v-if="dropDown.emoji === mess.id"
                                            >
                                              <div
                                                v-for="(emoji, ei) in emojis()"
                                                :key="ei"
                                                :class="'reaction-' + emoji"
                                                class="emoji_icon"
                                                @click="reactionMessage(mess.id, emoji, ei)"
                                              />
                                              <div
                                                v-if="mess.is_acc_mention === 1 && Object.values(mess.reaction_stats).reduce((a, b) => a + b, 0) > 0"
                                                class="remove-self-emoji"
                                              >
                                                <span class="material-icons float-right cursor-pointer" @click="deleteReaction(mess)">close</span>
                                              </div>
                                            </div>
                                          </Transition>
                                        </div>
                                        <div class="popup reply mr-2px">
                                          <div class="action" @click.stop="replyChat(mess)">
                                            <img class="icon_history_action" src="/img/chat/reply.svg" alt="">
                                          </div>
                                        </div>
                                        <div class="popup emoticon announcement-center-card__popup-anchor">
                                          <div
                                            class="action"
                                            @click.stop="dropDown.more === mess.id ? hideDropDown() : dropDownAction(mess.id, 'more')"
                                          >
                                            <img class="icon_history_action" src="/img/chat/three-dots.svg" alt="">
                                          </div>
                                          <div class="actionPopup menu announcement-center-card__more-popup" v-click-outside="hideDropDown" v-if="dropDown.more === mess.id">
                                            <div class="more_action pin-message" @click="pinMessageToList(mess.id, mess.pinned_at == null)">
                                              <span>{{ mess.pinned_at == null ? 'Ghim' : 'Bỏ ghim' }} tin nhắn</span>
                                            </div>
                                            <div
                                              class="more_action"
                                              @click="editMessage(mess)"
                                              v-if="mess.sender && mess.sender.id === user.id && (mess.type === MESSAGE_CHAT_TYPE.TEXT || mess.type === MESSAGE_CHAT_TYPE.ANNOUNCEMENT || mess.text !== null)"
                                            >
                                              <span>Chỉnh sửa tin nhắn</span>
                                            </div>
                                            <div class="more_action" v-if="mess.text" v-clipboard:copy="mess.text" v-clipboard:success="() => dropDown.more = false">
                                              <span>Sao chép tin nhắn</span>
                                            </div>
                                            <div class="more_action" @click="shareMessage(mess)">
                                              <span>Chuyển tiếp</span>
                                            </div>
                                            <div class="more_action category_message_change" v-if="mess.text && mess.sender.id == user.id">
                                              <span @click="openMenuOther(mess.id)">Đổi dạng tin nhắn <md-icon class="menu-icon-arrow-right">arrow_right</md-icon></span>
                                              <div class="menuOtherOption" v-if="menuOther == mess.id">
                                                <div class="listOther">
                                                  <div class="report-category" @click="changeCategory(mess, 'DEFAULT')">KỶ LỤC MỚI</div>
                                                  <div class="report-category" @click="changeCategory(mess, 'REPORT')">BÁO CÁO</div>
                                                  <div class="report-category" @click="changeCategory(mess, 'REWARD')">KHEN THƯỞNG</div>
                                                  <div class="report-category" @click="changeCategory(mess, 'DISCIPLINE')">KỶ LUẬT</div>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              class="more_action recovery_message"
                                              @click="showConfirmDeletePost(mess.id, 2)"
                                              v-if="mess.sender && mess.sender.id === user.id"
                                            >
                                              <span>Thu hồi</span>
                                            </div>
                                            <div
                                              class="more_action delete_message"
                                              @click="showConfirmDeletePost(mess.id, 1)"
                                              v-if="mess.sender && mess.sender.id === user.id"
                                            >
                                              <span>Xóa chỉ ở phía tôi</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="announcement-center-card__title-row">
                                    <span class="announcement-center-card__heading text-500-semibold">{{ (mess.announcement && mess.announcement.title) || mess.text }}</span>
                                  </div>
                                  <div class="announcement-center-card__footer-row">
                                    <span class="announcement-center-card__creator">
                                      <image-template
                                        class="announcement-center-card__avatar"
                                        :size="'small'"
                                        :image="mess.sender && mess.sender.avatar_url"
                                        :thumbnail="mess.sender && mess.sender.thumbnail"
                                        :name="chatSenderDisplayName(mess.sender) || chatGroupSelected.name"
                                      />
                                      <span class="announcement-center-card__name">{{ mess.sender && (mess.sender.display_name || mess.sender.name) }}</span>
                                    </span>
                                    <span v-if="mess.announcement && mess.announcement.expires_at"
                                          class="announcement-center-card__expiry-inline">
                                      <span class="announcement-center-card__label">Hết hạn lúc:</span>
                                      <span
                                        v-if="mess.announcement && mess.announcement.expires_at"
                                        class="announcement-center-card__expiry-time"
                                      >{{ formatAnnouncementExpires(mess.announcement.expires_at) }}</span>
                                      <span v-else class="announcement-center-card__expiry-time announcement-center-card__expiry-time--none">Không giới hạn</span>
                                    </span>
                                  </div>
                                  <ul v-if="announcementPayloadDataEntries(mess).length" class="announcement-center-card__kv-list">
                                    <li
                                      v-for="row in announcementPayloadDataEntries(mess)"
                                      :key="row.key"
                                      class="announcement-center-card__kv-item"
                                    >
                                      <div class="announcement-center-card__kv-title">{{ row.key }}</div>
                                      <div
                                        class="announcement-center-card__kv-content ws-pre-wrap"
                                        v-html="linkifyAnnouncementText(formatAnnouncementDataValue(row.value))"
                                      ></div>
                                    </li>
                                  </ul>
                                  <div
                                    v-if="announcementTableMessage(mess)"
                                    class="announcement-center-card__message text-400-default neutral_1 ws-pre-wrap"
                                    v-html="linkifyAnnouncementText(announcementTableMessage(mess))"
                                  ></div>
                                  <div
                                    v-if="mess.files && mess.files.length && announcementAttachmentKind(mess)"
                                    class="announcement-center-card__attachments"
                                  >
                                    <image-chat-content
                                      v-if="announcementAttachmentKind(mess) === 'image'"
                                      :display-name="display_name"
                                      :current-mess="mess"
                                      :next-mess="messageList[index + 1]"
                                      :hide-footer="true"
                                    />
                                    <video-chat-content
                                      v-else-if="announcementAttachmentKind(mess) === 'video'"
                                      :display-name="display_name"
                                      :current-mess="mess"
                                      :next-mess="messageList[index + 1]"
                                      :hide-footer="true"
                                    />
                                    <file-chat-content
                                      v-else
                                      :display-name="display_name"
                                      :current-mess="mess"
                                      :next-mess="messageList[index]"
                                      :hide-footer="true"
                                    />
                                  </div>
                                  <div
                                    v-if="mess.link_metadata && announcementLinkMetadata(mess) && announcementLinkMetadata(mess).title"
                                    class="announcement-center-card__linkmetadata"
                                  >
                                    <div class="metadata-message">
                                      <div>
                                        <div
                                          class="container-linkmetadata"
                                          :class="mess.status_message === 'sending' && typeof mess.status_message !== 'undefined' ? 'loading-holder' : ''"
                                        >
                                          <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            :href="mess.status_message === 'sending' && typeof mess.status_message !== 'undefined' ? '#' : (announcementLinkMetadata(mess).url || '#')"
                                            class="container-metadata"
                                          >
                                            <div class="metadata-image loader-shimmer">
                                              <img
                                                :src="announcementLinkMetadata(mess).image || '/img/link.png'"
                                                alt=""
                                              >
                                            </div>
                                            <div class="metadata-content">
                                              <p class="title text-1-line loader-shimmer">{{ announcementLinkMetadata(mess).title }}</p>
                                              <p class="description text-2-line loader-shimmer">{{ announcementLinkMetadata(mess).description }}</p>
                                              <p
                                                v-if="announcementLinkMetadata(mess).url && announcementLinkMetadata(mess).url !== '/'"
                                                class="domain text-1-line loader-shimmer"
                                              >{{ announcementLinkMetadata(mess).url }}</p>
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="emojis" v-if="sumEmoji(mess.reaction_stats) > 0"
                                       @click="$modal.show('reaction-message-detail-modal', {message_id : mess.id})">
                                    <div v-for="(emoji_icon, icon) in mess.reaction_stats" v-if="emoji_icon > 0"
                                         :key="icon" class="emoji-wrapper">
                                      <span class="mr-2px text-400-medium neutral_3">{{ emoji_icon }}</span>
                                      <div :class="'reaction-' + icon" class="emoji_icon"></div>
                                    </div>
                                  </div>
                                  <div class="content-display-timestamp">
                                    <span v-if="mess.history_message !== null">
                                      <span :class="(isAdmin === true || $store.state.chat.chatGroupSelected.type === 'USER') ? 'cursor-pointer hover-link' : ''"
                                            @click="openModalMessageHistory(mess)">Đã chỉnh sửa</span>
                                      <span v-if="!checkMessageInBlock(mess, index)">・</span>
                                    </span>
                                    <span v-if="!checkMessageInBlock(mess, index)">{{ getMessageTime(mess) }}</span>
                                  </div>
                                </div>
                              </template>

                              <template v-if="mess.type === MESSAGE_CHAT_TYPE.IMAGE && isChatStickerMessage(mess.system_note)">
                                <div v-if="hasMessageMediaFiles(mess)">
                                  <div class="sender-name" v-if="checkShowSenderName(mess, index)">
                                    <span>{{ display_name }}</span>
                                  </div>
                                  <sticker-chat-content
                                    :currentMess="mess"
                                    :nextMess="nextMessageAt(index)"
                                  />
                                </div>
                              </template>

                              <template v-else-if="mess.type === MESSAGE_CHAT_TYPE.IMAGE">
                                <div v-if="!!mess.text">
                                  <div class="message-text full-radius">
                                    <div class="sender-name" v-if="checkShowSenderName(mess, index)">
                                      <span>{{ display_name }}</span></div>
                                    <div class="content-display" style="margin-bottom: 5px">
                                      <tag-chat-content :mess="tagContentChat(mess)"></tag-chat-content>
                                      <div class="text-400-default is-message neutral_1 ws-pre-wrap"
                                          @click="openSearchChat"
                                          v-html=getMessageText(mess)></div>
                                    </div>
                                    <image-chat-content :displayName = display_name :currentMess = mess
                                                        :nextMess = nextMessageAt(index) v-if="hasMessageMediaFiles(mess)"/>
                                  </div>
                                </div>
                                <div v-else-if="hasMessageMediaFiles(mess)">
                                  <div class="sender-name" v-if="checkShowSenderName(mess, index)">
                                    <span>{{ display_name }}</span>
                                  </div>
                                  <image-chat-content :displayName = display_name :currentMess = mess :nextMess = nextMessageAt(index) />
                                </div>
                              </template>

                              <template v-if="mess.type === MESSAGE_CHAT_TYPE.VIDEO">
                                <div v-if="!!mess.text">
                                  <div class="message-text full-radius">
                                    <div class="sender-name" v-if="checkShowSenderName(mess, index)">
                                      <span>{{ display_name }}</span></div>
                                    <div class="content-display" style="margin-bottom: 5px">
                                      <tag-chat-content :mess="tagContentChat(mess)"></tag-chat-content>
                                      <div class="text-400-default is-message neutral_1 ws-pre-wrap"
                                          @click="openSearchChat"
                                           v-html=getMessageText(mess)></div>
                                    </div>
                                    <video-chat-content v-if="hasMessageMediaFiles(mess)" :displayName = display_name
                                                        :currentMess = mess :nextMess = nextMessageAt(index) />
                                  </div>
                                </div>
                                <div v-else>
                                  <div class="sender-name" v-if="checkShowSenderName(mess, index)">
                                    <span>{{ display_name }}</span></div>
                                  <video-chat-content :displayName = display_name :currentMess = mess :nextMess = nextMessageAt(index) />
                                </div>
                              </template>

                              <template v-if="mess.type === MESSAGE_CHAT_TYPE.FILE">
                                <div v-if="!!mess.text">
                                  <div class="message-text full-radius">
                                    <div class="sender-name" v-if="checkShowSenderName(mess, index)">
                                      <span>{{ display_name }}</span>
                                    </div>
                                    <div class="content-display" style="margin-bottom: 5px">
                                      <tag-chat-content :mess="tagContentChat(mess)"></tag-chat-content>
                                      <div class="text-400-default is-message neutral_1 ws-pre-wrap"
                                          @click="openSearchChat"
                                           v-html=getMessageText(mess)></div>
                                    </div>
                                    <file-chat-content  v-if="mess.files.length > 0" :displayName = display_name
                                                        :currentMess = mess :nextMess = messageList[index] />
                                  </div>
                                </div>
                                <div v-else>
                                  <div class="sender-name" v-if="checkShowSenderName(mess, index)">
                                    <span>{{ display_name }}</span></div>
                                  <file-chat-content :displayName = display_name :currentMess = mess :nextMess = messageList[index] />
                                </div>
                              </template>

                            </div>
                          </div>
                          <!-- <div class="history__action actions">
                          </div> -->
                          <!-- emojis -->
                          <!-- v-popover:tooltip.top="emoji_icon" -->
                          <!-- @click="$modal.show('user-message-interactive-modal', {listEmoji : mess.reaction_stats})" -->
                          <!-- end -->
                        </div>
                        <div v-if="mess.type !== MESSAGE_CHAT_TYPE.ANNOUNCEMENT" class="pophover-datetime">
                          <span>{{ getMessageTimeCreated(mess) }}</span>
                        </div>
                        <div
                          class="historyAction"
                          v-if="mess.type !== MESSAGE_CHAT_TYPE.ANNOUNCEMENT && (mess.status_message === 'done' || typeof mess.status_message === 'undefined')"
                          @mouseenter="cancelHideMessageActions"
                          @mouseleave="scheduleHideMessageActions"
                        >
                          <div class="container_popup">
                            <div class="popup reaction-message emoticon mr-2px" v-on:mouseover="dropDownAction(mess.id, 'emoji')">
                              <div class="action"  @click="reactionMessage(mess.id, 'love', 2)">
                                <img class="icon_history_action" src="/img/chat/heart.svg"/>
                              </div>
                              <Transition name="slide-fade">
                                <div class="actionPopup emojis" v-click-outside="hideDropDown" v-on:mouseover="dropDownAction(mess.id, 'emoji')"
                                    v-if="dropDown.emoji === mess.id">
                                  <div v-for="(emoji, index) in emojis()" @click="reactionMessage(mess.id, emoji, index)"
                                      :key="index" :class="'reaction-' + emoji" class="emoji_icon"></div>
                                      <div class="remove-self-emoji" v-if="mess.is_acc_mention === 1 && Object.values(mess.reaction_stats).reduce((a, b) => a + b, 0) > 0">
                                        <span class="material-icons float-right cursor-pointer" @click="deleteReaction(mess)">close</span>
                                      </div>
                                </div>
                            </Transition>
                            </div>
                            <div class="popup reply mr-2px" v-on:mouseover="dropDownAction(null, 'emoji')">
                              <div class="action" @click="replyChat(mess)">
                                <img class="icon_history_action" src="/img/chat/reply.svg"/>
                              </div>
                            </div>
                            <div class="popup emoticon">
                              <div class="action" v-on:click="dropDownAction(mess.id, 'more')">
                                <img class="icon_history_action" src="/img/chat/three-dots.svg"/>
                              </div>
                              <div class="actionPopup menu" v-click-outside="hideDropDown" v-if="dropDown.more === mess.id">
                                <div class="more_action pin-message" @click="pinMessageToList(mess.id, mess.pinned_at == null)">
                                  <span>{{ mess.pinned_at == null ? 'Ghim' : 'Bỏ ghim' }} tin nhắn</span>
                                </div>
                                <div class="more_action"
                                     @click="editMessage(mess)"
                                     v-if="mess.sender && mess.sender.id === user.id && (mess.type === MESSAGE_CHAT_TYPE.TEXT || mess.type === MESSAGE_CHAT_TYPE.ANNOUNCEMENT || mess.text !== null)"
                                >
                                  <span>Chỉnh sửa tin nhắn</span>
                                </div>
                                <div class="more_action" v-if="mess.text" v-clipboard:copy="mess.text" v-clipboard:success="() => dropDown.more = false">
                                  <span>Sao chép tin nhắn</span>
                                </div>
                                <div class="more_action" @click="shareMessage(mess)">
                                  <span>Chuyển tiếp</span>
                                </div>
                                <div class="more_action category_message_change" v-if="mess.text && mess.sender.id == user.id">
                                  <span @click="openMenuOther(mess.id)">Đổi dạng tin nhắn <md-icon class="menu-icon-arrow-right">arrow_right</md-icon></span>
                                  <div class="menuOtherOption" v-if="menuOther == mess.id">
                                    <div class="listOther">
                                      <div class="report-category" @click="changeCategory(mess, 'DEFAULT')">KỶ LỤC MỚI</div>
                                      <div class="report-category" @click="changeCategory(mess, 'REPORT')">BÁO CÁO</div>
                                      <div class="report-category" @click="changeCategory(mess, 'REWARD')">KHEN THƯỞNG</div>
                                      <div class="report-category" @click="changeCategory(mess, 'DISCIPLINE')">KỶ LUẬT</div>
                                    </div>
                                  </div>
                                </div>
                                <div class="more_action recovery_message"
                                     @click="showConfirmDeletePost(mess.id, 2)"
                                     v-if="mess.sender && mess.sender.id === user.id"
                                >
                                  <span>Thu hồi</span>
                                </div>
                                <div class="more_action delete_message"
                                     @click="showConfirmDeletePost(mess.id, 1)"
                                     v-if="mess.sender && mess.sender.id === user.id"
                                >
                                  <span>Xóa chỉ ở phía tôi</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                     <div class="message-status" v-if="mess.sender && mess.sender.id === user.id">
                       <template v-if="isLastMyMessage(index)">
                         <span class="messager-sending status-action"
                               v-if="mess.status_message === 'sending'">
                           <md-icon class="ic-z16">schedule</md-icon>
                           <span class="text-200-default">Đang gửi</span>
                         </span>
                         <div class="error-send"
                              v-else-if="mess.status_message === 'disconnect'">
                           Lỗi gửi tin.
                           <span class="reSendMessage cursor-pointer" @click="reSendMessageError(mess.id)">Gửi lại</span>
                         </div>
                         <div class="error-send"
                              v-else-if="mess.status_message === 'error'">
                           Lỗi gửi tin.
                           <span class="reSendMessage cursor-pointer" @click="reSendMessageError(mess.id)">Gửi lại</span>
                         </div>
                         <div class="messager-send status-action"
                              v-else-if="outboundMessageAcknowledged(mess) && messageSeenByPeer(mess)">
                           <md-icon class="ic-z16">done_all</md-icon>
                           <span class="text-200-default">Đã xem</span>
                         </div>
                         <div class="messager-sended status-action"
                              v-else-if="outboundMessageAcknowledged(mess)">
                           <md-icon class="ic-z16">done</md-icon>
                           <span class="text-200-default">Đã gửi</span>
                         </div>
                       </template>
                       <template v-else>
                         <div class="error-send"
                              v-if="mess.status_message === 'disconnect'">
                           Lỗi gửi tin.
                           <span class="reSendMessage cursor-pointer" @click="reSendMessageError(mess.id)">Gửi lại</span>
                         </div>
                         <div class="error-send"
                              v-else-if="mess.status_message === 'error'">
                           Lỗi gửi tin.
                           <span class="reSendMessage cursor-pointer" @click="reSendMessageError(mess.id)">Gửi lại</span>
                         </div>
                         <span class="messager-sending status-action"
                               v-else-if="mess.status_message === 'sending'">
                           <md-icon class="ic-z16">schedule</md-icon>
                           <span class="text-200-default">Đang gửi</span>
                         </span>
                       </template>
                     </div>
                    </div>
                    <!-- <div class="message-status">
                      <span class="messager-sending">
                        <md-icon>done</md-icon>
                      </span>
                    </div> -->
                  </div>
                </template>

              </div>

              <!-- <div class="message-seen message-seen-inline">
                <div class="sc-dSgAzf bcxvhx" v-if="mess.sender.id === user.id">
                  <span class="sc-dkBjDj sc-juLlUl iysmYH">
                    <span class="sc-gjXrWX daIMPk"></span>
                  </span>
                </div>
              </div> -->
            </div>
            <div v-if="showChatWelcomeEmpty" class="message-item chat-welcome-empty">
              <div class="chat-welcome-empty__card">
                <md-icon
                  v-if="showOfficialTeamVerifiedChat"
                  class="official-team-verified chat-welcome-empty__verified"
                  title="Nhóm chat chính thức theo đội (đã liên kết hệ thống)"
                >verified</md-icon>
                <h3 class="chat-welcome-empty__title">{{ chatWelcomeTitle }}</h3>
                <p class="chat-welcome-empty__text">{{ chatWelcomeText }}</p>
              </div>
            </div>
          </div>
          <div class="chat-wrapper" v-if="!convensationExisted">
            <div class="message-item new-chat">
              <span class="text-center">Gửi tin nhắn đến
                <strong class="new-chat-target-name">
                  <span class="new-chat-target-name__inner">{{ this.$store.state.chat.chatGroupSelected.name }}</span>
                  <md-icon
                    v-if="showOfficialTeamVerifiedChat"
                    class="official-team-verified md-icon md-icon-font md-theme-default"
                    title="Nhóm chat chính thức theo đội (đã liên kết hệ thống)"
                  >verified</md-icon>
                </strong>
                <br>để bắt đầu cuộc trò chuyện</span>
            </div>
          </div>
          <!-- user reply -->
          <div style="height: 25px"></div>
        </div>
         <!-- end body chat -->
        <div class="chat-footer transition"
          v-if="chatGroupSelected.chat_privacy !== 'readonly' || (chatGroupSelected.chat_privacy == 'readonly' && chatGroupSelected.is_admin == 1)" >
          <div class="user-reply text-300-default neutral_1"
               v-if="showUserReply && dataUserTypingRealCount > 0 && typingUiMatchesOpenConversation">
            <template v-if="chatGroupSelected.type === GROUP_CHAT_TYPE.USER">
              <span>{{ dataUserTyping[0].user_typing.fullname }} đang nhập</span>
            </template>
            <template v-else>
              <span v-if="dataUserTypingRealCount === 1">{{ dataUserTyping[0].user_typing.fullname }} đang nhập</span>
              <span v-if="dataUserTypingRealCount > 1">{{ dataUserTypingRealCount }} người đang nhập</span>
            </template>
          </div>
          <div class="file-upload border-top app-scroll" style="overflow-x: auto;overflow-y: hidden;"
               v-if="medias.length > 0">
            <div class="file-upload__container">
              <!-- <vue-element-loading :active="loadingFile" spinner="bar-fade-scale"/> -->
              <div v-for="(file, index) in medias" :key="index" class="upload-file-chat" :class="file.type + '-upload-chat'">
                <vue-element-loading :active="file.loading == 'loading'" spinner="bar-fade-scale"/>
                <template v-if="file.type === 'video'">
                  <div class="photo-upload-item">
                    <template>
                      <div class="p-relative">
                        <video class="file-img" controls="false" style="margin: auto">
                          <source :src="file.path">
                          Sorry, your browser doesn't support embedded videos.
                        </video>
                        <div class="w_100 h_100 p-absolute " style="top: 0px; left: 0px"></div>
                      </div>
                    </template>
                    <div class="photo-delete__action" @click="removeFile(index)">
                      <md-icon>close</md-icon>
                    </div>
                  </div>
                </template>
                <template v-if="file.type === 'image'">
                  <div class="photo-upload-item">
                    <template>
                      <img class="file-img" :src="file.path">
                    </template>
                    <div class="photo-delete__action" @click="removeFile(index)">
                      <md-icon>close</md-icon>
                    </div>
                  </div>
                </template>
                <template v-if="file.type === 'file'">
                  <div class="file-upload-item mx-2">
                    <div class="item-container">
                      <div class="url-colection-thumb mr-5px"><img src="/img/chat/Type-Other.svg" alt="thumb"></div>
                      <div class="file-content">
                        <div class="heading-400 text-1-line wb-break-all">{{ file.name }}</div>
                        <div class="text-300-default neutral_2"><span>{{
                            file.extension
                          }} - {{ bytesToSize(file.file_size) }}</span></div>
                      </div>
                    </div>
                    <div class="photo-delete__action" @click="removeFile(index)">
                      <md-icon>close</md-icon>
                    </div>
                  </div>
                </template>
                <template v-if="file.loading == 'error'">
                  <div class="error-upload">
                    <span>Lỗi</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <!-- reply -->
          <div class="reply-messager border-top app-scroll" v-if="replyMessager.active">
            <template>
              <div class="contentReply">
                <div class="sender-reply" v-if="!form_input.isEdit">
                  <span class="material-icons">format_quote</span>
                  <image-template
                    v-if="replyMessager.message.type == MESSAGE_CHAT_TYPE.ANNOUNCEMENT && replyMessager.message.sender"
                    class="reply-announcement-avatar"
                    :size="'small'"
                    :image="replyMessager.message.sender.avatar_url"
                    :thumbnail="replyMessager.message.sender.thumbnail"
                    :name="chatSenderDisplayName(replyMessager.message.sender)"
                  />
                  <span style="margin: auto 0">Trả lời
                    <span v-if="replyMessager.message.sender.id != user.id" class="sender-name text-400-semibold"> {{ replyMessager.message.sender.name }}</span>
                    <span v-else> chính mình</span>
                  </span>
                  </div>
                  <div class="edit-message" v-else>
                    <span class="material-icons" style="font-size: 16px;">border_color</span>
                    <span class="sender-name text-400-medium">Chỉnh sửa tin nhắn</span>
                  </div>
                <div class="templateType text-1-line">
                  <template v-if="replyMessager.message.type == MESSAGE_CHAT_TYPE.FILE">
                    <img
                      class="reply-file-icon"
                      :src="getChatFileIcon(replyMessager.message.files && replyMessager.message.files[0] && replyMessager.message.files[0].extension)"
                      alt="file"
                    />
                    <span class="text text-1-line">{{ (replyMessager.message.files && replyMessager.message.files[0] && replyMessager.message.files[0].name) || 'File' }}</span>
                  </template>
                  <template v-else-if="replyMessager.message.type == MESSAGE_CHAT_TYPE.IMAGE">
                    <img class="reply-asset" :src="replyMessager.message.files[0].thumbnail.medium_thumb" alt="">
                    <span class="text"> Hình ảnh</span>
                  </template>
                  <template v-else-if="replyMessager.message.type == MESSAGE_CHAT_TYPE.VIDEO">
                    <video class="reply-asset">
                      <source :src="replyMessager.message.files[0].path">
                      Sorry, your browser doesn't support embedded videos.
                    </video>
                    <span class="text"> Video</span>
                  </template>
                  <template v-else-if="replyMessager.message.type == MESSAGE_CHAT_TYPE.ANNOUNCEMENT">
                    <span class="text">{{ (replyMessager.message.announcement && replyMessager.message.announcement.title) || replyMessager.message.text }}</span>
                  </template>
                  <template v-else>
                    {{ replyMessager.message.text }}
                  </template>
                </div>
              </div>
              <div class="cancel-reply cursor-pointer" @click="closeReplyTemplate()">
                <span class="cancelRep">cancel</span>
              </div>
            </template>
          </div>

          <div class="reply-section p-relative">
            <VEmojiPicker class="p-absolute emoji" v-if="showDialogEmoji" @select="onSelectEmoji"
                          v-click-outside="hiddenDialogEmoji"/>

            <div class="fast-message" v-if="isFastMessage">
              <template v-if="!!tag_settings">
                <div class="f-message neutral_1" v-for="(tag, index) in tag_settings" :key="index" @click="chatFastMessage(tag)">
                  {{ tag }}
                </div>
              </template>
              <template v-else><div class="text-400-default">Vui lòng đăng nhập lại để sử dụng tính năng</div></template>
            </div>

            <div class="chat-footer__toolbar">
              <div class="chat-footer__toolbar-icons messager-attach-toolbar-icons">
                <md-icon
                  @click.native="openUpload('image')"
                  class="footer-icon footer-icon-media"
                  style="color: #198eeb"
                  title="Gửi ảnh"
                >photo</md-icon>
                <md-icon
                  @click.native="openUpload('video')"
                  class="footer-icon footer-icon-media"
                  style="color: #7b1fa2"
                  title="Gửi video"
                >videocam</md-icon>
                <img
                  class="footer-icon upload-file"
                  src="/img/chat/attachment.svg"
                  alt=""
                  title="Đính kèm file"
                  @click="openUpload('file')"
                >
                <md-icon
                  @click.native="activeFastMessage()"
                  class="footer-icon"
                  style="color: #198eeb"
                  title="Tin nhắn nhanh"
                >offline_bolt</md-icon>
                <div style="padding-left: 16px; border-left: 1px solid #e3e3e3">
                    <md-icon
                        v-if="canPostAnnouncement"
                        @click.native="openAnnouncementModal()"
                        class="footer-icon"
                        style="color: #e65100"
                        title="Tạo thông báo"
                    >campaign</md-icon>
                </div>
                <input ref="imageUpload" @change="onChangeUpload($event, 'image')" type="file" id="image" multiple
                       accept="image/*" hidden>
                <input ref="fileUpload" @change="onChangeUpload($event, 'file')" type="file" id="file" multiple
                       hidden>
                <input ref="videoUpload" @change="onChangeUpload($event, 'video')" type="file" id="video" multiple
                       accept="video/*" hidden>
              </div>
              <div
                class="chat-footer__toolbar-type message-type-picker"
                v-click-outside="closeMessageTypePicker"
              >
                <span class="sr-only">Dạng tin nhắn</span>
                <button
                  type="button"
                  class="chat-footer__message-type-trigger"
                  :class="[
                    composerMessageCategorySelectClass,
                    { 'message-type-picker__trigger--icon-only': !composerMessageCategory },
                  ]"
                  title="Dạng tin nhắn"
                  :aria-label="'Dạng tin nhắn: ' + composerMessageCategoryLabel"
                  aria-haspopup="listbox"
                  :aria-expanded="messageTypePickerOpen ? 'true' : 'false'"
                  @click="messageTypePickerOpen = !messageTypePickerOpen"
                >
                  <md-icon
                    class="message-type-picker__trigger-icon"
                  >{{ composerMessageCategoryMaterialIcon }}</md-icon>
                  <span
                    v-if="composerMessageCategory"
                    class="message-type-picker__trigger-label"
                  >{{ composerMessageCategoryLabel }}</span>
                  <md-icon class="message-type-picker__chevron">expand_more</md-icon>
                </button>
                <div
                  v-show="messageTypePickerOpen"
                  class="message-type-picker__panel"
                  role="listbox"
                >
                  <button
                    v-for="opt in messageTypePickerOptions"
                    :key="opt.value === '' ? '__normal' : opt.value"
                    type="button"
                    class="message-type-picker__option"
                    :class="{ 'is-active': composerMessageCategory === opt.value }"
                    role="option"
                    :aria-selected="composerMessageCategory === opt.value ? 'true' : 'false'"
                    @click="pickMessageType(opt.value)"
                  >
                    <md-icon
                      class="message-type-picker__option-icon"
                    >{{ opt.icon }}</md-icon>
                    <span class="message-type-picker__option-label">{{ opt.label }}</span>
                  </button>
                </div>
              </div>
            </div>

            <md-list-item class="chat-footer__composer-row">
                <md-field class="text-input" ref="resizeLayout">
                    <MentionChat
                      @open="onOpen"
                      @close="onClose"
                      @apply="onApply"
                      class="mentionable">
                      <md-textarea @input="resizeTextarea()" ref="textareaMessage" class="message" id="input-chat"
                                placeholder="Nhập tin nhắn..." v-model="form_input.message"
                                @click="hiddenDialogEmoji()"
                                @keydown="onKeydown($event)"
                                @keyup="onKeyup($event)"
                                @focusin="onFocus($event)"
                                @paste="onPaste($event)"
                                @blur="isFocusChat = false" ></md-textarea>
                    </MentionChat>
                </md-field>

              <Sticker class="sticker--footer-right" :colour="true" @send-sticker="sendSticker" />
              <img class="footer-icon img-emoji" src="/img/post/footer/smile.png" @click="toogleDialogEmoji">
              <img class="img-send" src="/img/chat/ic_like.svg" @click="likeEmoji" v-if="!typingMessage">
              <img class="img-send" @click="postMessage()" v-else :class="(form_input.message !== '' || files.length > 0) ?'active-send' : ''"
                   src="/img/chat/ic_send.svg">
            </md-list-item>
          </div>
        </div>
        <div class="chat-privacy" v-if="chatGroupSelected.chat_privacy == 'readonly' && chatGroupSelected.is_admin == 0">
            <div v-if="chatGroupSelected.type === 'BOT'">Tin nhắn từ BOT hệ thống không thể phản hồi</div>
            <div v-else>Chỉ có <span @click="getChatInfo('member', 2)"
              class="team-leader-chatgroup">Quản trị viên</span> mới gửi đc tin nhắn. Bạn có thể bày tỏ cảm xúc với tin nhắn
            </div>
            <!-- Bạn có thể bày tỏ cảm xúc với tin nhắn nhưng chỉ quản trị viên mới có thể gửi tin nhắn -->
          </div>
        <div ref="scrollBottomAnchor" class="scroll-bottom-anchor" v-show="!stickToBottomOnOpen && !hasScrolledToBottom">
          <button
            v-if="pendingNewMessageCount > 0"
            type="button"
            class="scroll-new-messages-pill"
            @click="scrollToBottom"
          >
            Có tin nhắn mới<span v-if="pendingNewMessageCount > 1"> ({{ pendingNewMessageCount }})</span>
          </button>
          <div ref="scrollBottom" class="scroll-to-new-messager cursor-pointer" @click="scrollToBottom">
            <md-icon>arrow_downward</md-icon>
          </div>
        </div>
      </div>
    </div>
    <!-- Panel phải: không nằm trong .container-message (tránh 2 cột phải). Mount sang #messenger-right-column. -->
    <div ref="sidebarMountHost" class="messenger-sidebar-host">
      <div ref="sidebarInfomationPanel" class="sidebar-infomation messenger-sidebar-panel" :class="infomationChat ? 'collapse-show' : 'collapse-none'">
        <div class="sidebar-infomation-scroll">
          <div class="sidebar-detail sidebar-detail--base"
               :style="this.$store.state.chat.chatGroupSelected.type === 'USER' ? 'border: 0;' : ''">
            <Custom
              @update-name-group-chat="updateNameGroupChat"
              @open-library="getChatInfo('library')"
              @open-member="getChatInfo('member', 1)"
              @open-announcements-panel="getChatInfo('announcements')"
              @open-create-announcement="openAnnouncementModal"
            />
          </div>
        </div>
        <div
          v-if="showBotCreateAnnouncementActionInPanel"
          class="custom-bot-announcement-action custom-bot-announcement-action--panel-fixed"
        >
          <button
            type="button"
            class="custom-bot-announcement-action__btn"
            @click="openAnnouncementModal"
          >
            <md-icon class="custom-bot-announcement-action__icon">campaign</md-icon>
            <span>Tạo thông báo</span>
          </button>
        </div>
        <div
          v-if="infomationChat !== 'custom'"
          class="sidebar-secondary-overlay"
        >
          <div class="sidebar-secondary-header">
            <button
              type="button"
              class="sidebar-secondary-back"
              aria-label="Quay lại"
              @click="getChatInfo('custom')"
            >
              <md-icon>arrow_back</md-icon>
            </button>
            <div class="sidebar-secondary-title">{{ titleInfomation }}</div>
          </div>
          <div class="sidebar-secondary-body">
            <SearchChat
              v-if="infomationChat === 'search'"
              @scrollToMessageId="scrollToMessage($event)"
              :searchKeyword="searchKeyword"
            />
            <Library v-if="infomationChat == 'library'"/>
            <MemberGroup
              v-if="infomationChat === 'member'"
              :members-group="membersGroup"
              :active-tab="activeTabMember"
              :infoGroup="{group_id : form.group_id, members : membersGroup}"
            />
            <ChatAnnouncementsFeed
              v-if="infomationChat === 'announcements'"
              mode="group"
              :group-id="$route.params.messenger_id"
              :limit="200"
              :only-active="false"
              :show-group-name="false"
              :emit-only="true"
              empty-text="Chưa có thông báo trong nhóm"
              @select="onFullAnnouncementListSelect"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Drawer panel phải (viewport < 1320px): trượt từ phải, nổi trên cửa sổ -->
    <div
      class="messenger-right-drawer"
      :class="{ 'messenger-right-drawer--open': messengerRightDrawerOpen }"
      aria-hidden="true"
    >
      <div
        class="messenger-right-drawer__backdrop"
        @click="closeRightDrawer"
      ></div>
      <div
        ref="sidebarDrawerMount"
        class="messenger-right-drawer__panel"
        role="dialog"
        aria-modal="true"
        aria-label="Thông tin hội thoại"
      ></div>
    </div>
    <div
      v-if="userInfoPopover.active && userInfoPopover.user"
      class="header-popover-message user-popover messenger-user-info-popover"
      :class="'messenger-user-info-popover--' + userInfoPopover.placement"
      :style="userInfoPopoverStyle"
      role="tooltip"
      @mouseenter="onUserInfoPopoverEnter"
      @mouseleave="onMouseleaveUserInfo"
    >
      <user-info :user-post="userInfoPopover.user" />
    </div>
    <share-message-modal @share-message="shareMessageToUser"></share-message-modal>
    <create-poll-chat-modal @create-poll="createPollMessage"></create-poll-chat-modal>
    <poll-vote-modal></poll-vote-modal>
    <poll-vote-detail-modal></poll-vote-detail-modal>
    <confirm-file-modal @postMulti="postMulti"></confirm-file-modal>
    <report-modal @send_message="postMessageReport"></report-modal>
    <sticker-manage-modal></sticker-manage-modal>
    <modal
      name="announcement-compose-modal"
      :click-to-close="true"
      width="560px"
      height="auto"
      class="modal-custom announcement-compose-modal"
    >
      <form class="announcement-compose-modal__form" @submit.prevent="submitAnnouncementFromModal">
        <md-card class="modal-header-custom">
          <md-dialog-title>
            <span class="neutral_1 heading-500 text-header-modal">{{ announcementForm.isEdit ? 'Sửa thông báo' : 'Tạo thông báo' }}</span>
            <span class="material-icons float-right cursor-pointer" @click.prevent="closeAnnouncementModal">close</span>
          </md-dialog-title>
        </md-card>
        <md-card-content class="p-15px">
          <div class="md-gutter">
            <label class="heading-400 neutral_3 required">Tiêu đề</label>
            <input
              v-model="announcementForm.title"
              type="text"
              class="form-control input-custom w_100"
              maxlength="512"
              placeholder="Tiêu đề"
              autocomplete="off"
            >
            <div class="announcement-compose-modal__char-count text-300-default neutral_3 text-right mt-4px">
              {{ (announcementForm.title || '').length }} / 512
            </div>
          </div>
          <div class="md-gutter pt-15px">
            <label class="heading-400 neutral_3">Thời gian hết hạn (tuỳ chọn)</label>
            <input
              v-model="announcementForm.expiresAtLocal"
              type="datetime-local"
              class="form-control input-custom w_100"
            >
          </div>
          <div class="md-gutter pt-15px announcement-compose-modal__payload-block">
            <label class="heading-400 neutral_3">Các trường bổ sung</label>
            <p class="announcement-compose-modal__hint text-300-default neutral_3">
              Thêm từng cặp <strong>tên trường</strong> và <strong>giá trị</strong> (hiển thị trên thẻ thông báo). Nội dung chính ghi ở «Tin nhắn» bên dưới.
            </p>
            <div
              v-for="row in announcementForm.payloadFields"
              :key="row.id"
              class="announcement-compose-modal__payload-row"
            >
              <div class="announcement-compose-modal__kv-field">
                <input v-model="row.key" type="text" class="form-control input-custom w_100" placeholder="VD: Địa điểm">
              </div>
              <div class="announcement-compose-modal__kv-field">
                <input v-model="row.value" type="text" class="form-control input-custom w_100" placeholder="VD: Vị trí">
              </div>
              <button
                type="button"
                class="announcement-compose-modal__row-remove md-button-clean"
                title="Xóa dòng"
                aria-label="Xóa dòng"
                @click="removeAnnouncementPayloadRow(row.id)"
              >
                <md-icon>close</md-icon>
              </button>
            </div>
            <button type="button" class="md-button text-400-default announcement-compose-modal__add-field" @click="addAnnouncementPayloadRow">
              Thêm trường
            </button>
          </div>
          <div class="md-gutter pt-15px">
            <label class="heading-400 neutral_3 required">Tin nhắn</label>
            <textarea
              v-model="announcementForm.messageText"
              class="form-control input-custom w_100 announcement-compose-modal__textarea"
              rows="4"
              placeholder="Nội dung tin nhắn"
            />
          </div>
          <div class="md-gutter pt-15px">
            <label class="heading-400 neutral_3">Đính kèm</label>
            <div class="announcement-compose-modal__attach-bar">
              <div class="messager-attach-toolbar-icons">
                <md-icon
                  class="footer-icon footer-icon-media"
                  style="color: #198eeb"
                  title="Gửi ảnh"
                  @click.native="openAnnouncementUpload('image')"
                >photo</md-icon>
                <md-icon
                  class="footer-icon footer-icon-media"
                  style="color: #7b1fa2"
                  title="Gửi video"
                  @click.native="openAnnouncementUpload('video')"
                >videocam</md-icon>
                <img
                  class="footer-icon upload-file"
                  src="/img/chat/attachment.svg"
                  alt=""
                  title="Đính kèm file"
                  @click="openAnnouncementUpload('file')"
                >
              </div>
              <input
                ref="announcementImageUpload"
                type="file"
                accept="image/*"
                multiple
                hidden
                @change="onAnnouncementChangeUpload($event, 'image')"
              >
              <input
                ref="announcementVideoUpload"
                type="file"
                accept="video/*"
                multiple
                hidden
                @change="onAnnouncementChangeUpload($event, 'video')"
              >
              <input
                ref="announcementFileUpload"
                type="file"
                multiple
                hidden
                @change="onAnnouncementChangeUpload($event, 'file')"
              >
            </div>
            <div
              v-if="announcementMedias.length > 0"
              class="announcement-compose-modal__file-strip border-top app-scroll"
            >
              <div class="file-upload__container">
                <div
                  v-for="(file, index) in announcementMedias"
                  :key="'ann-f-' + index + '-' + (file.file_id || file.name || '')"
                  class="upload-file-chat"
                  :class="file.type + '-upload-chat'"
                >
                  <vue-element-loading :active="file.loading === 'loading'" spinner="bar-fade-scale" />
                  <template v-if="file.type === 'video'">
                    <div class="photo-upload-item">
                      <div class="p-relative">
                        <video class="file-img" controls="false" style="margin: auto">
                          <source :src="file.path">
                        </video>
                        <div class="w_100 h_100 p-absolute" style="top: 0; left: 0"></div>
                      </div>
                      <div class="photo-delete__action" @click="removeAnnouncementFile(index)">
                        <md-icon>close</md-icon>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="file.type === 'image'">
                    <div class="photo-upload-item">
                      <img class="file-img" :src="file.path" alt="">
                      <div class="photo-delete__action" @click="removeAnnouncementFile(index)">
                        <md-icon>close</md-icon>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="file-upload-item mx-2">
                      <div class="item-container">
                        <div class="url-colection-thumb mr-5px">
                          <img src="/img/chat/Type-Other.svg" alt="thumb">
                        </div>
                        <div class="file-content">
                          <div class="heading-400 text-1-line wb-break-all">{{ file.name }}</div>
                          <div class="text-300-default neutral_2">
                            <span>{{ file.extension }} - {{ bytesToSize(file.file_size) }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="photo-delete__action" @click="removeAnnouncementFile(index)">
                        <md-icon>close</md-icon>
                      </div>
                    </div>
                  </template>
                  <template v-if="file.loading === 'error'">
                    <div class="error-upload">
                      <span>Lỗi</span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>
        <md-dialog-actions class="p-15px w_100">
          <button type="submit" class="btn-active md-button text-400-default">
            {{ announcementForm.isEdit ? 'Cập nhật' : 'Gửi thông báo' }}
          </button>
          <button type="button" class="btn-stroke md-button text-400-default" @click.prevent="closeAnnouncementModal">
            Huỷ
          </button>
        </md-dialog-actions>
      </form>
    </modal>
  </div>
</template>
<script>
  import {VEmojiPicker} from 'v-emoji-picker';
  import {GROUP_CHAT_TYPE, MESSAGE_CHAT_TYPE, TEXT_CHAT_SYSTEM} from "../../../../const/const";
  import ChatService from "../../../../store/services/ChatService";
  import PostService from "../../../../store/services/PostService";
  import Custom from "./Infomation/Custom"
  import Library from "./Infomation/Library"
  import MemberGroup from "./Infomation/MemberGroup"
  import ChatAnnouncementsFeed from "./Infomation/ChatAnnouncementsFeed.vue"
  import UserInfo from "../../../Components/PopoverInfo/UserInfo";
  import PinMessage from "./PinMessage";
  import moment from "moment";
  // import $ from "jquery";
  import {helpers} from "../../../../helper/helpers";
  import {libraryItemsFromImageVideoMessage} from "../../../../helper/chatGroupMediaSync";
  import {captureVideoThumbnailFromFile} from "../../../../helper/captureVideoThumbnail";
  import { validateChatUploadFile } from "../../../../helper/chatUploadLimits";
  import { prepareChatImageFileForUpload } from "../../../../helper/chatImagePrepare";
  import { prepareClipboardImagesForUpload } from "../../../../helper/chatClipboardPaste";
  import ImageTemplate from "../../../../components/ImageTemplate";
  import { chatSenderDisplayName } from "../../../../helper/chatSenderAvatar";
  import { isOfficialTeamGroup } from "../../../../helper/officialTeamGroup";
  import { canCreateBotAnnouncementInBotChat } from "../../../../helper/botChatOperator";
  import {
    redirectAfterChatGroupAccessLost,
    isChatGroupNotFoundResponse,
  } from "../../../../helper/chatAccessRedirect";
  import {
    installMessengerDebugGlobals,
    isMessengerDebugEnabled,
    messengerDebugLog,
    normalizeChatMessageListResponse,
  } from "../../../../helper/messengerDebug";
  import {
    isMessengerViewportNarrow,
    isMessengerRightPanelOpen,
    normalizeChatGroupSelectedForViewport,
    resolveMessengerRightBarVisible,
    MESSENGER_RIGHT_BAR_AUTO_HIDE_MAX_WIDTH,
  } from "../../../../helper/messengerViewport";
  import {
    appendChatMessageIfNew,
    mergeChatMessageLists,
    mergeOlderChatMessages,
    sortChatMessages,
    trimNewestMessages,
    trimAfterPrependOlder,
    CHAT_MESSAGE_LIST_MAX,
  } from "../../../../helper/chatMessageList";
  import {
    CHAT_SCROLL_TO_MESSAGE_MAX_FETCHES,
    getCacheEntry,
    getCacheMessages,
    shouldSoftSyncMessages,
    writeCacheEntry,
  } from "../../../../helper/chatMemory";
  import { isPollVoteActivityMessage } from "../../../../helper/pollVoteMessages";
  import {
    cloneMediaFilesForOptimisticMessage,
    revokeOptimisticMediaPreviewUrls,
  } from "../../../../helper/chatMediaDisplay";
  import { unwrapChatMessagePayload, isChatStickerMessage, normalizeChatMessageRow, normalizeChatMessageRows } from "../../../../helper/chatSystemNote";
  import {
    dedupeChatGroupsById,
    sortChatGroupsForSidebar,
  } from "../../../../helper/chatGroupStore";
  import ImageChatContent from "./Content/ImageChatContent";
  import StickerChatContent from "./Content/StickerChatContent";
  import FileChatContent from "./Content/FileChatContent";
  import VideoChatContent from "./Content/VideoChatContent";
  import ReplyChatContent from "./Content/ReplyChatContent";
  import ShareMessageContent from "./Content/ShareMessageContent";
  import PollMessageContent from "./Content/PollMessageContent";
  import PollVoteActivityMessage from "./Content/PollVoteActivityMessage";
  import TagChatContent from "./Content/TagChatContent";
  import MentionChat from "./Mention.vue"
  import ShareMessageModal from "../../../Components/Modal/ShareMessageModal"
  import SearchChat from "./Infomation/SearchChat"
  import CreatePollChatModal from '../../../Components/Modal/CreatePollChatModal';
  import PollVoteModal from '../../../Components/Modal/PollVoteModal';
  import PollVoteDetailModal from '../../../Components/Modal/PollVoteDetailModal';
  import ConfirmFileModal from '../../../Components/Modal/ConfirmFileModal';
  import ReportModal from '../../../Components/Modal/ReportModal';
  import Sticker from './Sticker.vue';
  import StickerManageModal from '../../../Components/Modal/StickerManageModal';
  import { ordersDetailUrl } from "@/config/agencyRuntime";

  export default {
  name: 'messenger',
  components: {
    VEmojiPicker,
    Custom,
    Library,
    MemberGroup,
    ChatAnnouncementsFeed,
    UserInfo,
    PinMessage,
    ImageChatContent,
    StickerChatContent,
    FileChatContent,
    VideoChatContent,
    ReplyChatContent,
    MentionChat,
    ShareMessageModal,
    ShareMessageContent,
    SearchChat,
    CreatePollChatModal,
    PollVoteModal,
    PollVoteDetailModal,
    PollMessageContent,
    PollVoteActivityMessage,
    ConfirmFileModal,
    ReportModal,
    TagChatContent,
    Sticker,
    StickerManageModal,
    ImageTemplate,
  },
  mounted() {
    // this.getMembersGroup();
    $(document).ready(function () {
      $("#input-chat").focus();
    });
    this.stickToBottomOnOpen = true;
    this.hasScrolledToBottom = false;
    let chatGroupSelected = this.$store.state.chat.chatGroupSelected;
    this.isAdmin = chatGroupSelected.is_admin === 1;
    this.rightBarVisible = resolveMessengerRightBarVisible(chatGroupSelected);
    if (isMessengerViewportNarrow()) {
      this.rightBarCollapsedByViewport = true;
    }

    this.onlineStatusInterval = setInterval(() => {
      this.isOnLine = window.navigator.onLine;
    }, 1000);
    this.syncRouteGroupContext();
    this.$nextTick(() => {
      this.scheduleMountSidebarPanel();
      this.resizeTextarea();
      this.setupMessengerViewportLayoutWatchers();
      this.messengerDebugLayoutSnapshot('lifecycle.mounted');
    });
    document.addEventListener('visibilitychange', this.onDocumentVisibilityForPeerRead);
    this.announcementCountdownTimer = setInterval(() => {
      this.announcementCountdownTick += 1;
    }, 1000);
  },
  created() {
    installMessengerDebugGlobals();
    import("@/helper/chatGroupStore").then(({ coerceMessageCacheMap }) => {
      this.cacheChatMessages = coerceMessageCacheMap(this.$store.state.chat.cacheChatMessages);
      this.$store.commit("chat/updateCacheChatMessages", this.cacheChatMessages);
    });
    this.$root.$on("messenger:reload-conversation", this.onReloadConversation);
    if (isMessengerDebugEnabled()) {
      messengerDebugLog('lifecycle.created', {
        route: this.$route.fullPath,
        messenger_id: this.$route.params.messenger_id,
        selectedId: this.$store.state.chat.chatGroupSelected?.id,
        chatGroupsLen: (this.$store.state.chat.chatGroups || []).length,
      });
    }
    this.params.is_cache = true;
  },
  destroyed() {
    this.$root.$off("messenger:reload-conversation", this.onReloadConversation);
    this.discardPendingComposerUploads();
    document.removeEventListener('visibilitychange', this.onDocumentVisibilityForPeerRead);
    if (this.onlineStatusInterval) {
      clearInterval(this.onlineStatusInterval);
      this.onlineStatusInterval = null;
    }
    if (this.announcementCountdownTimer) {
      clearInterval(this.announcementCountdownTimer);
      this.announcementCountdownTimer = null;
    }
    if (this.peerReadFetchTimer) {
      clearTimeout(this.peerReadFetchTimer);
      this.peerReadFetchTimer = null;
    }
    if (this.messageListLoadSafetyTimer) {
      clearTimeout(this.messageListLoadSafetyTimer);
      this.messageListLoadSafetyTimer = null;
    }
    this.cancelHideMessageActions();
    if (this.reconnectMessageListTimer) {
      clearTimeout(this.reconnectMessageListTimer);
      this.reconnectMessageListTimer = null;
    }
    this.detachStickToBottomObserver();
    this.messageListInflight = null;
    if (this.typingIndicatorHideTimer) {
      clearTimeout(this.typingIndicatorHideTimer);
      this.typingIndicatorHideTimer = null;
    }
    if (this.resizeTextareaRafId != null) {
      cancelAnimationFrame(this.resizeTextareaRafId);
      this.resizeTextareaRafId = null;
    }
    if (this.footerLayoutDebounceTimer != null) {
      clearTimeout(this.footerLayoutDebounceTimer);
      this.footerLayoutDebounceTimer = null;
    }
    this.teardownMessengerViewportLayoutWatchers();
    this.clearSidebarMountRetry();
    this.unmountSidebarInfomationPanel();
    this.syncMessengerRightDrawerBodyLock(false);
    this.clearUserInfoPopoverTimers();
    this.hideUserInfoPopover();
  },
  watch: {
    '$route.params.messenger_id': {
      immediate: true,
      async handler(to, from) {
      if (this.$route.name !== 'messenger' || !to) {
        return;
      }
      if (from != null && String(to) === String(from)) {
        return;
      }
      const groupId = String(to);
      messengerDebugLog('route.messenger_id', { to, from, fullPath: this.$route.fullPath });
      this.conversationOpenScrollToken += 1;
      const openScrollToken = this.conversationOpenScrollToken;
      this.messageListInflight = null;
      this.messageListFetchStatus = { groupId, rowCount: 0, done: false };
      this.loadingGetDataMessageList = false;
      this.pendingNewMessageCount = 0;
      this.stickToBottomOnOpen = true;
      this.hasScrolledToBottom = false;
      this.peerReadMessageId = null;
      this.showUserReply = false;
      this.dataUserTyping = [];
      this.dataUserTypingRealCount = 0;
      if (this.typingIndicatorHideTimer) {
        clearTimeout(this.typingIndicatorHideTimer);
        this.typingIndicatorHideTimer = null;
      }
      this.resetMessageListParams();
      this.params.group_id = groupId;
      this.form.group_id = groupId;
      this.params.is_cache = true;

      const cachedMessages = getCacheMessages(this.cacheChatMessages, groupId);
      const cacheEntry = getCacheEntry(this.cacheChatMessages, groupId);
      if (cachedMessages.length) {
        this.messageList = trimNewestMessages(sortChatMessages(cachedMessages), CHAT_MESSAGE_LIST_MAX);
        this.hasMoreOlderMessages = !cacheEntry || cacheEntry.hasMoreOlder !== false;
        this.loadingGetDataMessageList = true;
        this.beginStickToBottomOnOpen(openScrollToken);
      } else {
        this.messageList = [];
        this.$nextTick(() => {
          const chatEl = this.getChatContentEl();
          if (chatEl) {
            chatEl.scrollTop = 0;
          }
        });
      }

      try {
        const { syncMessengerRouteGroup } = await import("@/helper/chatGroupStore");
        await syncMessengerRouteGroup(this.$store, groupId);
      } catch (e) {
        void e;
      }
      if (String(this.$route.params.messenger_id) !== groupId) {
        return;
      }

      this.chatGroupSelected = { ...this.$store.state.chat.chatGroupSelected };
      this.isAdmin = this.chatGroupSelected.is_admin === 1;
      this.rightBarVisible = resolveMessengerRightBarVisible(this.chatGroupSelected);
      if (isMessengerViewportNarrow()) {
        this.rightBarCollapsedByViewport = true;
      }
      this.getConvensationExist();
      this.scheduleMessageListLoad(this.params, { force: true, forceSync: true });
      this.infomationChat = 'custom';
      this.lastMessengerShellWasNarrow = isMessengerViewportNarrow();
      this.$nextTick(() => {
        this.scheduleMountSidebarPanel();
        this.applyMessengerViewportRightBar();
        this.messengerDebugLayoutSnapshot('route.messenger_id.nextTick');
      });
      this.$nextTick(() => {
        if (this.$refs.pinMessage && typeof this.$refs.pinMessage.getPinMessage === 'function') {
          this.$refs.pinMessage.getPinMessage();
        }
      });
      $(document).ready(function () {
        $("#input-chat").focus();
      });
      this.$nextTick(() => {
        this.chatGroupSelected = this.$store.state.chat.chatGroupSelected;
        if (typeof this.chatGroupSelected.isCreateChat !== 'undefined' && this.chatGroupSelected.isCreateChat) {
          this.chatGroupSelected.isCreateChat = false;
        }
        this.discardPendingComposerUploads();
        this.resetChatContent();
        this.applyComposeDraftIfAny();
      });
      this.form_input.message = '';
      this.hasNextOnPage = false;
      },
    },
    loadingGetDataMessageList(newV) {
      if (newV && this.params.page == 1 && this.stickToBottomOnOpen) {
        this.beginStickToBottomOnOpen();
      }
    },
    '$store.state.chat.dataSocket'(newV) {
      const message = normalizeChatMessageRow(unwrapChatMessagePayload(newV));
      if (!message || String(this.$route.params.messenger_id) !== String(message.group_id)) {
        return;
      }
      const prevList = this.messageList;
      this.messageList = appendChatMessageIfNew(this.messageList, message);
      const wasAppended = this.messageList !== prevList;
      if (this.messageList.length > CHAT_MESSAGE_LIST_MAX) {
        this.messageList = trimNewestMessages(this.messageList, CHAT_MESSAGE_LIST_MAX);
      }
      if (wasAppended) {
        this.afterIncomingMessageAppended(message);
      }
      this.updateLastMessageToGroupChat(message);
      this.emitChatGroupMediaAppended(message);
      this.showUserReply = false;
      this.dataUserTyping = [];
      this.dataUserTypingRealCount = 0;
      if (this.$store.state.chat.chatGroupSelected.type === GROUP_CHAT_TYPE.USER
          && message.sender && message.sender.id !== this.user.id) {
        this.schedulePeerReadWatermarkRefresh();
      }
    },
    '$store.state.chat.readReceiptSocket'(newV) {
      if (!newV || newV.type !== 'chat_read_receipt') {
        return;
      }
      const gid = String(newV.group_id);
      if (gid !== String(this.$route.params.messenger_id)) {
        return;
      }
      if (this.chatGroupSelected.type !== GROUP_CHAT_TYPE.USER) {
        return;
      }
      if (Number(newV.reader_user_id) !== Number(this.chatGroupSelected.user_id)) {
        return;
      }
      const v = Number(newV.read_up_to_message_id);
      if (!Number.isFinite(v)) {
        return;
      }
      const cur = this.peerReadMessageId;
      this.peerReadMessageId = cur == null || !Number.isFinite(Number(cur)) ? v : Math.max(Number(cur), v);
    },
    '$store.state.chat.dataReactionEmoji'(newV) {
      if (this.$route.params.messenger_id == newV.chat_group_id && this.user.id !== newV.user_reacted.id) {
        this.messageList.map((mess, index) => {
          if (mess.id === newV.chat_message_id) {
            mess.reaction_stats = newV.reaction_stats;
            mess.like_count = newV.like_count;
          }
        });
        // this.updateLastMessageToGroupChat(newV);
      }
    },
    'messageList'(newV) {
      setTimeout(() => {
        const objDiv = document.getElementById("chat-content");
        if (!objDiv) {
          return;
        }

        if (this.onScrollMessageId !== null) {
          const onScrollDiv = document.getElementById("message-" + this.onScrollMessageId);
          if (!onScrollDiv) {
            this.onScrollMessageId = null;
            return;
          }

          if (this.scrollAnimaiton) {
            onScrollDiv.scrollIntoView({ behavior: 'smooth' });
            onScrollDiv.classList.add('shake');
            setTimeout(() => {
              onScrollDiv.classList.remove('shake');
              this.scrollAnimaiton = false;
            }, 1000);
          }

          objDiv.scrollTop = onScrollDiv.offsetTop - 300;
          this.onScrollMessageId = null;
        }
      });
    },
    '$store.state.chat.chatGroupSelected.right_bar_visible'(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      this.rightBarVisible = resolveMessengerRightBarVisible(this.$store.state.chat.chatGroupSelected);
      if (newVal !== false) {
        if (!isMessengerViewportNarrow()) {
          this.rightBarCollapsedByViewport = false;
        }
        this.$nextTick(() => {
          this.scheduleMountSidebarPanel();
          if (!this.infomationChat) {
            this.getChatInfo('custom');
          }
        });
      } else {
        this.$nextTick(() => this.scheduleMountSidebarPanel());
      }
      this.syncMessengerRightDrawerBodyLock();
    },
    messengerRightDrawerOpen(isOpen) {
      this.syncMessengerRightDrawerBodyLock(isOpen);
      this.$nextTick(() => this.scheduleMountSidebarPanel());
    },
    '$store.state.chat.chatGroupSelected'(newV) {
      this.chatGroupSelected = newV
      this.getConvensationExist();

      this.rightBarVisible = resolveMessengerRightBarVisible(newV);

      if (newV.open_right_menu === 'toggle_rightbar') {
        const nextVisible = newV.right_bar_visible === false;
        if (!isMessengerViewportNarrow()) {
          this.rightBarCollapsedByViewport = false;
        }
        this.rightBarVisible = nextVisible;
        const item = { ...newV, right_bar_visible: nextVisible };
        delete item.open_right_menu;
        this.$store.commit("chat/updateChatGroupSelected", item);
        this.$nextTick(() => {
          if (nextVisible) {
            this.scheduleMountSidebarPanel();
            if (!this.infomationChat) {
              this.getChatInfo('custom');
            }
          } else {
            this.scheduleMountSidebarPanel();
          }
        });
        return;
      }

      if (newV.open_right_menu) {
        if (isMessengerViewportNarrow()) {
          const item = { ...newV, right_bar_visible: true };
          delete item.open_right_menu;
          this.$store.commit("chat/updateChatGroupSelected", item);
        } else if (!this.rightBarVisible) {
          this.rightBarVisible = true;
          this.rightBarCollapsedByViewport = false;
          const item = { ...newV, right_bar_visible: true };
          delete item.open_right_menu;
          this.$store.commit("chat/updateChatGroupSelected", item);
        }
        const memberTab = newV.open_member_tab != null ? newV.open_member_tab : undefined;
        this.getChatInfo(newV.open_right_menu, memberTab);
      } else if (this.infomationChat === 'member') {
        this.getChatInfo(this.infomationChat);
      }

      this.isAdmin = newV.is_admin === 1;
    },
    'form_input.message'(newV, oldV) {
      // if (this.mentions.length > 0) {
      //   this.highlightTextarea();
      //   $('#input-chat').focus();
      // }
      this.typingMessage = newV !== '' ? true : false;
    },
    'medias.length'(newV, oldV) {
      this.setHeightChatContent();
    },
    '$store.state.chat.modifyMessageSocket'(newV) {
      const payload = newV.modifyData || newV;
      const evType = payload.type || newV.type;
      const data = payload.data || newV.data;

      const joinRequestEvents = [
        'join_request_created',
        'join_request_resolved',
        'join_request_approved',
        'join_request_rejected',
      ];
      if (joinRequestEvents.includes(evType)) {
        return;
      }

      if (!data || !data.group_id) return;
      if (this.$route.params.messenger_id != data.group_id) return;

      if (evType === 'update_message') {
          this.messageList.map((mess, index) => {
            if (mess.id == data.id) {
              mess.history_message = data.history_message;
              mess.text = data.text;
              if (Object.prototype.hasOwnProperty.call(data, 'announcement')) {
                mess.announcement = data.announcement;
              }
            }
          });
        } else if (evType === 'poll_voted' || evType === 'poll_option_added') {
          this.messageList.forEach((mess) => {
            if (mess.id == data.id && data.poll) {
              this.$set(mess, 'poll', data.poll);
            }
          });
        } else if (evType === 'message_bulk_deleted') {
          // Auto-delete đã chạy ở BE: lọc bỏ mọi message cũ hơn cutoff khỏi danh sách hiện tại.
          const cutoffMs = data.cutoff_at ? new Date(data.cutoff_at).getTime() : 0;
          if (cutoffMs > 0) {
            this.messageList = this.messageList.filter((m) => {
              const ts = m && m.created_at ? new Date(m.created_at).getTime() : Number.POSITIVE_INFINITY;
              return ts >= cutoffMs;
            });
            try { this.$refs.pinMessage && this.$refs.pinMessage.getPinMessage && this.$refs.pinMessage.getPinMessage(); } catch (e) { /* noop */ }
          }
        } else if (evType === 'message_retention_updated') {
          // Chỉ refresh metadata; danh sách tin nhắn không đổi cho tới khi job purge chạy.
          const selected = this.$store.state.chat.chatGroupSelected || {};
          if (selected && selected.settings && String(selected.id) === String(data.group_id)) {
            this.$set(selected.settings, 'message_retention_days', Number(data.message_retention_days));
          }
        } else if (evType === 'group_emptied_removed') {
          // Group bị xóa do rỗng sau purge — clear danh sách hiện tại, main.ts đã đảm nhiệm redirect.
          this.messageList = [];
        } else if(evType !== 'set_role_admin') {
          const prevList = this.messageList;
          this.messageList = appendChatMessageIfNew(this.messageList, normalizeChatMessageRow(data));
          const wasAppended = this.messageList !== prevList;
          if (this.messageList.length > CHAT_MESSAGE_LIST_MAX) {
            this.messageList = trimNewestMessages(this.messageList, CHAT_MESSAGE_LIST_MAX);
          }
          if (wasAppended) {
            this.afterIncomingMessageAppended(data);
          }
          const pinCur = newV.current_message || payload.current_message;
          if (pinCur && (data.text === TEXT_CHAT_SYSTEM.PIN_MESSAGE || data.text === TEXT_CHAT_SYSTEM.UNPIN_MESSAGE)) {
            this.messageList.map((mess, index) => {
              if (mess.id === pinCur.id) {
                mess.pinned_at = pinCur.pinned_at;
                this.$refs.pinMessage.getPinMessage();
              }
            });
          }
          this.updateLastMessageToGroupChat(data);
          this.emitChatGroupMediaAppended(data);
        }
    },
    '$store.state.chat.chatGroupSelected.scroll_to_message_id'(newV){
      setTimeout(() => {
        if(newV){
          this.scrollToMessage(newV);
          this.$store.state.chat.chatGroupSelected.scroll_to_message_id = null;
        }
      }, 300);
    },
    '$store.state.chat.reconnectSocket'(){
      if (this.$route.name !== 'messenger') return;
      if (this.reconnectMessageListTimer) {
        clearTimeout(this.reconnectMessageListTimer);
      }
      this.reconnectMessageListTimer = setTimeout(() => {
        this.reconnectMessageListTimer = null;
        if (this.$route.name !== 'messenger') return;
        this.messageListInflight = null;
        this.scheduleMessageListLoad(this.params, { force: true, forceSync: true });
      }, 600);
    },
    isOnLine(newVal, oldVal) {
      if(newVal !== oldVal && newVal === true){
        if(this.router_name === 'messenger'){
          const gid = String(this.$route.params.messenger_id || '');
          if (gid && !/^new\d+$/i.test(gid)) {
            this.messageListFetchStatus = { groupId: gid, rowCount: 0, done: false };
          }
          this.resetMessageListParams();
          this.params.is_cache = true;
          this.getConvensationExist();
          this.scheduleMessageListLoad(this.params, { force: true, forceSync: true });
          if (this.$refs.pinMessage && typeof this.$refs.pinMessage.getPinMessage === 'function') {
            this.$refs.pinMessage.getPinMessage();
          }
          $(document).ready(function () {
            $("#input-chat").focus();
          });
          setTimeout(() => {
            this.chatGroupSelected = this.$store.state.chat.chatGroupSelected;
            if(typeof this.chatGroupSelected.isCreateChat !== 'undefined' && this.chatGroupSelected.isCreateChat){
              this.chatGroupSelected.isCreateChat = false;
            }
            this.resetChatContent();
          });
          this.form_input.message = '';
          this.hasNextOnPage = false;
        }
      }
    },
    '$store.state.chat.dataUserTyping'(newV) {
      const openId = String(this.$route.params.messenger_id || '');
      if (!openId || !newV || String(newV.chat_group?.id) !== openId) {
        return;
      }
      this.showUserReply = true;
      this.dataUserTyping.push(newV);
      const unique = [...new Map(this.dataUserTyping.map((m) => [m.user_typing.id, m])).values()];
      this.dataUserTyping = unique;
      this.dataUserTypingRealCount = unique.length;
      if (this.typingIndicatorHideTimer) {
        clearTimeout(this.typingIndicatorHideTimer);
      }
      this.typingIndicatorHideTimer = setTimeout(() => {
        this.showUserReply = false;
        this.dataUserTyping = [];
        this.dataUserTypingRealCount = 0;
        this.typingIndicatorHideTimer = null;
      }, 5000);
    },
    '$store.state.chat.dataUserRecall'(newV) {
      if (!newV || newV.group_id == null) return;
      const recallStatus = Number(newV.delete_status);
      if (String(newV.group_id) === String(this.$route.params.messenger_id)) {
        this.messageList.forEach((mess) => {
          if (mess.id === newV.chat_message_id) {
            this.$set(mess, 'delete_status', recallStatus);
          }
        });
      }
      let chatGroups = this.$store.state.chat.chatGroups;
      chatGroups.forEach((item) => {
        if (String(item.id) === String(newV.group_id) && item.last_message) {
          this.$set(item.last_message, 'delete_status', recallStatus);
        }
      });
      this.$store.commit('chat/updateChatGroups', chatGroups);
    },
  },
  data() {
    return {
      infomationChat: 'custom',
      titleInfomation: 'Tùy chỉnh',
      showDialogEmoji: false,
      chatGroupSelected: this.$store.state.chat.chatGroupSelected,
      form: {
        group_id: this.$route.params.messenger_id,
        message: '',
        type: MESSAGE_CHAT_TYPE.TEXT,
        file_ids: [],
        fcm_token: localStorage.getItem("cmf_token"),
        mentions: [],
        reply_to_msg_id: null,
        message_id: null, //id edit message,
        category: null,
        tag_list: null
      },
      form_input: {
        message: '',
        file_ids: [],
        like_emoji: {
          status: false,
          icon: '👍' // chat like fast
        },
        uploading: false,
        isEdit: false,
        files: []
      },
      createChat: {
        status: '',
        messageErrors: []
      },
      params: {
        page: 1,
        per_page: 40,
        group_id: this.$route.params.messenger_id,
        is_cache: false
      },
      messageList: [],
      expandedPollVoteGroups: {},
      user: this.$store.state.auth.user,
      MESSAGE_CHAT_TYPE,
      TEXT_CHAT_SYSTEM,
      loadingFile: false,
      files: [],
      medias: [],
      fileUploadData: [],
      loadingGetDataMessageList: false,
      typeUpload: 'image',
      activeTypeUpload: '',
      membersGroup: [],
      customGroup: [],
      convensationExisted: true,
      dropDown: {
        more: false,
        emoji: false
      },
      hideMessageActionsTimer: null,
      messageLastPage: 1,
      /** Còn tin cũ hơn để load-more (cursor last_message_id). */
      hasMoreOlderMessages: true,
      onScrollMessageId: null,
      loadingOnScroll: false,
      mentions: [],
      allTextMentions: ['@All'],
      GROUP_CHAT_TYPE,
      replyMessager: {
        active: false,
        message: []
      },
      userInfoPopover: {
        active: false,
        message_id: null,
        user: null,
        placement: 'top',
      },
      userInfoPopoverStyle: {
        top: '0px',
        left: '0px',
      },
      hasScrolledToBottom: false,
      /** Đang settle scroll về đáy khi mở/chuyển cuộc chat — nút ↓ ẩn trong lúc này. */
      stickToBottomOnOpen: false,
      pendingNewMessageCount: 0,
      conversationOpenScrollToken: 0,
      stickToBottomRo: null,
      stickToBottomRoToken: null,
      scrollAnimaiton: false,
      typingMessage: false,
      isFocusChat: false,
      suppressReadOnComposerFocus: false,
      items: [],
      activeMention: false,
      timer: null,
      loadingMention: false,
      cacheChatMessages: {},
      isOnLine: window.navigator.onLine,
      router_name: this.$route.name,
      shareMessages: [],
      isAdmin: false,
      selectionStart: 0,
      tag_settings: this.$store.state.auth.dictionaryTagSetting.value,
      isFastMessage: false,
      activeTabMember: 1,
      searchKeyword: '',
      showUserReply: false,
      isCallUserTyping: true,
      dataUserTyping : [],
      dataUserTypingRealCount : 0,
      typingIndicatorHideTimer: null,
      /**
       * Chrome dọc quanh textarea trong md-field (viền/padding vue-material).
       * Chiều cao ô nhập = scrollHeight(#input-chat) + giá trị này → một dòng ~36+12 = 48px (trước đây +20 = 56px).
       */
      chatComposerFieldChromePx: 12,
      /** Min chiều cao vùng textarea / .mentionable (một dòng). */
      chatComposerTextareaMinPx: 36,
      footerLayoutDebounceTimer: null,
      dataSplitFile: {
        dataSplit: null,
        dataOrigin: null
      },
      /** Rỗng = tin thường (category null); cùng enum với đổi loại tin sau khi gửi. */
      composerMessageCategory: '',
      messageTypePickerOpen: false,
      menuOther: null,
      sidebarInfomationPlaceholder: null,
      sidebarMountRetryTimer: null,
      /** Tăng mỗi lần fetch page 1 — bỏ qua response API của group/route cũ. */
      messageListRequestSeq: 0,
      /** Gộp request trùng group_id đang in-flight (tránh race reconnect / route). */
      messageListInflight: null,
      messageListFetchStatus: { groupId: null, rowCount: 0, done: false },
      messageListLoadSafetyTimer: null,
      reconnectMessageListTimer: null,
      rightBarVisible: true,
      messengerViewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1920,
      /** `window.innerWidth` dưới ngưỡng này → ẩn panel phải (dùng innerWidth vì kéo cửa sổ luôn đổi; ResizeObserver trên shell dễ không bắn). */
      messengerRightBarAutoHideMaxWidth: MESSENGER_RIGHT_BAR_AUTO_HIDE_MAX_WIDTH,
      messengerWindowResizeHandler: null,
      messengerShellLayoutRetryTimer: null,
      /** Trạng thái hẹp/rộng lần trước (null = chưa đo). */
      lastMessengerShellWasNarrow: null,
      /** Panel vừa bị ẩn do hẹp màn hình — khi rộng lại sẽ mở lại (trừ khi user đã can thiệp toggle). */
      rightBarCollapsedByViewport: false,
      messengerShellResizeObserver: null,
      messengerShellResizeDebounceTimer: null,
      /** Chat USER: message_id cuối mà đối phương đã đọc (từ API get messages). */
      peerReadMessageId: null,
      peerReadFetchTimer: null,
      announcementForm: {
        isEdit: false,
        messageId: null,
        title: '',
        messageText: '',
        expiresAtLocal: '',
        /** Mỗi phần tử: { id, key, value } → gói thành payload.data */
        payloadFields: [],
      },
      /** Đính kèm trong modal Tạo/Sửa thông báo (tách khỏi composer). */
      announcementMedias: [],
      announcementFileIds: [],
      announcementUploading: false,
      announcementActiveTypeUpload: '',
      announcementCountdownTick: 0,
      announcementCountdownTimer: null,
      onlineStatusInterval: null,
    }
  },
  computed: {
    messengerRightDrawerOpen() {
      if (this.$route.name !== 'messenger') return false;
      if (!isMessengerViewportNarrow(this.messengerViewportWidth)) return false;
      return isMessengerRightPanelOpen(this.$store.state.chat.chatGroupSelected);
    },
    showBotCreateAnnouncementActionInPanel() {
      const userId = this.$store.state.auth && this.$store.state.auth.user
        ? this.$store.state.auth.user.id
        : null;
      return canCreateBotAnnouncementInBotChat(
        this.$store.state.chat.chatGroupSelected,
        userId,
      );
    },
    canPostAnnouncement() {
      const g = this.chatGroupSelected || this.$store.state.chat.chatGroupSelected || {};
      if (g.type === GROUP_CHAT_TYPE.BOT) {
        return false;
      }
      if (g.type === GROUP_CHAT_TYPE.USER) return false;
      if (g.chat_privacy === 'readonly' && g.is_admin !== 1) return false;
      const pol = g.settings && g.settings.announcement_policy;
      if (pol === 2) return true;
      return g.is_admin === 1;
    },
    /** Màu/viền giống badge loại tin trong `TagChatContent.vue` (.active-normal / report / …). */
    composerMessageCategorySelectClass() {
      const c = this.composerMessageCategory;
      if (!c) return 'message-type-pill--normal';
      const map = {
        DEFAULT: 'message-type-pill--default',
        REPORT: 'message-type-pill--report',
        REWARD: 'message-type-pill--reward',
        DISCIPLINE: 'message-type-pill--discipline',
      };
      return map[c] || 'message-type-pill--normal';
    },
    messageTypePickerOptions() {
      return [
        { value: '', label: 'Tin nhắn thường', icon: 'chat_bubble_outline' },
        { value: 'DEFAULT', label: 'KỶ LỤC MỚI', icon: 'emoji_events' },
        { value: 'REPORT', label: 'BÁO CÁO', icon: 'assignment' },
        { value: 'REWARD', label: 'KHEN THƯỞNG', icon: 'card_giftcard' },
        { value: 'DISCIPLINE', label: 'KỶ LUẬT', icon: 'gavel' },
      ];
    },
    composerMessageCategoryLabel() {
      const o = this.messageTypePickerOptions.find((x) => x.value === this.composerMessageCategory);
      return (o && o.label) || 'Tin nhắn thường';
    },
    composerMessageCategoryMaterialIcon() {
      const o = this.messageTypePickerOptions.find((x) => x.value === this.composerMessageCategory);
      return (o && o.icon) ? o.icon : 'chat_bubble_outline';
    },
    hasNextPageForMessage: function () {
      return this.hasMoreOlderMessages;
    },
    /** Typing chỉ hiện khi payload khớp đúng group đang mở theo URL (tránh lệch chatGroupSelected). */
    typingUiMatchesOpenConversation() {
      const openId = String(this.$route.params.messenger_id || '');
      if (!openId || !this.dataUserTyping.length) {
        return false;
      }
      return String(this.dataUserTyping[0].chat_group?.id) === openId;
    },
    showOfficialTeamVerifiedChat() {
      const g = this.chatGroupSelected || this.$store.state.chat.chatGroupSelected || {};
      return g.type === 'GROUP' && isOfficialTeamGroup(g);
    },
    showChatWelcomeEmpty() {
      // loadingGetDataMessageList === true nghĩa là đã tải xong (overlay tắt), không phải đang loading.
      const routeGid = String(this.$route.params.messenger_id || '');
      const fetch = this.messageListFetchStatus || {};
      return this.convensationExisted
        && this.loadingGetDataMessageList
        && this.messageList.length === 0
        && fetch.done === true
        && String(fetch.groupId) === routeGid;
    },
    chatWelcomeTitle() {
      const name = (this.chatGroupSelected && this.chatGroupSelected.name) || 'nhóm chat';
      return `Chào mừng đến ${name}`;
    },
    chatWelcomeText() {
      if (this.showOfficialTeamVerifiedChat) {
        return 'Đây là nhóm chat chính thức theo đội. Hãy gửi tin nhắn đầu tiên để bắt đầu trao đổi công việc với đồng nghiệp.';
      }
      return 'Chưa có tin nhắn nào. Hãy gửi tin nhắn đầu tiên để bắt đầu cuộc trò chuyện.';
    },

  },
  methods: {
    chatSenderDisplayName,
    isChatStickerMessage,
    hasMessageMediaFiles(mess) {
      return Array.isArray(mess && mess.files) && mess.files.length > 0;
    },
    nextMessageAt(index) {
      const list = this.messageList || [];
      return list[index + 1] || null;
    },

    messengerDebugLayoutSnapshot(phase) {
      if (!isMessengerDebugEnabled()) {
        return;
      }
      const chatContent = document.getElementById('chat-content');
      const rightColumn = document.getElementById('messenger-right-column');
      const panel = this.$refs.sidebarInfomationPanel;
      const footer = document.getElementsByClassName('chat-footer')[0];
      const overlay = this.$el && this.$el.querySelector('.velmld-overlay');
      messengerDebugLog(phase, {
        routeGroupId: this.$route.params.messenger_id,
        formGroupId: this.form.group_id,
        paramsGroupId: this.params.group_id,
        selectedId: this.$store.state.chat.chatGroupSelected?.id,
        selectedType: this.$store.state.chat.chatGroupSelected?.type,
        rightBarVisible: this.rightBarVisible,
        storeRightBar: this.$store.state.chat.chatGroupSelected?.right_bar_visible,
        convensationExisted: this.convensationExisted,
        loadingGetDataMessageList: this.loadingGetDataMessageList,
        messageListLen: this.messageList.length,
        messageListRequestSeq: this.messageListRequestSeq,
        cacheLen: getCacheMessages(this.cacheChatMessages, this.form.group_id).length,
        chatContentHeight: chatContent && chatContent.style ? chatContent.style.height : null,
        messagerClientHeight: this.$refs.messager ? this.$refs.messager.clientHeight : null,
        footerHeight: footer ? footer.offsetHeight : null,
        overlayDisplay: overlay ? getComputedStyle(overlay).display : null,
        rightColumnExists: !!rightColumn,
        rightColumnHidden: rightColumn
          ? rightColumn.classList.contains('messenger-right-column--hidden')
          : null,
        panelInRightColumn: !!(panel && rightColumn && rightColumn.contains(panel)),
        panelParent: panel && panel.parentNode
          ? (panel.parentNode.id || panel.parentNode.className || panel.parentNode.nodeName)
          : null,
      });
    },

    clearSidebarMountRetry() {
      if (this.sidebarMountRetryTimer != null) {
        clearTimeout(this.sidebarMountRetryTimer);
        this.sidebarMountRetryTimer = null;
      }
    },

    clearSidebarPanelPlaceholder() {
      const placeholder = this.sidebarInfomationPlaceholder;
      if (placeholder && placeholder.parentNode) {
        placeholder.parentNode.removeChild(placeholder);
      }
      this.sidebarInfomationPlaceholder = null;
    },

    scheduleMountSidebarPanel(attempt = 0) {
      this.clearSidebarMountRetry();
      const mounted = this.mountSidebarInfomationPanel();
      messengerDebugLog('sidebar.mountAttempt', { attempt, mounted });
      if (mounted || attempt >= 12) {
        if (attempt >= 12 && !mounted) {
          messengerDebugLog('sidebar.mountFailed', { attempt });
        }
        return;
      }
      this.sidebarMountRetryTimer = setTimeout(() => {
        this.sidebarMountRetryTimer = null;
        this.scheduleMountSidebarPanel(attempt + 1);
      }, 80);
    },

    getSidebarPanelMountTarget() {
      if (this.$route.name !== 'messenger') {
        return null;
      }
      const width = this.messengerViewportWidth;
      const sel = this.$store.state.chat.chatGroupSelected || {};
      const panelOpen = isMessengerRightPanelOpen(sel);

      if (isMessengerViewportNarrow(width)) {
        if (panelOpen && this.messengerRightDrawerOpen && this.$refs.sidebarDrawerMount) {
          return this.$refs.sidebarDrawerMount;
        }
        return this.$refs.sidebarMountHost || null;
      }

      if (!panelOpen) {
        return this.$refs.sidebarMountHost || null;
      }

      return document.getElementById('messenger-right-column');
    },

    mountSidebarInfomationPanel() {
      if (this.$route.name !== 'messenger') {
        return false;
      }
      const panel = this.$refs.sidebarInfomationPanel;
      if (!panel) {
        return false;
      }

      const target = this.getSidebarPanelMountTarget();
      if (!target) {
        return false;
      }
      if (panel.parentNode === target) {
        return true;
      }

      this.clearSidebarPanelPlaceholder();
      target.appendChild(panel);
      return true;
    },

    unmountSidebarInfomationPanel() {
      const panel = this.$refs.sidebarInfomationPanel;
      const host = this.$refs.sidebarMountHost;
      this.clearSidebarPanelPlaceholder();
      if (!panel || !host) {
        return;
      }
      if (panel.parentNode !== host) {
        host.appendChild(panel);
      }
    },

    closeRightDrawer() {
      const sel = this.$store.state.chat.chatGroupSelected || {};
      if (sel.right_bar_visible === false) {
        this.syncMessengerRightDrawerBodyLock(false);
        this.$nextTick(() => this.scheduleMountSidebarPanel());
        return;
      }
      this.$store.commit('chat/updateChatGroupSelected', {
        ...sel,
        right_bar_visible: false,
      });
      this.$nextTick(() => {
        this.syncMessengerRightDrawerBodyLock(false);
        this.scheduleMountSidebarPanel();
      });
    },

    syncMessengerRightDrawerBodyLock(forceOpen) {
      if (typeof document === 'undefined') {
        return;
      }
      const open = typeof forceOpen === 'boolean'
        ? forceOpen
        : this.messengerRightDrawerOpen;
      document.body.classList.toggle('messenger-right-drawer-body-lock', open);
    },
    getMessengerLayoutShellEl() {
      return document.querySelector('.content-shell.content-shell--messenger');
    },
    setupMessengerViewportLayoutWatchers() {
      this.teardownMessengerViewportLayoutWatchers();
      if (this.$route.name !== 'messenger') return;

      if (!this.messengerWindowResizeHandler) {
        this.messengerWindowResizeHandler = () => {
          this.scheduleMessengerViewportRightBarSync();
        };
      }
      window.addEventListener('resize', this.messengerWindowResizeHandler, { passive: true });

      const tryAttachShellObserver = () => {
        if (typeof ResizeObserver === 'undefined') return;
        if (this.messengerShellResizeObserver) return;
        const shell = this.getMessengerLayoutShellEl();
        if (!shell) return;
        const ro = new ResizeObserver(() => {
          this.scheduleMessengerViewportRightBarSync();
        });
        ro.observe(shell);
        this.messengerShellResizeObserver = ro;
      };

      tryAttachShellObserver();
      this.messengerShellLayoutRetryTimer = setTimeout(() => {
        this.messengerShellLayoutRetryTimer = null;
        tryAttachShellObserver();
        this.scheduleMountSidebarPanel();
        this.applyMessengerViewportRightBar();
      }, 450);

      this.$nextTick(() => {
        this.scheduleMountSidebarPanel();
        this.applyMessengerViewportRightBar();
      });
    },
    teardownMessengerViewportLayoutWatchers() {
      if (this.messengerShellResizeDebounceTimer != null) {
        clearTimeout(this.messengerShellResizeDebounceTimer);
        this.messengerShellResizeDebounceTimer = null;
      }
      if (this.messengerShellLayoutRetryTimer != null) {
        clearTimeout(this.messengerShellLayoutRetryTimer);
        this.messengerShellLayoutRetryTimer = null;
      }
      if (this.messengerWindowResizeHandler) {
        window.removeEventListener('resize', this.messengerWindowResizeHandler);
      }
      if (this.messengerShellResizeObserver) {
        try {
          this.messengerShellResizeObserver.disconnect();
        } catch (e) {
          void e;
        }
        this.messengerShellResizeObserver = null;
      }
    },
    scheduleMessengerViewportRightBarSync() {
      if (typeof window !== 'undefined') {
        this.messengerViewportWidth = window.innerWidth;
      }
      const narrow = isMessengerViewportNarrow(this.messengerViewportWidth);
      const breakpointChanged = this.lastMessengerShellWasNarrow !== narrow;

      if (breakpointChanged) {
        if (this.messengerShellResizeDebounceTimer != null) {
          clearTimeout(this.messengerShellResizeDebounceTimer);
          this.messengerShellResizeDebounceTimer = null;
        }
        this.applyMessengerViewportRightBar();
        return;
      }

      if (this.messengerShellResizeDebounceTimer != null) {
        clearTimeout(this.messengerShellResizeDebounceTimer);
      }
      this.messengerShellResizeDebounceTimer = setTimeout(() => {
        this.messengerShellResizeDebounceTimer = null;
        this.applyMessengerViewportRightBar();
      }, 120);
    },
    /** Viewport hẹp: cột phải ẩn, panel mount vào drawer khi mở. Viewport rộng: mount vào cột cố định. */
    applyMessengerViewportRightBar() {
      if (this.$route.name !== 'messenger') return;
      const narrow = isMessengerViewportNarrow(this.messengerViewportWidth);
      this.lastMessengerShellWasNarrow = narrow;

      const sel = this.$store.state.chat.chatGroupSelected || {};

      if (narrow) {
        this.rightBarCollapsedByViewport = true;
        this.rightBarVisible = isMessengerRightPanelOpen(sel);
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.scheduleMountSidebarPanel();
            this.syncMessengerRightDrawerBodyLock();
          });
        });
        return;
      }

      this.rightBarCollapsedByViewport = false;
      this.rightBarVisible = isMessengerRightPanelOpen(sel);
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.scheduleMountSidebarPanel();
          this.syncMessengerRightDrawerBodyLock(false);
        });
      });
    },
    onOpen (mention) {
      this.activeMention = true;
      this.allTextMentions = mention;
      // console.log(key, onLoad);
      // if(this.chatGroupSelected.type == GROUP_CHAT_TYPE.USER){
      //   return;
      // }
      // let except_userId = [];
      // this.mentions.forEach(element => {
      //   except_userId.push(element.mention_user_id);
      // });
      // // this.loadDataMentions();
      // ChatService.getMembersGroup({
      //   group_id: this.$route.params.messenger_id,
      //   except: except_userId
      // }).then(res => {
      //   this.loadDataMentions(res.data);

        // for (let i = 0; i < res.data.length; i++) {
        //   const text = '@' + res.data[i]['fullname']
        //   this.allTextMentions.push(text);
        // }

      // });
      // this.activeMention = !onLoad;
    },
    onClose (e) {
      this.activeMention = false;
    },
    onApply(item, key, replacedWith, keyIndex) {
      this.$nextTick(() => {
        this.selectUserTag(item, keyIndex, replacedWith);
      });
      this.activeMention = false;
      this.$nextTick(() => {
        const ta = this.$refs.textareaMessage;
        if (ta && ta.$el) {
          ta.$el.focus();
        }
      });
    },
    async loadIssues(searchText = null) {
      this.loadingMention = true;
      if (searchText) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }

        this.timer = setTimeout(() => {
          let except_userId = [];
          this.mentions.forEach(element => {
            except_userId.push(element.mention_user_id);
          });
          ChatService.getMembersGroup({
            group_id: this.$route.params.messenger_id,
            keyword: searchText,
            except: except_userId
          }).then(res => {
            this.loadDataMentions(res.data);

            for (let i = 0; i < res.data.length; i++) {
              const text = '@' + res.data[i]['fullname']
              this.allTextMentions.push(text);
            }

          });
        }, 500);
      } else {
        this.loadDataMentions()
      }
    },
    loadDataMentions(members = null){
      let datas = members || this.membersGroup;

      let member = [];
      for (let index = 0; index < datas.length; index++) {
        let mention = this.mentions.filter(item => item.mention_user_id == datas[index].id);

        if(mention.length > 0) continue;
        if(index == 5) break;

        datas[index].value = datas[index].fullname;
        member.push(datas[index]);
      }

      if(member.length > 0){
        member.unshift({
          value: 'All',
          fullname: 'Tất cả',
          avatar: {
            url: this.$store.state.chat.chatGroupSelected.avatar
          }
        });
      }
      this.items = member;
      this.loadingMention = false;
    },
    sumEmoji(emojiList) {
      return helpers.sumEmoji(emojiList)
    },
    bytesToSize(size) {
      return helpers.bytesToSize(size)
    },
    getChatFileIcon(extension) {
      return helpers.getFileType(extension)
    },
    async onReloadConversation(groupId) {
      const gid = String(groupId || "");
      if (!gid || String(this.$route.params.messenger_id) !== gid) return;

      this.conversationOpenScrollToken += 1;
      try {
        const { syncMessengerRouteGroup } = await import("@/helper/chatGroupStore");
        await syncMessengerRouteGroup(this.$store, gid);
      } catch (e) {
        void e;
      }
      if (String(this.$route.params.messenger_id) !== gid) return;

      this.messageListInflight = null;
      this.messageListFetchStatus = { groupId: gid, rowCount: 0, done: false };
      this.peerReadMessageId = null;
      this.resetMessageListParams();
      this.params.group_id = gid;
      this.form.group_id = gid;
      this.params.is_cache = false;
      this.chatGroupSelected = { ...this.$store.state.chat.chatGroupSelected };
      this.isAdmin = this.chatGroupSelected.is_admin === 1;
      this.getConvensationExist();
      this.scheduleMessageListLoad(this.params, { force: true, forceSync: true });
      this.$nextTick(() => {
        this.scheduleMountSidebarPanel();
        this.applyMessengerViewportRightBar();
      });
    },

    clearMessageListLoadingSafety() {
      if (this.messageListLoadSafetyTimer) {
        clearTimeout(this.messageListLoadSafetyTimer);
        this.messageListLoadSafetyTimer = null;
      }
    },

    armMessageListLoadingSafety(groupId) {
      this.clearMessageListLoadingSafety();
      this.messageListLoadSafetyTimer = setTimeout(() => {
        this.messageListLoadSafetyTimer = null;
        if (String(this.$route.params.messenger_id) !== String(groupId)) return;
        this.loadingGetDataMessageList = true;
      }, 15000);
    },

    scheduleMessageListLoad(params, options = {}) {
      const groupId = String(this.$route.params.messenger_id || "");
      if (!groupId || /^new\d+$/i.test(groupId)) return;
      if (options.force) {
        this.messageListInflight = null;
      }
      this.armMessageListLoadingSafety(groupId);
      return this.getMessageList(params, false, 'initial', {
        forceSync: options.forceSync === true || !!(params && params.is_cache === false),
      });
    },

    /** Đồng bộ store/header với `messenger_id` trên URL (mở link trực tiếp không qua sidebar). */
    syncRouteGroupContext() {
      if (this.$route.name !== 'messenger') {
        return;
      }
      const groupId = String(this.$route.params.messenger_id || '');
      if (!groupId || /^new\d+$/i.test(groupId)) {
        return;
      }
      messengerDebugLog('syncRouteGroupContext.start', { groupId });
      this.params.group_id = groupId;
      this.form.group_id = groupId;

      const applySelected = (found) => {
        if (!found) return;
        const cur = this.$store.state.chat.chatGroupSelected;
        if (!cur || String(cur.id) !== groupId) {
          let next = { ...found };
          delete next.isCreateChat;
          delete next.create_new_message;
          next = normalizeChatGroupSelectedForViewport(next);
          this.$store.commit('chat/updateChatGroupSelected', next);
        }
        this.chatGroupSelected = this.$store.state.chat.chatGroupSelected;
        this.rightBarVisible = resolveMessengerRightBarVisible(this.chatGroupSelected);
        if (isMessengerViewportNarrow()) {
          this.rightBarCollapsedByViewport = true;
        }
        this.isAdmin = this.chatGroupSelected.is_admin === 1;
      };

      const groups = this.$store.state.chat.chatGroups || [];
      const found = groups.find((g) => String(g.id) === groupId);
      if (found) {
        applySelected(found);
        messengerDebugLog('syncRouteGroupContext.fromStore', {
          groupId,
          name: found.name,
          type: found.type,
        });
        return;
      }

      if (this._syncRouteGroupFetchInFlight === groupId) {
        return;
      }
      this._syncRouteGroupFetchInFlight = groupId;
      messengerDebugLog('syncRouteGroupContext.fetch', { groupId });
      import("@/helper/chatGroupStore")
        .then(({ syncMessengerRouteGroup }) => syncMessengerRouteGroup(this.$store, groupId))
        .then((row) => {
          if (String(this.$route.params.messenger_id) !== groupId) {
            messengerDebugLog('syncRouteGroupContext.fetchStale', { groupId });
            return;
          }
          messengerDebugLog('syncRouteGroupContext.fetchDone', {
            groupId,
            hasRow: !!row,
            rowId: row && row.id,
          });
          applySelected(row);
        })
        .catch((err) => {
          messengerDebugLog('syncRouteGroupContext.fetchError', {
            groupId,
            message: err && err.message ? err.message : String(err),
          });
        })
        .finally(() => {
          if (this._syncRouteGroupFetchInFlight === groupId) {
            this._syncRouteGroupFetchInFlight = null;
          }
        });
    },

    getMessageList(params, loading = false, loadMode = 'initial', options = {}) {
      if (this.$route.name !== 'messenger') {
        messengerDebugLog('getMessageList.skip', { reason: 'not-messenger-route' });
        this.loadingGetDataMessageList = true;
        return Promise.resolve();
      }

      const groupId = String(this.$route.params.messenger_id || '');
      if (!groupId || /^new\d+$/i.test(groupId)) {
        messengerDebugLog('getMessageList.skip', { reason: 'invalid-group-id', groupId });
        this.loadingGetDataMessageList = true;
        return Promise.resolve();
      }

      const isInitialLoad = loadMode !== 'older';
      let softSyncMerge = false;

      if (isInitialLoad) {
        const inflight = this.messageListInflight;
        if (inflight && inflight.groupId === groupId && inflight.promise) {
          messengerDebugLog('getMessageList.coalesce', { groupId });
          return inflight.promise;
        }
      }

      params.group_id = groupId;
      this.params.group_id = groupId;
      this.form.group_id = groupId;

      let chatGroupSelected = this.$store.state.chat.chatGroupSelected;

      // ẩn loading khi vừa tạo cuộc trò chuyện mới
      if (typeof chatGroupSelected.create_new_message !== 'undefined' && chatGroupSelected.create_new_message) {
        loading = true;
      }

      this.getConvensationExist();

      let requestSeq = this.messageListRequestSeq;
      if (isInitialLoad) {
        requestSeq = ++this.messageListRequestSeq;
        this.hasMoreOlderMessages = true;
        this.messageListFetchStatus = { groupId, rowCount: 0, done: false };
        const selectedId = String(this.$store.state.chat.chatGroupSelected?.id ?? "");
        const cacheAllowed = selectedId === groupId || String(this.form.group_id) === groupId;
        const cacheEntry = cacheAllowed ? getCacheEntry(this.cacheChatMessages, groupId) : null;
        const cachedMessages = cacheEntry ? cacheEntry.messages : [];
        const unreadCount = Number(
          (this.$store.state.chat.chatGroupSelected && this.$store.state.chat.chatGroupSelected.unread_count) || 0,
        );
        const forceSync =
          options.forceSync === true ||
          (params && params.is_cache === false);

        if (cachedMessages.length && this.convensationExisted) {
          if (!this.messageList.length) {
            this.messageList = trimNewestMessages(
              sortChatMessages(cachedMessages.slice()),
              CHAT_MESSAGE_LIST_MAX,
            );
          }
          this.hasMoreOlderMessages = cacheEntry.hasMoreOlder !== false;
          loading = true;
          softSyncMerge = this.messageList.length > 0;

          if (!shouldSoftSyncMessages(cacheEntry, { unreadCount, force: forceSync })) {
            messengerDebugLog('getMessageList.cacheHit', {
              groupId,
              cachedLen: cachedMessages.length,
              unreadCount,
              fetchedAt: cacheEntry.fetchedAt,
            });
            this.loadingGetDataMessageList = true;
            this.messageListFetchStatus = {
              groupId,
              rowCount: this.messageList.length,
              done: true,
            };
            this.clearMessageListLoadingSafety();
            this.beginStickToBottomOnOpen();
            return Promise.resolve();
          }
        } else if (!this.convensationExisted) {
          this.messageList = [];
          loading = true;
        } else {
          this.messageList = [];
          loading = false;
        }
      }

      this.loadingGetDataMessageList = loading;

      messengerDebugLog('getMessageList.start', {
        groupId,
        loadMode,
        requestSeq,
        softSyncMerge,
        loadingGetDataMessageList: this.loadingGetDataMessageList,
        convensationExisted: this.convensationExisted,
        cachedLen: getCacheMessages(this.cacheChatMessages, groupId).length,
        messageListLen: this.messageList.length,
        params,
      });

      if (!this.convensationExisted) {
        messengerDebugLog('getMessageList.noConversation', {
          groupId,
          isCreateChat: chatGroupSelected.isCreateChat,
        });
        this.loadingGetDataMessageList = true;
        this.clearMessageListLoadingSafety();
        this.messengerDebugLayoutSnapshot('getMessageList.noConversation.done');
        return Promise.resolve();
      }

      if (!isInitialLoad) {
        if (!this.hasMoreOlderMessages || this.loadingOnScroll) {
          return Promise.resolve();
        }
        this.loadingOnScroll = true;
        if (this.$refs.messager) {
          this.$refs.messager.style.zIndex = 0;
        }
      }

      const resetScrollLoadingUi = () => {
        this.loadingOnScroll = false;
        if (this.$refs.messager) {
          this.$refs.messager.style.zIndex = 1;
        }
      };

      const perPage = Number(params.per_page) || 60;
      const apiParams = {
        group_id: groupId,
        per_page: perPage,
        type: params.type || 'ALL',
      };

      if (isInitialLoad) {
        apiParams.page = 1;
      } else {
        const oldest = this.messageList[0];
        if (!oldest || oldest.id == null) {
          resetScrollLoadingUi();
          this.hasMoreOlderMessages = false;
          return Promise.resolve();
        }
        apiParams.last_message_id = oldest.id;
      }

      const fetchPromise = ChatService.getMessageList(apiParams)
        .then(res => {
          if (isChatGroupNotFoundResponse(res)) {
            redirectAfterChatGroupAccessLost({ groupId });
            return;
          }
          const normalized = normalizeChatMessageListResponse(res);
          const rows = normalizeChatMessageRows(normalized.rows.map((row) => {
            if (!row || row.group_id != null) return row;
            return { ...row, group_id: Number(groupId) };
          }));
          const firstGroupId = rows[0] && rows[0].group_id != null ? String(rows[0].group_id) : null;
          const isCurrentRequest =
            requestSeq === this.messageListRequestSeq &&
            String(this.$route.params.messenger_id) === groupId;

          if (!isCurrentRequest) {
            messengerDebugLog('getMessageList.stale', {
              groupId,
              requestSeq,
              current: this.messageListRequestSeq,
              routeNow: this.$route.params.messenger_id,
            });
            return;
          }

          const rowsWithGroupId = rows.filter((m) => m && m.group_id != null);
          const payloadMatches =
            rows.length === 0 ||
            rowsWithGroupId.length === 0 ||
            rowsWithGroupId.some((m) => String(m.group_id) === groupId);

          messengerDebugLog('getMessageList.response', {
            groupId,
            requestSeq,
            loadMode,
            shape: normalized.shape,
            rowCount: rows.length,
            firstGroupId,
            payloadMatches,
            resTopKeys: res && typeof res === 'object' ? Object.keys(res) : [],
            metaLastPage: normalized.meta && normalized.meta.last_page,
            lastMessageId: apiParams.last_message_id,
          });

          if (isInitialLoad && payloadMatches) {
            const pr = normalized.peerReadMessageId ?? this.pickPeerReadMessageIdFromResponse(res);
            if (pr !== undefined) {
              this.peerReadMessageId = pr === null || typeof pr === 'undefined' ? null : Number(pr);
            }
          }

          if (payloadMatches) {
            this.messageListFetchStatus = {
              groupId,
              rowCount: rows.length,
              done: true,
            };
            if (rows.length > 0 && this.$store.state.chat.chatGroupSelected.type === 'BOT') {
              rows.forEach((item) => {
                item.sender = {
                  id: 0,
                  name: this.$store.state.chat.chatGroupSelected.name,
                  fullname: this.$store.state.chat.chatGroupSelected.name,
                  display_name: this.$store.state.chat.chatGroupSelected.name,
                  thumbnail: this.$store.state.chat.chatGroupSelected.thumbnail,
                };
              });
            }
            if (!isInitialLoad && this.messageList[0] && this.onScrollMessageId == null) {
              this.onScrollMessageId = this.messageList[0].id;
            }
            const batch = sortChatMessages(rows.slice().reverse());
            if (!isInitialLoad) {
              const merged = mergeOlderChatMessages(batch, this.messageList);
              const trimmed = trimAfterPrependOlder(merged, CHAT_MESSAGE_LIST_MAX);
              this.messageList = trimmed.list;
              if (trimmed.trimmedTail) {
                this.stickToBottomOnOpen = false;
                this.hasScrolledToBottom = false;
              }
            } else {
              this.applyInitialMessageBatch(groupId, batch, { softSyncMerge });
              this.params.is_cache = false;
            }

            this.hasMoreOlderMessages = rows.length >= perPage;
            if (isInitialLoad) {
              this.persistMessageCache(groupId);
            }

            if (normalized.meta && normalized.meta.last_page != null) {
              this.messageLastPage = Number(normalized.meta.last_page);
            }

            if (isInitialLoad && this.$store.state.chat.chatGroupSelected.type === GROUP_CHAT_TYPE.USER) {
              this.$nextTick(() => this.createReadGroupChat(true));
            }
          } else {
            messengerDebugLog('getMessageList.rejected', {
              groupId,
              shape: normalized.shape,
              rowCount: rows.length,
              firstGroupId,
            });
            if (isInitialLoad && isCurrentRequest) {
              this.messageList = [];
              this.messageListFetchStatus = { groupId, rowCount: 0, done: true };
            }
          }

          resetScrollLoadingUi();
          if (isInitialLoad) {
            if (payloadMatches && (this.stickToBottomOnOpen || !softSyncMerge || this.checkIsAtBottom())) {
              this.beginStickToBottomOnOpen();
            }
            this.$nextTick(() => {
              this.setHeightChatContent();
              this.messengerDebugLayoutSnapshot('getMessageList.done');
            });
          }
        })
        .catch((err) => {
          messengerDebugLog('getMessageList.error', {
            groupId,
            message: err && err.message ? err.message : String(err),
          });
          if (requestSeq === this.messageListRequestSeq) {
            this.messageListFetchStatus = { groupId, rowCount: 0, done: true };
          }
          resetScrollLoadingUi();
          this.messengerDebugLayoutSnapshot('getMessageList.error.done');
        })
        .finally(() => {
          if (this.messageListInflight && this.messageListInflight.promise === fetchPromise) {
            this.messageListInflight = null;
          }
          if (String(this.$route.params.messenger_id) !== groupId) return;
          if (requestSeq === this.messageListRequestSeq) {
            this.loadingGetDataMessageList = true;
            this.clearMessageListLoadingSafety();
            return;
          }
          if (!this.messageListInflight && this.loadingGetDataMessageList === false) {
            this.loadingGetDataMessageList = true;
            this.clearMessageListLoadingSafety();
          }
        });

      if (isInitialLoad) {
        this.messageListInflight = { groupId, requestSeq, promise: fetchPromise };
      }
      return fetchPromise;
    },

    /**
     * Áp batch trang 1: soft-sync merge khi đã có list (không giật nếu user đang đọc tin cũ).
     */
    applyInitialMessageBatch(groupId, batch, { softSyncMerge = false } = {}) {
      const wantStick = this.stickToBottomOnOpen || this.checkIsAtBottom() || !this.messageList.length;
      if (softSyncMerge && this.messageList.length) {
        const chatEl = this.getChatContentEl();
        const prevHeight = chatEl ? chatEl.scrollHeight : 0;
        const prevTop = chatEl ? chatEl.scrollTop : 0;
        this.messageList = trimNewestMessages(
          mergeChatMessageLists(this.messageList, batch),
          CHAT_MESSAGE_LIST_MAX,
        );
        if (!wantStick && chatEl) {
          this.$nextTick(() => {
            const el = this.getChatContentEl();
            if (el) {
              el.scrollTop = prevTop + (el.scrollHeight - prevHeight);
            }
          });
          return;
        }
      } else {
        this.messageList = trimNewestMessages(batch, CHAT_MESSAGE_LIST_MAX);
      }
      this.stickToBottomOnOpen = true;
    },

    persistMessageCache(groupId, messages = null) {
      const gid = String(groupId || this.form.group_id || '');
      if (!gid) {
        return;
      }
      const list = messages != null ? messages : this.messageList;
      this.cacheChatMessages = writeCacheEntry(this.cacheChatMessages, gid, list || [], {
        hasMoreOlder: this.hasMoreOlderMessages,
      });
      this.$store.commit('chat/updateCacheChatMessages', this.cacheChatMessages);
    },

    async postMessage() {
      if(this.form_input.uploading &&
       this.form.type !== MESSAGE_CHAT_TYPE.TEXT ||
       this.activeMention){
        return;
      }

      // is post only like emoji can disable
      if (!this.form_input.like_emoji.status) {
        this.positionMention(this.form_input.message || "");
        this.form.message = this.form_input.message;
        this.form.file_ids = this.form_input.file_ids;
        this.form.mentions = this.mentions;
        this.form.category = this.composerMessageCategory === '' ? null : this.composerMessageCategory;
      } else {
        this.form.category = null;
      }

      if(this.form.type !== MESSAGE_CHAT_TYPE.TEXT && this.form_input.file_ids.length == 0){
        this.form.type = MESSAGE_CHAT_TYPE.TEXT;
      }
      if (this.form.message !== '' || this.form.file_ids.length !== 0) {

        this.form_input.message = '';
        this.form_input.file_ids = [];
        this.activeTypeUpload = '';

        this.setHeightChatContent();

        if (!this.convensationExisted) {
          let member = this.$store.state.chat.chatGroupSelected;

          const dataCreateGroup = new FormData();

          dataCreateGroup.append("name", member.name);
          dataCreateGroup.append("model_type", GROUP_CHAT_TYPE.USER);
          dataCreateGroup.append("model_ids[]", member.user_id);

          await ChatService.createGroupChat(dataCreateGroup).then(res => {
            if (res.status) {
              this.$store.dispatch("chat/getChatGroups");
              this.$modal.hide('member-list-modal')

              this.form.group_id = res.data.id;
              this.createMessageChat(this.form);
            } else {
              this.$store.dispatch("alerts/error", 'Bạn tạo cuộc trò chuyện không thành công. Nguyên nhân: ' + res.message);
            }
          });
        } else {
          await this.createMessageChat(this.form);
        }
      }
    },

    async createMessageChat(form) {
      // fake uid
      form.mobile_local_id = Date.now().toString();

      if(this.form_input.isEdit){
        await ChatService.editMessageChat(form).then(res => {
          if (res.status) {
            this.messageList.map((mess, index) => {
              if (mess.id == res.data.id) {
                mess.history_message = res.data.history_message;
                mess.text = res.data.text;
              }
            });
            // Resetting the chat content.
            this.resetChatContent();
          }
        });
      }else{
        //===================================
        let groupedData = {};
        let fileCountMultiType = 0;
        this.medias.forEach(item => {
          const { type, file_id } = item;
          if (groupedData[type]) {
            groupedData[type]['file_ids'].push(file_id);
          } else {
            groupedData[type] = {
              ...form,
              file_ids: [file_id],
              message: (type === 'video' || type === 'file') ? this.form.message : ''
            };
            groupedData[type].type = type.toUpperCase();
            fileCountMultiType++;
          }

        });
        this.dataSplitFile.dataSplit = groupedData;
        // return;
        //===================================
        if(fileCountMultiType > 1){
          this.$modal.show('confirm-file-modal');
        } else {
          await this.createMessage(form);
        }
      }

    },

    emitChatGroupMediaAppended(message) {
      const items = libraryItemsFromImageVideoMessage(message);
      if (!items.length || !message.group_id) return;
      this.$root.$emit('chat-group-media-appended', {
        groupId: message.group_id,
        messageType: String(message.type || '').toUpperCase(),
        items,
      });
    },

    mergeOptimisticMessageFromResponse(res) {
      if (!res || !res.status || !res.data) {
        return;
      }
      const messageData = normalizeChatMessageRow(unwrapChatMessagePayload(res.data));
      if (!messageData) {
        return;
      }
      this.messageList.forEach((message) => {
        if (message.id != messageData.mobile_local_id) {
          return;
        }
        revokeOptimisticMediaPreviewUrls(message.files);
        const apiFiles = Array.isArray(messageData.files) ? messageData.files : [];
        if (apiFiles.length) {
          message.files = apiFiles;
        } else if (!Array.isArray(message.files)) {
          message.files = [];
        }
        Object.keys(message).forEach((key) => {
          if (key === 'files') {
            return;
          }
          if (Object.prototype.hasOwnProperty.call(message, key)
            && messageData[key] !== message[key]) {
            message[key] = messageData[key];
          }
        });
        message.status_message = 'done';
      });
    },

    async createMessage(form){
      const cloneForm = { ...form };
      delete cloneForm._optimistic_files;
      const isNewChatRoute = /^new\d+$/i.test(String(this.$route.params.messenger_id || ''));
      const isFirstMessageInNewChat = isNewChatRoute && !!form.group_id;

      if (isFirstMessageInNewChat) {
        this.convensationExisted = true;
        this.addDataToMessageList(form);
      } else if (this.convensationExisted) {
        this.addDataToMessageList(form);
      }

      await ChatService.createMessageChat(cloneForm).then(res => {
        if (res.status) {
          this.mergeOptimisticMessageFromResponse(res);
          const saved = normalizeChatMessageRow(unwrapChatMessagePayload(res.data));
          if (saved) {
            this.messageList = appendChatMessageIfNew(this.messageList, saved);
            const gid = String(saved.group_id || form.group_id || '');
            if (gid) {
              this.persistMessageCache(gid);
            }
          }

          this.clearPendingNewMessages();
          setTimeout(() => {
            this.scrollChatToBottom({ smooth: false });
          }, 100);

          this.updateLastMessageToGroupChat(res.data, { isFirstMessageInNewChat });
          this.emitChatGroupMediaAppended(res.data);

          this.convensationExisted = true;
        } else {
          cloneForm.status_message = 'error';
          this.createChat.messageErrors.push(cloneForm);
        }

        // Resetting the chat content.
        // this.resetChatContent();
      });
    },

    addDataToMessageList(form) {
      let dateTime = moment().format();
      let chatGroupSelected = this.$store.state.chat.chatGroupSelected;

      if(form.mentions){
        form.mentions.map((item) =>{
          item.id = Date.now();
        });
      }

      let reply_msg = null;
      if(form.reply_to_msg_id){
        let relyMess = this.messageList.find((item) => item.id === form.reply_to_msg_id);
        reply_msg = {
          id: Date.now(),
          "text": relyMess.text,
          "type": relyMess.type,
          "sender": relyMess.sender
        };
      }

      let link_metadata = null;
      if (form.type !== MESSAGE_CHAT_TYPE.ANNOUNCEMENT && /\bhttps?:[^,\s()<>]+(?:\([\w\d]+\)|([^,[:punct:]\s]|))/ig.test(form.message)) {
        link_metadata = "{\"description\":\"desc\",\"image\":\"https:\\/\\/znews-photo-fbcrawler.zadn.vn\\/Uploaded\\/grpu_fhccbeg1\\/2022_12_13\\/thumb_zing.png\",\"url\":\"https:\\/\\/social.vn\",\"title\":\"Soical\"}";
      }

      let tag_list = null;
      if (Array.isArray(form.tag_list) && form.tag_list.length > 0) {
        tag_list = JSON.stringify(form.tag_list)
      }

      let data = {
        "id": form.mobile_local_id,
        "text": form.message,
        "type": form.type,
        "group_id": form.group_id,
        "sender": this.user,
        "created_at": dateTime,
        "updated_at": dateTime,
        "pinned_at": moment().format('YYYY-MM-DD'),
        "system_note": null,
        "files": cloneMediaFilesForOptimisticMessage(
          form._optimistic_files != null ? form._optimistic_files : this.medias,
        ),
        "mentions": form.mentions,
        "mobile_local_id": form.mobile_local_id,
        "delete_status": null,
        "history_message": null,
        "reply_to_msg": reply_msg,
        "link_metadata": link_metadata,
        "group": {
          "id": chatGroupSelected.id || form.group_id,
          "name": chatGroupSelected.name,
          "join_policy": chatGroupSelected.settings && chatGroupSelected.settings.join_policy,
          "type": chatGroupSelected.type,
          "chat_privacy": chatGroupSelected.chat_privacy
        },
        "like_count": 0,
        "reaction_stats": {
          "like": 0,
          "love": 0,
          "haha": 0,
          "wow": 0,
          "sad": 0,
          "care": 0,
          "angry": 0
        },
        "status_message": this.isOnLine ? 'sending' : 'disconnect',
        "poll": form.poll ?? [],
        "category": form.category,
        "tag_list": tag_list
      };
      if(this.form.system_note){
        data.system_note = this.form.system_note;
      }
      if (form.type === MESSAGE_CHAT_TYPE.ANNOUNCEMENT) {
        data.text = form.message != null ? String(form.message) : '';
        const exp = form.announcement_expires_at;
        data.announcement = {
          title: form.announcement_title || '',
          expires_at: exp || null,
          payload: form.announcement_payload || {},
          schema_version: form.announcement_schema_version || 1,
          is_expired: false,
        };
      }
      this.messageList = appendChatMessageIfNew(this.messageList, normalizeChatMessageRow(data));
      if (this.messageList.length > CHAT_MESSAGE_LIST_MAX) {
        this.messageList = trimNewestMessages(this.messageList, CHAT_MESSAGE_LIST_MAX);
      }
      // Resetting the chat content.
      this.resetChatContent();

      this.afterIncomingMessageAppended(data, { forceScroll: true });
      this.$nextTick(() => this.resizeTextarea());
    },

    /** Chỉ tin cuối cả thread là của mình mới hiện tick (đúng nghiệp vụ: có tin mới từ đối phương = đã đọc). */
    isLastMyMessage(index) {
      if (this.messageList.length !== index + 1) {
        return false;
      }
      const last = this.messageList[this.messageList.length - 1];
      return last && last.sender && last.sender.id === this.user.id;
    },
    /**
     * peer_read có thể ở root, trong meta, hoặc trong lớp bọc API { data: { data, meta } }.
     */
    pickPeerReadMessageIdFromResponse(res) {
      if (!res || typeof res !== 'object') {
        return undefined;
      }
      if (Object.prototype.hasOwnProperty.call(res, 'peer_read_message_id')) {
        return res.peer_read_message_id;
      }
      if (res.meta && Object.prototype.hasOwnProperty.call(res.meta, 'peer_read_message_id')) {
        return res.meta.peer_read_message_id;
      }
      const inner = res.data;
      if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
        if (Object.prototype.hasOwnProperty.call(inner, 'peer_read_message_id')) {
          return inner.peer_read_message_id;
        }
        if (inner.meta && Object.prototype.hasOwnProperty.call(inner.meta, 'peer_read_message_id')) {
          return inner.meta.peer_read_message_id;
        }
      }
      return undefined;
    },
    onDocumentVisibilityForPeerRead() {
      if (document.visibilityState !== 'visible') {
        return;
      }
      if (this.router_name !== 'messenger') {
        return;
      }
      if (this.$store.state.chat.chatGroupSelected.type !== GROUP_CHAT_TYPE.USER) {
        return;
      }
      this.schedulePeerReadWatermarkRefresh();
    },
    schedulePeerReadWatermarkRefresh() {
      if (this.peerReadFetchTimer) {
        clearTimeout(this.peerReadFetchTimer);
      }
      this.peerReadFetchTimer = setTimeout(() => {
        this.peerReadFetchTimer = null;
        this.refreshPeerReadWatermark();
      }, 400);
    },
    async refreshPeerReadWatermark() {
      if (this.$store.state.chat.chatGroupSelected.type !== GROUP_CHAT_TYPE.USER) {
        return;
      }
      const groupId = this.$route.params.messenger_id;
      if (!groupId) {
        return;
      }
      try {
        const res = await ChatService.getMessageList({
          group_id: groupId,
          page: 1,
          per_page: 1,
          type: 'ALL',
        });
        const pr = this.pickPeerReadMessageIdFromResponse(res);
        if (pr === undefined) {
          return;
        }
        this.peerReadMessageId = pr === null || typeof pr === 'undefined' ? null : Number(pr);
      } catch (e) {
        /* noop */
      }
    },
    outboundMessageAcknowledged(mess) {
      return mess.status_message === 'done' || typeof mess.status_message === 'undefined';
    },
    messageSeenByPeer(mess) {
      if (this.$store.state.chat.chatGroupSelected.type !== GROUP_CHAT_TYPE.USER) {
        return false;
      }
      if (this.peerReadMessageId === null || this.peerReadMessageId === undefined) {
        return false;
      }
      const id = Number(mess.id);
      if (!Number.isFinite(id)) {
        return false;
      }
      return id <= this.peerReadMessageId;
    },

    async reSendMessageError(id) {

      const messageErrors = this.createChat.messageErrors;

      const messageError = messageErrors.find((item) => item.message_local_id == id);

      await ChatService.createMessageChat(messageError).then(res => {
        if (res.status) {
          this.mergeOptimisticMessageFromResponse(res);
          this.updateLastMessageToGroupChat(res.data);
          this.emitChatGroupMediaAppended(res.data);

          //remove is done
          // this.messageList.filter((mess, index) => {
          //   if (mess.id == id) {
          //     this.createChat.messageErrors.splice(messageErrors.findIndex((item) => item.id == id), 1);
          //     this.messageList.splice(index, 1);
          //   }
          // });

          this.convensationExisted = true;
        } else {
          this.messageList.filter((mess, index) => {
            if (mess.id == id) {
              mess.status_message = 'error';
            }
          });
        }
      });
    },

    /**
     * @param {boolean} force Gọi API read dù unread = 0 (cần để cập nhật read receipt / Đã xem cho đối phương sau khi tải tin).
     */
    async createReadGroupChat(force = false) {
      const groupId = this.$route.params.messenger_id;
      if (!groupId) return;
      const groupKey = String(groupId);

      if (!force) {
        const unread = this.$store.state.chat?.chatGroupSelected?.unread_count;
        if (unread === 0) return;
      }

      // Dedupe/throttle toàn app: ChatService.createReadGroupChat (sidebar + focus + load messages).
      await ChatService.createReadGroupChat({ group_id: groupKey }).then((res) => {
        if (res && res.status) {
          this.updateUnreadMessageToGroupChat();
          const sel = this.$store.state.chat.chatGroupSelected;
          if (sel && String(sel.id) === groupKey) {
            this.$store.commit('chat/updateChatGroupSelected', { ...sel, unread_count: 0 });
          }
          this.$store.dispatch('chat/getUnreadGroupChat');
        }
      });
    },

    updateUnreadMessageToGroupChat() {
      let chatGroupSelected = this.$store.state.chat.chatGroupSelected;
      let chatGroups = this.$store.state.chat.chatGroups;

      chatGroups.map((item) => {
            if (item.id === chatGroupSelected.id) {
              item.unread_count = 0
            }
          }
      )

      document.title = 'Agency Social';
      this.$store.commit('chat/updateChatGroups', chatGroups);
    },

    updateLastMessageToGroupChat(data, options = {}) {
      let chatGroupSelected = this.$store.state.chat.chatGroupSelected;
      let chatGroups = this.$store.state.chat.chatGroups;
      chatGroupSelected.last_message = data;
      delete chatGroupSelected.isCreateChat;

      const groupId = data.group_id;
      if (groupId != null) {
        chatGroupSelected.id = groupId;
      }

      chatGroups.map((item) => {
            if (item.id == chatGroupSelected.id || item.id == groupId) {
              item.last_message = data
            }
          }
      )

      const sortedGroups = sortChatGroupsForSidebar(
        dedupeChatGroupsById(chatGroups),
      );

      const isNewChatRoute = /^new\d+$/i.test(String(this.$route.params.messenger_id || ''));
      const shouldNavigateToGroup = options.isFirstMessageInNewChat || isNewChatRoute || !this.convensationExisted;
      if (shouldNavigateToGroup && groupId != null) {
        this.goToGroupChat(groupId);
        this.$router.push("/messenger/" + groupId);
        // set khi tạo mới cuộc trò chuyện cần bỏ hiệu ứng loading
        chatGroupSelected.create_new_message = true;
      }

      this.$store.commit('chat/updateChatGroups', sortedGroups);
      this.$store.commit('chat/updateChatGroupSelected', chatGroupSelected);

    },

    async goToGroupChat(group_id) {
      const params = {
        'page': 1,
        'per_page': 20,
        'group_id': group_id
      };

      await ChatService.getChatGroups(params).then(res => {
        if (res.data) {
          this.$store.commit("chat/updateChatGroupSelected", res.data[0]);
        }
      });
    },

    toogleDialogEmoji() {
      this.showDialogEmoji = !this.showDialogEmoji;
    },

    hiddenDialogEmoji() {
      this.showDialogEmoji = false;
      this.suppressReadOnComposerFocus = false;
    },

    onSelectEmoji(emoji) {
      let startPos = this.$refs.textareaMessage.$el.selectionStart;

      // Lấy phần văn bản trước và sau vị trí con trỏ chuột
      const textBeforeCursor = this.form_input.message.slice(0, startPos);
      const textAfterCursor = this.form_input.message.slice(startPos);

      // Cập nhật giá trị của textarea
      this.form_input.message = textBeforeCursor + emoji.data + textAfterCursor;
      const newCursorPosition = startPos + emoji.data.length;

      this.suppressReadOnComposerFocus = true;
      this.$nextTick(() => {
        this.$refs.textareaMessage.$el.focus();
        this.$refs.textareaMessage.$el.setSelectionRange(newCursorPosition, newCursorPosition);
        this.userTyping();
      });
    },

    setCursorPosition(el, pos) {
      el.focus();
      el.setSelectionRange((pos), (pos));
    },

    async likeEmoji() {
      this.form.message = this.form_input.like_emoji.icon;
      this.form.category = null;
      this.composerMessageCategory = '';
      this.form_input.like_emoji.status = true;
      await this.postMessage();
      this.form_input.like_emoji.status = false;
    },

    activeFastMessage(){
      this.isFastMessage = !this.isFastMessage;
      this.$nextTick(() => {
        this.setHeightChatContent();
      });
    },

    async chatFastMessage(tag){

      this.form.message = tag;
      this.form_input.message = tag;
      await this.postMessage();
    },

    getApproveJoinGroupText(item) {
      if (!item || !item.system_note) return '';
      try {
        const note = JSON.parse(item.system_note);
        const approved = note.approved_user;
        const approver = note.approver;
        if (!approved || !approver) return '';
        const approverName = Number(approver.id) === Number(this.user.id) ? 'Bạn' : approver.fullname;
        return `<a target="_blank" class="other-member" href="/profile/${approved.id}">${approved.fullname}</a> đã được <span class="text-400-medium">${approverName}</span> phê duyệt vào nhóm`;
      } catch (e) {
        return '';
      }
    },

    getImageTypeSystem(item) {
      let image = '';
      switch (item.text) {
        case TEXT_CHAT_SYSTEM.CREATE_GROUP:
          image = '/img/chat/group_chat.svg';
          break;
        case TEXT_CHAT_SYSTEM.CHANGE_GROUP_AVATAR:
          image = '/img/chat/change_avatar_group.svg';
          break;
        case TEXT_CHAT_SYSTEM.CHANGE_GROUP_NAME:
          image = '/img/chat/change_name_group.svg';
          break;
        default:
          image = '/img/chat/group_chat.svg';
          break;
      }

      return image;
    },

    getTextTypeSystem(item) {
      let text = '';
      switch (item.text) {
        case TEXT_CHAT_SYSTEM.CREATE_GROUP:
          text = ' đã tạo nhóm';
          break;
        case TEXT_CHAT_SYSTEM.CHANGE_GROUP_AVATAR:
          if(!item.system_note){
            text = ` đã đổi ảnh đại diện của nhóm`;
          }else{
            text = ` đã đổi <a target="_blank" href="${JSON.parse(item.system_note).data}">ảnh đại diện</a> của nhóm`;
          }
          break;
        case TEXT_CHAT_SYSTEM.CHANGE_GROUP_NAME:
          if(!item.system_note){
            text = ' đã đổi tên nhóm';
          }else {
            text = ` đã đổi tên nhóm thành "<span class="text-400-medium">${JSON.parse(item.system_note).data}</span>"`;
          }
          break;
        case TEXT_CHAT_SYSTEM.LEAVE_GROUP:
          text = ' đã rời khỏi nhóm';
          break;
        case TEXT_CHAT_SYSTEM.REMOVE_USER:
          if(!item.system_note){
            text = ' đã xóa thành viên khỏi nhóm';
          }else{
            let member_remove = JSON.parse(item.system_note);
            text = ` đã xóa <a target="_blank" class="other-member" href="/profile/${member_remove[0].id}">${member_remove[0].fullname}</a> `;
          }

          break;
        case TEXT_CHAT_SYSTEM.ADD_USER_GROUP:
          if (!item.system_note) {
            text = ' đã thêm thành viên ';
          } else {
            try {
              const member_added = JSON.parse(item.system_note);
              if (Array.isArray(member_added) && member_added.length > 0 && member_added[0]) {
                text = ` đã thêm <a target="_blank" class="other-member" href="/profile/${member_added[0].id}">${member_added[0].fullname}</a> `;
              } else {
                text = ' đã thêm thành viên ';
              }
            } catch (e) {
              text = ' đã thêm thành viên ';
            }
          }
          break;
        case TEXT_CHAT_SYSTEM.APPROVE_JOIN_GROUP:
          text = '';
          break;
        case TEXT_CHAT_SYSTEM.PIN_MESSAGE:
          text = ` đã ghim tin nhắn "${JSON.parse(item.system_note).data}"`;
          break;
        case TEXT_CHAT_SYSTEM.UNPIN_MESSAGE:
          text = ` đã bỏ ghim tin nhắn "${JSON.parse(item.system_note).data}"`;
          break;
        case TEXT_CHAT_SYSTEM.CREATE_GROUP_RULES:
          text = ' đã thêm nội quy nhóm';
          break;
        case TEXT_CHAT_SYSTEM.UPDATE_GROUP_RULES: {
          let cleared = false;
          if (item.system_note) {
            try {
              const note = JSON.parse(item.system_note);
              cleared = note.has_rules === false;
            } catch (e) {
              cleared = false;
            }
          }
          text = cleared ? ' đã xóa nội quy nhóm' : ' đã cập nhật nội quy nhóm';
          break;
        }
        case TEXT_CHAT_SYSTEM.POLL_VOTE: {
          let answer = '';
          if (item.system_note) {
            try {
              const note = JSON.parse(item.system_note);
              answer = note.answer || '';
            } catch (e) {
              answer = '';
            }
          }
          text = answer !== ''
            ? ` đã bình chọn "<span class="text-400-medium">${answer}</span>"`
            : ' đã bình chọn';
          break;
        }
        default:
          text = '';
          break;
      }

      return text;
    },

    onKeydown(e) {
      if (this.activeMention && (e.keyCode === 13 || e.keyCode === 9 || e.keyCode === 38 || e.keyCode === 40)) {
        return;
      }
      if ((e.shiftKey && e.keyCode == 13) || (e.ctrlKey && e.keyCode == 13)) {
        return;
      } else if (e.keyCode == 13) {
        const inputText = e.target.value;
        this.positionMention(inputText);
        this.postMessage();
        e.preventDefault()
        e.stopPropagation();
        return;
      }
    },

    onKeyup(e) {
      this.userTyping();
      if (this.chatGroupSelected.type !== GROUP_CHAT_TYPE.USER){
        const inputText = e.target.value;
        this.positionMention(inputText);
      }
    },

    positionMention(inputText) {
      for (let i = this.mentions.length - 1; i >= 0; i--) {
        const mention = this.mentions[i];
        let text = String(mention.text || "").trim();
        if (!text) {
          this.mentions.splice(i, 1);
          continue;
        }

        let offsetToInput = inputText.indexOf(text);
        if (offsetToInput < 0 && text.startsWith("@")) {
          const withoutTrailingSpace = text.replace(/\s+$/, "");
          if (withoutTrailingSpace !== text) {
            offsetToInput = inputText.indexOf(withoutTrailingSpace);
            if (offsetToInput > -1) {
              text = withoutTrailingSpace;
            }
          }
        }

        if (offsetToInput > -1) {
          mention.off_set = offsetToInput;
          mention.length = text.length;
          mention.text = text;
        } else {
          this.mentions.splice(i, 1);
        }
      }
    },

    onFocus(e) {
      if (this.suppressReadOnComposerFocus) {
        this.suppressReadOnComposerFocus = false;
        this.isFocusChat = true;
        return;
      }
      if (this.convensationExisted) {
        this.createReadGroupChat(true);
        this.isFocusChat = true;
      }
    },

    async onPaste(e) {
      if (!e || !e.clipboardData) return;

      const imageFiles = await prepareClipboardImagesForUpload(e);
      if (!imageFiles.length) return;

      e.preventDefault();
      this.typingMessage = true;
      await this.onChangeUpload(e, 'image', imageFiles);
    },

    async userTyping(){
      if(this.isCallUserTyping && !!this.form_input.message){
        this.isCallUserTyping = false;
        setTimeout(() => {
          this.isCallUserTyping = true
        }, 5000);

        let params = {
          group_id : this.$store.state.chat.chatGroupSelected.id,
        };
        await ChatService.userTyping(params).then(res => {});
      }
    },

    openUpload(type) {
      this.isFastMessage = false;
      switch (type) {
        case 'file':
          if (this.$refs.fileUpload) this.$refs.fileUpload.click();
          break;
        case 'image':
          if (this.$refs.imageUpload) this.$refs.imageUpload.click();
          break;
        case 'video':
          if (this.$refs.videoUpload) this.$refs.videoUpload.click();
          break;
      }
      this.typingMessage = true;
    },

    selectUserTag(member = null, keyIndex = null, insertedText = null) {
      if (!member) return;
      const trimmedName = String(member.fullname || "").trim();
      const label = insertedText
        ? String(insertedText).replace(/\s+$/, "")
        : "@" + trimmedName;
      const message = this.form_input.message || "";
      let off = -1;

      if (typeof keyIndex === "number" && keyIndex >= 0) {
        off = message.indexOf(label, Math.max(0, keyIndex - 3));
      }
      if (off < 0) {
        off = message.lastIndexOf(label);
      }
      if (off < 0 && typeof keyIndex === "number" && keyIndex >= 0) {
        off = keyIndex;
      }

      this.mentions.push({
        mention_user_id: member.value == "All" ? 0 : member.id,
        off_set: off >= 0 ? off : 0,
        text: label,
        length: label.length,
      });
      this.suppressReadOnComposerFocus = true;
      this.$nextTick(() => {
        this.highlightTextarea();
        this.resizeTextarea();
        const ta = this.$refs.textareaMessage;
        if (ta && ta.$el) {
          ta.$el.focus();
        }
      });
    },

    highlightTextarea() {
      $('#input-chat').highlightTextarea({
        words: [{color: "rgb(204,227,255)", words: this.allTextMentions}],
        caseSensitive: false,
      });
    },

    async onChangeUpload(e, type, fileOnPaste = false) {
      /** Phải copy FileList trước khi reset input — không thì một số browser làm rỗng danh sách file. */
      const rawList = fileOnPaste ? fileOnPaste : (e && e.target ? e.target.files : null);
      const selectedFiles = rawList && rawList.length ? Array.from(rawList) : [];
      if (e && e.target) {
        e.target.value = '';
      }
      if (!selectedFiles.length) return;
      await this.uploadFilesWithTarget(selectedFiles, type, 'composer');
    },

    async onAnnouncementChangeUpload(e, type, fileOnPaste = false) {
      const rawList = fileOnPaste ? fileOnPaste : (e && e.target ? e.target.files : null);
      const selectedFiles = rawList && rawList.length ? Array.from(rawList) : [];
      if (e && e.target) {
        e.target.value = '';
      }
      if (!selectedFiles.length) return;
      await this.uploadFilesWithTarget(selectedFiles, type, 'announcement');
    },

    /**
     * Upload file (PostService) — dùng cho composer hoặc modal thông báo.
     * @param {'composer'|'announcement'} target
     */
    deleteUploadedMediaQuiet(fileId) {
      if (fileId == null) return;
      PostService.deleteUploadedMedia(fileId).catch(() => {});
    },

    revokeMediaPreview(item) {
      if (item && item._previewObjectUrl) {
        URL.revokeObjectURL(item._previewObjectUrl);
        delete item._previewObjectUrl;
      }
    },

    discardMediaItem(item) {
      if (!item) return;
      if (item.loading === 'loading') {
        item._discarded = true;
        this.revokeMediaPreview(item);
        return;
      }
      if (item.file_id != null) {
        this.deleteUploadedMediaQuiet(item.file_id);
      }
      this.revokeMediaPreview(item);
    },

    discardPendingComposerUploads() {
      const composerItems = this.medias.slice();
      const announcementItems = this.announcementMedias.slice();

      composerItems.forEach((item) => this.discardMediaItem(item));
      announcementItems.forEach((item) => this.discardMediaItem(item));

      this.medias = [];
      this.form.file_ids = [];
      this.form_input.file_ids = [];
      this.announcementMedias = [];
      this.announcementFileIds = [];
      this.announcementActiveTypeUpload = '';
      this.announcementUploading = false;
      this.activeTypeUpload = '';
      this.typeUpload = '';
      this.form_input.uploading = false;
    },

    buildChatUploadMediaPlaceholder(file) {
      const typeFile = file.type;
      const ext = (String(file.name || '').split('.').pop() || '').toLowerCase();
      const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp'];
      const videoTypes = ['video/mp4', 'video/mpeg', 'video/quicktime'];
      const item = {
        name: file.name,
        file_size: file.size,
        extension: ext,
        url: null,
        path: null,
        type: 'file',
        loading: 'loading',
      };

      if (imageTypes.includes(typeFile) || ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(ext)) {
        item.type = 'image';
      } else if (videoTypes.includes(typeFile) || ['mp4', 'mpeg', 'mov'].includes(ext)) {
        item.type = 'video';
      }

      if (item.type === 'image' || item.type === 'video') {
        try {
          const objectUrl = URL.createObjectURL(file);
          item.path = objectUrl;
          item._previewObjectUrl = objectUrl;
          item.thumbnail = { small_thumb: objectUrl, medium_thumb: objectUrl };
        } catch (err) {
          item.path = '';
        }
      }

      return item;
    },

    getChatUploadErrorMessage(resOrErr, fallback = 'Không thể tải tệp lên.') {
      const body = resOrErr && resOrErr.response ? resOrErr.response.data : resOrErr;
      if (!body) return fallback;
      let errMsg = body.message || fallback;
      const fieldErrors = body.data;
      if (fieldErrors && typeof fieldErrors === 'object') {
        const firstKey = Object.keys(fieldErrors)[0];
        const raw = firstKey ? fieldErrors[firstKey] : null;
        const firstErr = Array.isArray(raw) ? raw[0] : raw;
        if (firstErr) errMsg = String(firstErr);
      }
      return errMsg;
    },

    applyChatUploadResponseToItem(item, uploaded, mediasBucket, fileIdsBucket) {
      if (!uploaded) {
        item.loading = 'error';
        return;
      }

      const uploadedFileId = uploaded.file_id;
      if (item._discarded) {
        this.deleteUploadedMediaQuiet(uploadedFileId);
        const bucketIndex = mediasBucket.indexOf(item);
        if (bucketIndex !== -1) {
          mediasBucket.splice(bucketIndex, 1);
        }
        return;
      }

      if (item._previewObjectUrl) {
        URL.revokeObjectURL(item._previewObjectUrl);
        delete item._previewObjectUrl;
      }
      item.path = uploaded.url;
      item.url = uploaded.url;
      item.file_id = uploadedFileId;
      item.loading = false;
      if (uploaded.thumbnail && typeof uploaded.thumbnail === 'object') {
        item.thumbnail = uploaded.thumbnail;
      } else if (uploaded.url) {
        item.thumbnail = {
          small_thumb: uploaded.url,
          medium_thumb: uploaded.url,
        };
      } else {
        item.thumbnail = null;
      }
      fileIdsBucket.push(uploadedFileId);
    },

    async uploadChatMediaBatch(entries, mediasBucket, fileIdsBucket) {
      const formFile = new FormData();
      entries.forEach((entry) => {
        formFile.append('files[]', entry.file);
      });

      try {
        const res = await PostService.uploadFile(formFile);
        if (!res.status || !Array.isArray(res.data)) {
          entries.forEach((entry) => {
            entry.item.loading = 'error';
          });
          this.$store.dispatch('alerts/error', this.getChatUploadErrorMessage(res));
          return;
        }

        entries.forEach((entry, index) => {
          this.applyChatUploadResponseToItem(
            entry.item,
            res.data[index],
            mediasBucket,
            fileIdsBucket,
          );
        });
      } catch (err) {
        entries.forEach((entry) => {
          entry.item.loading = 'error';
        });
        this.$store.dispatch('alerts/error', this.getChatUploadErrorMessage(err));
      }
    },

    async uploadChatMediaVideoEntry(entry, mediasBucket, fileIdsBucket) {
      const formFile = new FormData();
      formFile.append('files[]', entry.file);

      try {
        const thumbBlob = await captureVideoThumbnailFromFile(entry.file);
        if (thumbBlob && thumbBlob.size > 0) {
          formFile.append('thumbnail', thumbBlob, 'video-thumb.jpg');
        }
      } catch (thumbErr) {
        void thumbErr;
      }

      try {
        const res = await PostService.uploadFile(formFile);
        if (!res.status || !Array.isArray(res.data) || !res.data[0]) {
          entry.item.loading = 'error';
          this.$store.dispatch('alerts/error', this.getChatUploadErrorMessage(res));
          return;
        }
        this.applyChatUploadResponseToItem(
          entry.item,
          res.data[0],
          mediasBucket,
          fileIdsBucket,
        );
      } catch (err) {
        entry.item.loading = 'error';
        this.$store.dispatch('alerts/error', this.getChatUploadErrorMessage(err));
      }
    },

    async uploadFilesWithTarget(selectedFiles, pickerType, target) {
      const isAnnouncement = target === 'announcement';
      const mediasBucket = isAnnouncement ? this.announcementMedias : this.medias;
      const fileIdsBucket = isAnnouncement ? this.announcementFileIds : this.form_input.file_ids;

      const entries = [];
      for (let i = 0; i < selectedFiles.length; i += 1) {
        // eslint-disable-next-line no-await-in-loop
        const preparedFile = await prepareChatImageFileForUpload(selectedFiles[i]);
        const validation = validateChatUploadFile(preparedFile);
        if (!validation.ok) {
          this.$store.dispatch('alerts/error', validation.message);
          continue;
        }
        entries.push({ file: preparedFile });
      }
      if (!entries.length) return;

      if (isAnnouncement) {
        this.announcementUploading = true;
        this.announcementActiveTypeUpload = pickerType;
      } else {
        this.typeUpload = pickerType;
        this.activeTypeUpload = pickerType;
        this.form_input.uploading = true;
        if (selectedFiles.length > 0 && this.$refs.scrollBottomAnchor) {
          this.$refs.scrollBottomAnchor.style.bottom = '160px';
        }
      }

      const types = [];
      for (let i = 0; i < entries.length; i += 1) {
        const typeFile = entries[i].file.type.split('/')[0];
        if (!types.includes(typeFile) || types.length === 0) {
          types.push(['video', 'image'].includes(typeFile) ? typeFile : 'file');
        }
      }
      const type_upload = types.find((item) => item !== pickerType) ?? pickerType;

      entries.forEach((entry) => {
        entry.item = this.buildChatUploadMediaPlaceholder(entry.file);
        if (!isAnnouncement) {
          switch (type_upload) {
            case 'image':
              this.form.type = MESSAGE_CHAT_TYPE.IMAGE;
              break;
            case 'video':
              this.form.type = MESSAGE_CHAT_TYPE.VIDEO;
              break;
            case 'file':
              this.form.type = MESSAGE_CHAT_TYPE.FILE;
              break;
          }
        }
        mediasBucket.push(entry.item);
      });

      const batchEntries = entries.filter((entry) => entry.item.type !== 'video');
      const videoEntries = entries.filter((entry) => entry.item.type === 'video');

      if (batchEntries.length) {
        await this.uploadChatMediaBatch(batchEntries, mediasBucket, fileIdsBucket);
      }

      for (let i = 0; i < videoEntries.length; i += 1) {
        // eslint-disable-next-line no-await-in-loop
        await this.uploadChatMediaVideoEntry(videoEntries[i], mediasBucket, fileIdsBucket);
      }

      if (isAnnouncement) {
        this.announcementUploading = false;
      } else {
        this.form_input.uploading = false;
      }
    },

    openAnnouncementUpload(type) {
      this.isFastMessage = false;
      switch (type) {
        case 'file':
          if (this.$refs.announcementFileUpload) this.$refs.announcementFileUpload.click();
          break;
        case 'image':
          if (this.$refs.announcementImageUpload) this.$refs.announcementImageUpload.click();
          break;
        case 'video':
          if (this.$refs.announcementVideoUpload) this.$refs.announcementVideoUpload.click();
          break;
      }
    },

    removeAnnouncementFile(index) {
      const removed = this.announcementMedias[index];
      this.discardMediaItem(removed);
      this.announcementMedias.splice(index, 1);
      this.announcementFileIds.splice(index, 1);
      if (this.announcementMedias.length === 0) {
        this.announcementActiveTypeUpload = '';
      }
    },

    clearAnnouncementModalAttachments(options = {}) {
      const deleteFromServer = options.deleteFromServer !== false;
      if (deleteFromServer) {
        this.announcementMedias.forEach((m) => this.discardMediaItem(m));
      } else {
        this.announcementMedias.forEach((m) => this.revokeMediaPreview(m));
      }
      this.announcementMedias = [];
      this.announcementFileIds = [];
      this.announcementActiveTypeUpload = '';
      this.announcementUploading = false;
    },

    closeAnnouncementModal() {
      this.$modal.hide('announcement-compose-modal');
      this.clearAnnouncementModalAttachments();
    },

    hydrateAnnouncementMediasFromMessage(message) {
      this.clearAnnouncementModalAttachments({ deleteFromServer: false });
      const rawFiles = message && message.files;
      if (!Array.isArray(rawFiles) || rawFiles.length === 0) return;

      rawFiles.forEach((f) => {
        const mf = f.media_file || f;
        if (!mf) return;
        const ext = String(mf.extension || (mf.name || '').split('.').pop() || '').toLowerCase().replace(/^\./, '');
        let mime = mf.mime_type || mf.type || '';
        if (typeof mime !== 'string') mime = '';
        const mimeRoot = mime.split('/')[0] || '';
        let itemType = 'file';
        const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp'];
        const videoTypes = ['video/mp4', 'video/mpeg', 'video/quicktime'];
        if (imageTypes.includes(mime) || ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(ext)) {
          itemType = 'image';
        } else if (videoTypes.includes(mime) || ['mp4', 'mpeg', 'mov'].includes(ext)) {
          itemType = 'video';
        }
        const fid = mf.file_id != null ? mf.file_id : f.file_id;
        const thumb = mf.thumbnail || {};
        const path = mf.path || mf.url || thumb.medium_thumb || thumb.small_thumb || '';
        this.announcementMedias.push({
          name: mf.name || 'file',
          file_size: mf.file_size || 0,
          extension: ext,
          url: mf.url,
          path,
          type: itemType,
          loading: false,
          file_id: fid,
          thumbnail: mf.thumbnail || { medium_thumb: path, small_thumb: path },
        });
        if (fid != null) this.announcementFileIds.push(fid);
      });
      if (this.announcementMedias.length) {
        const first = this.announcementMedias[0].type;
        this.announcementActiveTypeUpload = first === 'image' ? 'image' : first === 'video' ? 'video' : 'file';
      }
    },

    async uploadFile() {
      const formFile = new FormData();
      this.fileUploadData = [];
      for (let i = 0; i < this.files.length; i++) {
        formFile.append("files[]", this.files[i]);
      }

      await PostService.uploadFile(formFile).then(res => {
        if (res.status) {
          for (let i = 0; i < res.data.length; i++) {
            this.fileUploadData.push(res.data[i]['url'])
            this.medias.push(res.data[i]);
            this.form.file_ids.push(res.data[i]['file_id']);
          }
        }
      });
    },

    removeFile(index) {
      const removed = this.medias[index];
      this.discardMediaItem(removed);
      this.files.splice(index, 1);
      this.medias.splice(index, 1);
      this.form.file_ids.splice(index, 1);
      this.form_input.file_ids.splice(index, 1);

      if (this.medias.length === 0) {
        this.form.type = MESSAGE_CHAT_TYPE.TEXT;
        this.activeTypeUpload = '';
        this.$refs.fileUpload.value = '';
        this.$refs.imageUpload.value = '';
        if (this.$refs.videoUpload) this.$refs.videoUpload.value = '';
        this.form_input.uploading = false;
        this.$refs.scrollBottomAnchor.style.bottom = '100px';
      }
      if(this.form_input.message === '' || this.medias.length === 0){
          this.typingMessage = false;
        }
      this.setHeightChatContent();
    },


    getTimeCreated(time, format) {
      let today = moment().subtract(0, 'days');
      let yesterday = moment().subtract(1, 'days');
      if (moment(time).isSame(today, "day")) {
        return moment(time).format("HH:mm") + ", Hôm nay"
      } else if (moment(time).isSame(yesterday, "day")) {
        return moment(time).format("HH:mm") + ", Hôm qua"
      }
      return moment(time).locale('vi').format(format);
    },

    checkShowSenderName(message, index) {
      if (index === 0)  return true;
      if(this.chatGroupSelected.type == GROUP_CHAT_TYPE.BOT && message.sender == null){
        return true;
      }
      if (this.chatGroupSelected.type == GROUP_CHAT_TYPE.USER || this.chatGroupSelected.type == GROUP_CHAT_TYPE.BOT) return false;
      if (message.sender.id !== this.user.id) {
        const prevMessage = this.messageList[index - 1];
        if (message.type !== MESSAGE_CHAT_TYPE.SYSTEM && prevMessage.type === MESSAGE_CHAT_TYPE.SYSTEM) {
          return true
        }
        if (message.sender.id !== prevMessage.sender.id) {
          return true;
        }

        if (this.checkShowTime(message, index)) {
          return true;
        }

      }
      return false;
    },

    checkShowAvatar(message, index) {
      if (index === 0)  return true;
      if (message.sender.id !== this.user.id) {
        const prevMessage = this.messageList[index - 1];
        if (message.type !== MESSAGE_CHAT_TYPE.SYSTEM && prevMessage.type === MESSAGE_CHAT_TYPE.SYSTEM) {
          return true
        }
        if (message.sender.id !== prevMessage.sender.id) {
          return true;
        }

        if (this.checkShowTime(message, index)) {
          return true;
        }

      }
      return false;
    },

    checkShowTime(item, index) {
      if (index !== 0) {
        return !moment(item.created_at).isSame(moment(this.messageList[index - 1]['created_at']), "days")
      } else {
        return true;
      }
    },

    showFullCommentImage(image) {
      this.$modal.show('show-comment-image', {imgUrl: image});
    },

    //elements information
    // getMembersGroup() {
    //   if (this.convensationExisted) {
    //     ChatService.getMembersGroup({group_id: this.$route.params.messenger_id}).then(res => {
    //       if (res.data.length) {
    //         this.membersGroup = res.data.reverse();
    //         for (let i = 0; i < res.data.length; i++) {
    //           const text = '@' + res.data[i]['fullname']
    //           this.allTextMentions.push(text);
    //         }
    //       }
    //     });
    //   }
    // },

    //sidebar
    getChatInfo(item, activeTab) {
      const nextPanel = item === 'rule' || item === '' ? 'custom' : item;

      switch (nextPanel) {
        case 'search':
          this.titleInfomation = 'Tìm kiếm';
          break;
        case 'library':
          this.titleInfomation = 'Thư viện';
          break;
        case 'member':
          this.titleInfomation = `Thành viên (${this.chatGroupSelected.member_count})`;
          if (activeTab != null) {
            this.activeTabMember = activeTab;
          }
          break;
        case 'announcements':
          this.titleInfomation = 'Thông báo nhóm';
          break;
        case 'custom':
          this.titleInfomation = 'Tùy chỉnh';
          break;
        default:
          this.titleInfomation = '';
          break;
      }
      this.infomationChat = nextPanel;

      const selectedMenu = this.$store.state.chat.chatGroupSelected;
      if (
        selectedMenu
        && (selectedMenu.open_right_menu != null || selectedMenu.open_member_tab != null)
      ) {
        const item = { ...selectedMenu };
        delete item.open_right_menu;
        delete item.open_member_tab;
        this.$store.commit("chat/updateChatGroupSelected", item);
      }

    },

    hideCustomInfo() {
      this.infomationChat = 'custom';
      this.titleInfomation = 'Tùy chỉnh';
    },

    onFullAnnouncementListSelect(item) {
      if (!item || item.message_id == null) {
        return;
      }
      this.scrollToMessage(item.message_id);
      this.getChatInfo('custom');
    },

    updateNameGroupChat(name) {
      const chatGroupSelected = this.$store.state.chat.chatGroupSelected
      chatGroupSelected.name = name;
      delete chatGroupSelected.isCreateChat;
      this.$store.commit("chat/updateChatGroupSelected", chatGroupSelected);
    },


    async getChatGroups() {
      const params = {
        'page': 1,
        'per_page': 20,
        'status': "ALL"
      };
      await ChatService.getChatGroups(params).then(res => {
        if (res.data) {
          let data = res.data;
          this.$store.commit('chat/updateChatGroups', data);
          delete data[0].isCreateChat;
          this.$store.commit("chat/updateChatGroupSelected", data[0]);
        }
      });
    },

    checkMessageInBlock(item, index) {
      if (this.messageList[index + 1] == null) return false

      const senderNext = this.messageList[index + 1].sender;
      if (senderNext && senderNext.id !== item.sender.id) return false

      const current = moment(item.created_at)
      const next = moment(this.messageList[index + 1].created_at)
      const offset = next.diff(current, 'minutes')
      return offset < 4
    },

    getMessageTime(item) {
      return moment(item.created_at).format('HH:mm');
    },

    getMessageTimeCreated(item) {
      return moment(item.created_at).format('HH:mm, DD/MM/yyyy');
    },

    resolveMentionSpan(text, mention) {
      let start = Number(mention.off_set) || 0;
      let len = Number(mention.length) || 0;
      if (start < 0) start = 0;

      const originalEnd = Math.min(text.length, start + len);
      let slice = text.slice(start, originalEnd);

      if (slice && !slice.startsWith("@") && start > 0) {
        let atPos = start;
        while (atPos > 0 && text[atPos - 1] !== "@" && start - atPos < 6) {
          atPos--;
        }
        if (atPos > 0 && text[atPos - 1] === "@") {
          atPos--;
          start = atPos;
          len = originalEnd - start;
          slice = text.slice(start, start + len);
        }
      }

      const mentionUserId = Number(mention.mention_user_id);
      if (mentionUserId === 0) {
        const atIdx = text.lastIndexOf("@", Math.max(0, start + len - 1));
        if (atIdx >= 0 && atIdx <= start) {
          for (const candidate of ["@Tất cả", "@All"]) {
            if (text.slice(atIdx, atIdx + candidate.length) === candidate) {
              return { start: atIdx, end: atIdx + candidate.length, text: candidate };
            }
          }
        }
      }

      return { start, end: start + len, text: slice };
    },

    applyMentionsToMessageText(text, mentions) {
      const spans = [];
      const seenKeys = new Set();

      for (let i = 0; i < mentions.length; i++) {
        const mention = mentions[i];
        const key = `${mention.mention_user_id}-${mention.off_set}-${mention.length}`;
        if (seenKeys.has(key)) continue;
        seenKeys.add(key);

        const span = this.resolveMentionSpan(text, mention);
        if (!span.text) continue;
        spans.push({ ...span, id: mention.mention_user_id });
      }

      spans.sort((a, b) => a.start - b.start);

      let result = "";
      let cursor = 0;
      for (const span of spans) {
        if (span.start < cursor) continue;
        result += text.slice(cursor, span.start);
        if (span.id != 0) {
          result += "<a target='_blank' href='profile/" + span.id + "'><span class='cursor-pointer hover-link user-tag'>" + span.text + "</span></a>";
        } else {
          result += "<span class='cursor-pointer hover-link user-tag user-tag--all'>" + span.text + "</span>";
        }
        cursor = span.end;
      }
      result += text.slice(cursor);
      return result;
    },

    getMessageText: function (mess) {
      let text = mess?.text;
      if (typeof text !== "string" || text.trim() === "") return "***";

      if (mess.mentions && mess.mentions.length > 0) {
        text = this.applyMentionsToMessageText(text, mess.mentions);
      }

      if (this.tag_settings) {
        for (let i = 0; i < this.tag_settings.length; i++) {
          let keyword = this.tag_settings[i];
          let regex = new RegExp(keyword, 'gi');
          text = text.replace(regex, '<span id="searchText" class="cursor-pointer"><mark>$&</mark></span>');
        }
      }

      text = text.replace(/(^|\s)(#[\w\d]+)(\s|$)/g, '<span id="searchText" class="cursor-pointer">$1<mark>$2</mark>$3</span>');

      text = text.replace(/([^\s@]+@[^\s@]+\.[^\s@]+)/g, '<a target="_blank" href="mailto:$1">$1</a>');

      const urlRegex = /\bhttps?:[^,\s()<>]+(?:\([\w\d]+\)|([^,[:punct:]\s]|))/ig
      // /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])?[\w.-]+(?:\.[\w\.-]+)+/ig
      text = text.replace(urlRegex, function (url) {
        // tự động thêm http:// khi không có http | https
        // VD: facebook.com => http://facebook.com
        let pattern = /^((http|https):\/\/)/;
        let link_href = url;
        if (!pattern.test(url)) {
          link_href = "http://" + url;
        }
        return '<a target="_blank" href="' + link_href + '">' + url + '</a>';
      });

      text = text.replace(/(^|\s)(\d{2})(\d{2})(\d{4})-(\w{6})(\s|$)/g, (orderCode) => {
        let link = ordersDetailUrl(orderCode);
        return '<a target="_blank" href="'+ link +'">'+ orderCode +'</a>'
      });

      return text;
    },

    showFileSlideShow(files, index) {
      this.$modal.show('slide-show-modal', {items: files, activeId: index});
    },

    systemNoteMemberCount(mess) {
      if (!mess || mess.system_note == null) return 0;
      try {
        const parsed = JSON.parse(mess.system_note);
        return Array.isArray(parsed) ? parsed.length : 0;
      } catch (e) {
        return 0;
      }
    },

    systemNoteHasMultipleMembers(mess) {
      return this.systemNoteMemberCount(mess) > 1;
    },

    getConvensationExist() {
      let chatGroupSelected = this.$store.state.chat.chatGroupSelected;

      let isCreateChat = /^new\d+$/.test(this.$route.params.messenger_id);
      if (typeof chatGroupSelected.isCreateChat !== 'undefined' && chatGroupSelected.isCreateChat && isCreateChat) {
        this.convensationExisted = false;
        this.loadingGetDataMessageList = true;
      } else {
        this.convensationExisted = true;
      }

      messengerDebugLog('getConvensationExist', {
        routeId: this.$route.params.messenger_id,
        isCreateChatRoute: isCreateChat,
        selectedIsCreateChat: chatGroupSelected.isCreateChat,
        convensationExisted: this.convensationExisted,
      });
    },

    async messageRecall(mess_id, status) {
      const params = {
        chat_message_id: mess_id,
        delete_status: parseInt(status)
      }

      await ChatService.messageRecall(params).then(res => {
        if (res.status) {
          const recallStatus = Number(status);
          this.messageList.forEach((mess) => {
            if (mess.id === mess_id) {
              this.$set(mess, 'delete_status', recallStatus);
            }
          });
          let chatGroups = this.$store.state.chat.chatGroups;
          chatGroups.forEach((item) => {
            if (String(item.id) === String(this.$route.params.messenger_id) && item.last_message) {
              this.$set(item.last_message, 'delete_status', recallStatus);
            }
          });

          this.$store.commit('chat/updateChatGroups', chatGroups);
        }
      });
    },

    showConfirmDeletePost(mess_id, status) {

      const title = status == 2 ? 'Thu hồi tin nhắn' : 'Xóa tin nhắn';

      this.$modal.show('dialog', {
        title: title,
        text: 'Bạn có chắc muốn ' + title.toLowerCase(),
        buttons: [
          {
            title: 'Không',
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title: status == 2 ? 'Thu hồi' : 'Xóa',
            handler: () => {
              this.messageRecall(mess_id, status);
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },

    messageBodyRowClass(mess) {
      if (mess.type === MESSAGE_CHAT_TYPE.ANNOUNCEMENT) {
        return 'announcement-center';
      }
      return mess.sender && mess.sender.id === this.user.id ? 'mine' : 'opposite';
    },

    editMessage(message){
      if (message.type === MESSAGE_CHAT_TYPE.ANNOUNCEMENT) {
        this.openAnnouncementEdit(message);
        return;
      }
      message = {...message, ...{type: MESSAGE_CHAT_TYPE.TEXT}};
      this.replyMessager.active = true;
      this.replyMessager.message = message;
      this.form_input.message = message.text
      this.form_input.isEdit = true;
      this.form.message_id = message.id;
      this.setHeightChatContent();
      this.$refs.scrollBottomAnchor.style.bottom = '160px';
    },

    openAnnouncementModal() {
      this.clearAnnouncementModalAttachments();
      this.announcementForm.isEdit = false;
      this.announcementForm.messageId = null;
      this.announcementForm.title = '';
      this.announcementForm.messageText = '';
      this.announcementForm.expiresAtLocal = '';
      this.announcementForm.payloadFields = [];
      this.$modal.show('announcement-compose-modal');
    },

    openAnnouncementEdit(message) {
      this.announcementForm.isEdit = true;
      this.announcementForm.messageId = message.id;
      this.announcementForm.title = (message.announcement && message.announcement.title) || '';
      this.announcementForm.messageText = message.text != null ? String(message.text) : '';
      const exp = message.announcement && message.announcement.expires_at;
      this.announcementForm.expiresAtLocal = exp ? moment(exp).format('YYYY-MM-DDTHH:mm') : '';
      this.announcementForm.payloadFields = [];
      try {
        const raw = (message.announcement && message.announcement.payload) || {};
        const data = raw && typeof raw.data === 'object' && raw.data !== null && !Array.isArray(raw.data) ? raw.data : {};
        Object.keys(data).forEach((k) => {
          this.announcementForm.payloadFields.push({
            id: this.nextAnnouncementPayloadRowId(),
            key: k,
            value: this.announcementPayloadValueToEditString(data[k]),
          });
        });
      } catch (e) {
        this.announcementForm.payloadFields = [];
      }
      this.hydrateAnnouncementMediasFromMessage(message);
      this.$modal.show('announcement-compose-modal');
    },

    nextAnnouncementPayloadRowId() {
      return `apf_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
    },

    announcementPayloadValueToEditString(val) {
      if (val === null || val === undefined) return '';
      if (typeof val === 'object') {
        try {
          return JSON.stringify(val);
        } catch (e) {
          return String(val);
        }
      }
      return String(val);
    },

    addAnnouncementPayloadRow() {
      this.announcementForm.payloadFields.push({
        id: this.nextAnnouncementPayloadRowId(),
        key: '',
        value: '',
      });
    },

    removeAnnouncementPayloadRow(id) {
      this.announcementForm.payloadFields = this.announcementForm.payloadFields.filter((r) => r.id !== id);
    },

    buildAnnouncementPayloadFromFields() {
      const data = {};
      this.announcementForm.payloadFields.forEach((row) => {
        const k = (row.key || '').trim();
        if (!k) return;
        data[k] = row.value != null ? String(row.value) : '';
      });
      return { data };
    },

    announcementPayloadDataEntries(mess) {
      const p = mess.announcement && mess.announcement.payload;
      if (!p || typeof p !== 'object' || Array.isArray(p)) return [];
      const raw = p.data;
      if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return [];
      return Object.keys(raw).map((key) => ({ key, value: raw[key] }));
    },

    formatAnnouncementDataValue(val) {
      if (val === null || val === undefined) return '';
      if (typeof val === 'object') {
        try {
          return JSON.stringify(val, null, 2);
        } catch (e) {
          return String(val);
        }
      }
      return String(val);
    },

    /** Linkify URL/email trong nội dung thông báo (ANNOUNCEMENT dùng plain text, không qua getMessageText). */
    linkifyAnnouncementText(raw) {
      if (raw == null) return '';
      let text = String(raw);
      text = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

      text = text.replace(/([^\s@]+@[^\s@]+\.[^\s@]+)/g, '<a target="_blank" rel="noopener noreferrer" href="mailto:$1">$1</a>');

      const urlRegex = /\bhttps?:[^,\s()<>]+(?:\([\w\d]+\)|([^,[:punct:]\s]|))/ig;
      text = text.replace(urlRegex, (url) => {
        let href = url;
        if (!/^https?:\/\//i.test(url)) {
          href = 'http://' + url;
        }
        return `<a target="_blank" rel="noopener noreferrer" href="${href}">${url}</a>`;
      });

      return text;
    },

    /** Nội dung hiển thị từ cột chat_message.text (không đọc payload.message). Ẩn nếu trùng tiêu đề (bản ghi cũ). */
    announcementTableMessage(mess) {
      const txt = mess.text;
      if (txt == null || String(txt).trim() === '') return '';
      const title = mess.announcement && mess.announcement.title;
      if (title != null && String(txt).trim() === String(title).trim()) return '';
      return String(txt);
    },

    /** Parse link preview JSON cho thông báo (an toàn khi API trả object hoặc chuỗi). */
    announcementLinkMetadata(mess) {
      if (!mess || mess.link_metadata == null) return null;
      const raw = mess.link_metadata;
      if (typeof raw === 'object' && !Array.isArray(raw)) return raw;
      if (typeof raw !== 'string') return null;
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    },

    /** Ảnh / video / file đính kèm thông báo (theo file đầu tiên). */
    announcementAttachmentKind(mess) {
      if (!mess || !Array.isArray(mess.files) || !mess.files.length) return null;
      const f = mess.files[0];
      if (!f) return null;
      const ext = String(f.extension || '').toLowerCase();
      const mime = String(f.mime_type || f.type || '').toLowerCase();
      if (mime.startsWith('image/')) return 'image';
      if (mime.startsWith('video/')) return 'video';
      const img = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
      const vid = ['mp4', 'mpeg', 'mov', 'webm', 'm4v', 'avi'];
      if (img.includes(ext)) return 'image';
      if (vid.includes(ext)) return 'video';
      return 'file';
    },

    formatAnnouncementExpires(iso) {
      if (!iso) return '';
      return moment(iso).format('DD/MM/YYYY HH:mm');
    },

    announcementIsExpiredLive(mess) {
      void this.announcementCountdownTick;
      const iso = mess.announcement && mess.announcement.expires_at;
      if (!iso) return false;
      return !moment(iso).isAfter(moment());
    },

    /** Badge cạnh THÔNG BÁO: "Hết hạn" hoặc "Còn … ngày … giờ … phút" (có cập nhật mỗi giây). */
    announcementExpiryBadgeText(mess) {
      void this.announcementCountdownTick;
      const iso = mess.announcement && mess.announcement.expires_at;
      if (!iso) return '';
      const end = moment(iso);
      const now = moment();
      if (!end.isAfter(now)) {
        return 'Hết hạn';
      }
      let sec = Math.max(0, end.diff(now, 'seconds'));
      const d = Math.floor(sec / 86400);
      sec -= d * 86400;
      const h = Math.floor(sec / 3600);
      sec -= h * 3600;
      const m = Math.floor(sec / 60);
      const s = sec % 60;
      const parts = [];
      if (d > 0) parts.push(`${d} ngày`);
      if (h > 0) parts.push(`${h} giờ`);
      if (m > 0) parts.push(`${m} phút`);
      if (parts.length === 0) {
        return `Còn ${s} giây`;
      }
      if (d === 0 && h === 0 && s > 0) {
        parts.push(`${s} giây`);
      }
      return `Còn ${parts.join(' ')}`;
    },

    async submitAnnouncementFromModal() {
      const title = (this.announcementForm.title || '').trim();
      if (!title) {
        this.$store.dispatch('alerts/error', 'Vui lòng nhập tiêu đề');
        return;
      }
      const payload = this.buildAnnouncementPayloadFromFields();

      const bodyText = this.announcementForm.messageText != null ? String(this.announcementForm.messageText) : '';

      const expiresLocal = this.announcementForm.expiresAtLocal;
      const expiresOut = expiresLocal
        ? moment(expiresLocal).format('YYYY-MM-DD HH:mm:ss')
        : null;

      this.$modal.hide('announcement-compose-modal');

      if (this.announcementForm.isEdit) {
        const form = {
          message_id: this.announcementForm.messageId,
          message: bodyText,
          announcement_title: title,
          announcement_expires_at: expiresOut,
          announcement_payload: payload,
          announcement_schema_version: 1,
          group_id: this.form.group_id,
          file_ids: this.announcementFileIds.slice(),
        };
        await ChatService.editMessageChat(form).then((res) => {
            if (res.status) {
            this.messageList.map((mess) => {
              if (mess.id === res.data.id) {
                mess.history_message = res.data.history_message;
                mess.text = res.data.text;
                mess.announcement = res.data.announcement;
                if (Array.isArray(res.data.files)) {
                  mess.files = res.data.files;
                }
              }
            });
          }
        });
        return;
      }

      const sendForm = {
        ...this.form,
        type: MESSAGE_CHAT_TYPE.ANNOUNCEMENT,
        message: bodyText,
        announcement_title: title,
        announcement_expires_at: expiresOut,
        announcement_payload: payload,
        announcement_schema_version: 1,
        mobile_local_id: Date.now().toString(),
        file_ids: this.announcementFileIds.slice(),
        reply_to_msg_id: null,
        mentions: [],
        _optimistic_files: this.announcementMedias.slice(),
      };
      await this.createMessage(sendForm);
    },

    emojis(reaction_stats) {
      return {
        1: 'like',
        2: 'love',
        3: 'care',
        4: 'haha',
        5: 'wow',
        6: 'sad',
        7: 'angry'
      };
    },

    async reactionMessage(message_id, emoji, icon_id) {

      const params = {
        type: parseInt(icon_id),
        message_id: message_id
      }

      // const emojiList = this.emojis();

      this.messageList.map((mess, index) => {
        if (mess.id === message_id) {
          let data = mess.reaction_stats;
          mess.reaction_stats[emoji] = data[emoji] + 1;
          mess.is_acc_mention = 1;
        }
      });

      //hide popup icon
      this.hideDropDown();

      await ChatService.reactionMessage(params).then(res => {
        if (res.status) {
          // this.messageList.map((mess, index) => {
          //   if (mess.sender.id === this.user.id&& mess.id === message_id) {
          //     let data = mess.reaction_stats;
          //     mess.reaction_stats[emoji] = data[emoji] + 1;
          //   }
          // });
        }
      });
    },

    dropDownAction(elementId = false, block = '') {
      this.cancelHideMessageActions();
      let isMore = false;
      let isEmoji = false;

      if (block == 'more') {
        isMore = elementId;
        isEmoji = false;
      } else {
        isEmoji = elementId;
        isMore = false;
      }

      this.dropDown.more = isMore;
      this.dropDown.emoji = isEmoji;
      this.menuOther = null;
    },

    isMessageActionsOpen(messageId) {
      if (messageId == null) {
        return false;
      }
      return this.dropDown.emoji === messageId || this.dropDown.more === messageId || this.menuOther === messageId;
    },

    cancelHideMessageActions() {
      if (this.hideMessageActionsTimer) {
        clearTimeout(this.hideMessageActionsTimer);
        this.hideMessageActionsTimer = null;
      }
    },

    scheduleHideMessageActions(e) {
      const related = e && e.relatedTarget;
      if (related && typeof related.closest === 'function') {
        if (related.closest('.historyAction') || related.closest('.actionPopup')) {
          return;
        }
      }
      this.cancelHideMessageActions();
      this.hideMessageActionsTimer = setTimeout(() => {
        this.hideMessageActionsTimer = null;
        this.hideDropDown();
      }, 180);
    },

    isOnlyOneEmoji(s) {
      var EmojiPattern = /^(?:\uD83D(?:\uDD73\uFE0F?|\uDC41(?:(?:\uFE0F(?:\u200D\uD83D\uDDE8\uFE0F?)?|\u200D\uD83D\uDDE8\uFE0F?))?|[\uDDE8\uDDEF]\uFE0F?|\uDC4B(?:\uD83C[\uDFFB-\uDFFF])?|\uDD90(?:(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F))?|[\uDD96\uDC4C\uDC48\uDC49\uDC46\uDD95\uDC47\uDC4D\uDC4E\uDC4A\uDC4F\uDE4C\uDC50\uDE4F\uDC85\uDCAA\uDC42\uDC43\uDC76\uDC66\uDC67](?:\uD83C[\uDFFB-\uDFFF])?|\uDC71(?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2640\u2642]\uFE0F?))?)|\u200D(?:[\u2640\u2642]\uFE0F?)))?|\uDC68(?:(?:\uD83C(?:\uDFFB(?:\u200D(?:\uD83E(?:\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF]|[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD])|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92]|\u2708\uFE0F?))?|\uDFFC(?:\u200D(?:\uD83E(?:\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF]|[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD])|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92]|\u2708\uFE0F?))?|\uDFFD(?:\u200D(?:\uD83E(?:\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD])|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92]|\u2708\uFE0F?))?|\uDFFE(?:\u200D(?:\uD83E(?:\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF]|[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD])|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92]|\u2708\uFE0F?))?|\uDFFF(?:\u200D(?:\uD83E(?:\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE]|[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD])|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92]|\u2708\uFE0F?))?)|\u200D(?:\uD83E[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD]|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D(?:\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uDC68\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92])|\u2708\uFE0F?|\u2764(?:\uFE0F\u200D\uD83D(?:\uDC8B\u200D\uD83D\uDC68|\uDC68)|\u200D\uD83D(?:\uDC8B\u200D\uD83D\uDC68|\uDC68)))))?|\uDC69(?:(?:\uD83C(?:\uDFFB(?:\u200D(?:\uD83E(?:\uDD1D\u200D\uD83D(?:\uDC69\uD83C[\uDFFC-\uDFFF]|\uDC68\uD83C[\uDFFC-\uDFFF])|[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD])|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92]|\u2708\uFE0F?))?|\uDFFC(?:\u200D(?:\uD83E(?:\uDD1D\u200D\uD83D(?:\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF]|\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])|[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD])|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92]|\u2708\uFE0F?))?|\uDFFD(?:\u200D(?:\uD83E(?:\uDD1D\u200D\uD83D(?:\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD])|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92]|\u2708\uFE0F?))?|\uDFFE(?:\u200D(?:\uD83E(?:\uDD1D\u200D\uD83D(?:\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF]|\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])|[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD])|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92]|\u2708\uFE0F?))?|\uDFFF(?:\u200D(?:\uD83E(?:\uDD1D\u200D\uD83D(?:\uDC69\uD83C[\uDFFB-\uDFFE]|\uDC68\uD83C[\uDFFB-\uDFFE])|[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD])|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92]|\u2708\uFE0F?))?)|\u200D(?:\uD83E[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD]|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D(?:\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92])|\u2708\uFE0F?|\u2764(?:\uFE0F\u200D\uD83D(?:\uDC8B\u200D\uD83D[\uDC68\uDC69]|[\uDC68\uDC69])|\u200D\uD83D(?:\uDC8B\u200D\uD83D[\uDC68\uDC69]|[\uDC68\uDC69])))))?|[\uDC74\uDC75](?:\uD83C[\uDFFB-\uDFFF])?|[\uDE4D\uDE4E\uDE45\uDE46\uDC81\uDE4B\uDE47\uDC6E](?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|\uDD75(?:(?:\uFE0F(?:\u200D(?:[\u2642\u2640]\uFE0F?))?|\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|[\uDC82\uDC77](?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|\uDC78(?:\uD83C[\uDFFB-\uDFFF])?|\uDC73(?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|[\uDC72\uDC70\uDC7C](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC86\uDC87\uDEB6](?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|[\uDC83\uDD7A](?:\uD83C[\uDFFB-\uDFFF])?|\uDD74(?:(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F))?|\uDC6F(?:\u200D(?:[\u2642\u2640]\uFE0F?))?|[\uDEA3\uDEB4\uDEB5](?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|[\uDEC0\uDECC\uDC6D\uDC6B\uDC6C](?:\uD83C[\uDFFB-\uDFFF])?|\uDDE3\uFE0F?|\uDC15(?:\u200D\uD83E\uDDBA)?|[\uDC3F\uDD4A\uDD77\uDD78\uDDFA\uDEE3\uDEE4\uDEE2\uDEF3\uDEE5\uDEE9\uDEF0\uDECE\uDD70\uDD79\uDDBC\uDD76\uDECD\uDDA5\uDDA8\uDDB1\uDDB2\uDCFD\uDD6F\uDDDE\uDDF3\uDD8B\uDD8A\uDD8C\uDD8D\uDDC2\uDDD2\uDDD3\uDD87\uDDC3\uDDC4\uDDD1\uDDDD\uDEE0\uDDE1\uDEE1\uDDDC\uDECF\uDECB\uDD49]\uFE0F?|[\uDE00\uDE03\uDE04\uDE01\uDE06\uDE05\uDE02\uDE42\uDE43\uDE09\uDE0A\uDE07\uDE0D\uDE18\uDE17\uDE1A\uDE19\uDE0B\uDE1B-\uDE1D\uDE10\uDE11\uDE36\uDE0F\uDE12\uDE44\uDE2C\uDE0C\uDE14\uDE2A\uDE34\uDE37\uDE35\uDE0E\uDE15\uDE1F\uDE41\uDE2E\uDE2F\uDE32\uDE33\uDE26-\uDE28\uDE30\uDE25\uDE22\uDE2D\uDE31\uDE16\uDE23\uDE1E\uDE13\uDE29\uDE2B\uDE24\uDE21\uDE20\uDE08\uDC7F\uDC80\uDCA9\uDC79-\uDC7B\uDC7D\uDC7E\uDE3A\uDE38\uDE39\uDE3B-\uDE3D\uDE40\uDE3F\uDE3E\uDE48-\uDE4A\uDC8B\uDC8C\uDC98\uDC9D\uDC96\uDC97\uDC93\uDC9E\uDC95\uDC9F\uDC94\uDC9B\uDC9A\uDC99\uDC9C\uDDA4\uDCAF\uDCA2\uDCA5\uDCAB\uDCA6\uDCA8\uDCA3\uDCAC\uDCAD\uDCA4\uDC40\uDC45\uDC44\uDC8F\uDC91\uDC6A\uDC64\uDC65\uDC63\uDC35\uDC12\uDC36\uDC29\uDC3A\uDC31\uDC08\uDC2F\uDC05\uDC06\uDC34\uDC0E\uDC2E\uDC02-\uDC04\uDC37\uDC16\uDC17\uDC3D\uDC0F\uDC11\uDC10\uDC2A\uDC2B\uDC18\uDC2D\uDC01\uDC00\uDC39\uDC30\uDC07\uDC3B\uDC28\uDC3C\uDC3E\uDC14\uDC13\uDC23-\uDC27\uDC38\uDC0A\uDC22\uDC0D\uDC32\uDC09\uDC33\uDC0B\uDC2C\uDC1F-\uDC21\uDC19\uDC1A\uDC0C\uDC1B-\uDC1E\uDC90\uDCAE\uDD2A\uDDFE\uDDFB\uDC92\uDDFC\uDDFD\uDD4C\uDED5\uDD4D\uDD4B\uDC88\uDE82-\uDE8A\uDE9D\uDE9E\uDE8B-\uDE8E\uDE90-\uDE9C\uDEF5\uDEFA\uDEB2\uDEF4\uDEF9\uDE8F\uDEA8\uDEA5\uDEA6\uDED1\uDEA7\uDEF6\uDEA4\uDEA2\uDEEB\uDEEC\uDCBA\uDE81\uDE9F-\uDEA1\uDE80\uDEF8\uDD5B\uDD67\uDD50\uDD5C\uDD51\uDD5D\uDD52\uDD5E\uDD53\uDD5F\uDD54\uDD60\uDD55\uDD61\uDD56\uDD62\uDD57\uDD63\uDD58\uDD64\uDD59\uDD65\uDD5A\uDD66\uDD25\uDCA7\uDEF7\uDD2E\uDC53-\uDC62\uDC51\uDC52\uDCFF\uDC84\uDC8D\uDC8E\uDD07-\uDD0A\uDCE2\uDCE3\uDCEF\uDD14\uDD15\uDCFB\uDCF1\uDCF2\uDCDE-\uDCE0\uDD0B\uDD0C\uDCBB\uDCBD-\uDCC0\uDCFA\uDCF7-\uDCF9\uDCFC\uDD0D\uDD0E\uDCA1\uDD26\uDCD4-\uDCDA\uDCD3\uDCD2\uDCC3\uDCDC\uDCC4\uDCF0\uDCD1\uDD16\uDCB0\uDCB4-\uDCB8\uDCB3\uDCB9\uDCB1\uDCB2\uDCE7-\uDCE9\uDCE4-\uDCE6\uDCEB\uDCEA\uDCEC-\uDCEE\uDCDD\uDCBC\uDCC1\uDCC2\uDCC5-\uDCD0\uDD12\uDD13\uDD0F-\uDD11\uDD28\uDD2B\uDD27\uDD29\uDD17\uDD2C\uDD2D\uDCE1\uDC89\uDC8A\uDEAA\uDEBD\uDEBF\uDEC1\uDED2\uDEAC\uDDFF\uDEAE\uDEB0\uDEB9-\uDEBC\uDEBE\uDEC2-\uDEC5\uDEB8\uDEAB\uDEB3\uDEAD\uDEAF\uDEB1\uDEB7\uDCF5\uDD1E\uDD03\uDD04\uDD19-\uDD1D\uDED0\uDD4E\uDD2F\uDD00-\uDD02\uDD3C\uDD3D\uDD05\uDD06\uDCF6\uDCF3\uDCF4\uDD31\uDCDB\uDD30\uDD1F-\uDD24\uDD34\uDFE0-\uDFE2\uDD35\uDFE3-\uDFE5\uDFE7-\uDFE9\uDFE6\uDFEA\uDFEB\uDD36-\uDD3B\uDCA0\uDD18\uDD33\uDD32\uDEA9])|\uD83E(?:[\uDD1A\uDD0F\uDD1E\uDD1F\uDD18\uDD19\uDD1B\uDD1C\uDD32\uDD33\uDDB5\uDDB6\uDDBB\uDDD2](?:\uD83C[\uDFFB-\uDFFF])?|\uDDD1(?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:\uD83E(?:\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD])|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92]|\u2708\uFE0F?))?)|\u200D(?:\uD83E(?:\uDD1D\u200D\uD83E\uDDD1|[\uDDB0\uDDB1\uDDB3\uDDB2\uDDAF\uDDBC\uDDBD])|\u2695\uFE0F?|\uD83C[\uDF93\uDFEB\uDF3E\uDF73\uDFED\uDFA4\uDFA8]|\u2696\uFE0F?|\uD83D[\uDD27\uDCBC\uDD2C\uDCBB\uDE80\uDE92]|\u2708\uFE0F?)))?|[\uDDD4\uDDD3](?:\uD83C[\uDFFB-\uDFFF])?|[\uDDCF\uDD26\uDD37](?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|[\uDD34\uDDD5\uDD35\uDD30\uDD31\uDD36](?:\uD83C[\uDFFB-\uDFFF])?|[\uDDB8\uDDB9\uDDD9-\uDDDD](?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|[\uDDDE\uDDDF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?|[\uDDCD\uDDCE\uDDD6\uDDD7\uDD38](?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|\uDD3C(?:\u200D(?:[\u2642\u2640]\uFE0F?))?|[\uDD3D\uDD3E\uDD39\uDDD8](?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|[\uDD23\uDD70\uDD29\uDD2A\uDD11\uDD17\uDD2D\uDD2B\uDD14\uDD10\uDD28\uDD25\uDD24\uDD12\uDD15\uDD22\uDD2E\uDD27\uDD75\uDD76\uDD74\uDD2F\uDD20\uDD73\uDD13\uDDD0\uDD7A\uDD71\uDD2C\uDD21\uDD16\uDDE1\uDD0E\uDD0D\uDD1D\uDDBE\uDDBF\uDDE0\uDDB7\uDDB4\uDD3A\uDDB0\uDDB1\uDDB3\uDDB2\uDD8D\uDDA7\uDDAE\uDD8A\uDD9D\uDD81\uDD84\uDD93\uDD8C\uDD99\uDD92\uDD8F\uDD9B\uDD94\uDD87\uDDA5\uDDA6\uDDA8\uDD98\uDDA1\uDD83\uDD85\uDD86\uDDA2\uDD89\uDDA9\uDD9A\uDD9C\uDD8E\uDD95\uDD96\uDD88\uDD8B\uDD97\uDD82\uDD9F\uDDA0\uDD40\uDD6D\uDD5D\uDD65\uDD51\uDD54\uDD55\uDD52\uDD6C\uDD66\uDDC4\uDDC5\uDD5C\uDD50\uDD56\uDD68\uDD6F\uDD5E\uDDC7\uDDC0\uDD69\uDD53\uDD6A\uDD59\uDDC6\uDD5A\uDD58\uDD63\uDD57\uDDC8\uDDC2\uDD6B\uDD6E\uDD5F-\uDD61\uDD80\uDD9E\uDD90\uDD91\uDDAA\uDDC1\uDD67\uDD5B\uDD42\uDD43\uDD64\uDDC3\uDDC9\uDDCA\uDD62\uDD44\uDDED\uDDF1\uDDBD\uDDBC\uDE82\uDDF3\uDE90\uDDE8\uDDE7\uDD47-\uDD49\uDD4E\uDD4F\uDD4D\uDD4A\uDD4B\uDD45\uDD3F\uDD4C\uDE80\uDE81\uDDFF\uDDE9\uDDF8\uDDF5\uDDF6\uDD7D\uDD7C\uDDBA\uDDE3-\uDDE6\uDD7B\uDE71-\uDE73\uDD7E\uDD7F\uDE70\uDDE2\uDE95\uDD41\uDDEE\uDE94\uDDFE\uDE93\uDDAF\uDDF0\uDDF2\uDDEA-\uDDEC\uDE78-\uDE7A\uDE91\uDE92\uDDF4\uDDF7\uDDF9-\uDDFD\uDDEF])|[\u263A\u2639\u2620\u2763\u2764]\uFE0F?|\u270B(?:\uD83C[\uDFFB-\uDFFF])?|[\u270C\u261D](?:(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F))?|\u270A(?:\uD83C[\uDFFB-\uDFFF])?|\u270D(?:(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F))?|\uD83C(?:\uDF85(?:\uD83C[\uDFFB-\uDFFF])?|\uDFC3(?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|[\uDFC7\uDFC2](?:\uD83C[\uDFFB-\uDFFF])?|\uDFCC(?:(?:\uFE0F(?:\u200D(?:[\u2642\u2640]\uFE0F?))?|\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|[\uDFC4\uDFCA](?:(?:\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|\uDFCB(?:(?:\uFE0F(?:\u200D(?:[\u2642\u2640]\uFE0F?))?|\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|[\uDFF5\uDF36\uDF7D\uDFD4-\uDFD6\uDFDC-\uDFDF\uDFDB\uDFD7\uDFD8\uDFDA\uDFD9\uDFCE\uDFCD\uDF21\uDF24-\uDF2C\uDF97\uDF9F\uDF96\uDF99-\uDF9B\uDF9E\uDFF7\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37]\uFE0F?|\uDFF4(?:(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F|\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F|\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F)))?|\uDFF3(?:(?:\uFE0F(?:\u200D\uD83C\uDF08)?|\u200D\uD83C\uDF08))?|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|[\uDFFB-\uDFFF\uDF38-\uDF3C\uDF37\uDF31-\uDF35\uDF3E-\uDF43\uDF47-\uDF53\uDF45\uDF46\uDF3D\uDF44\uDF30\uDF5E\uDF56\uDF57\uDF54\uDF5F\uDF55\uDF2D-\uDF2F\uDF73\uDF72\uDF7F\uDF71\uDF58-\uDF5D\uDF60\uDF62-\uDF65\uDF61\uDF66-\uDF6A\uDF82\uDF70\uDF6B-\uDF6F\uDF7C\uDF75\uDF76\uDF7E\uDF77-\uDF7B\uDF74\uDFFA\uDF0D-\uDF10\uDF0B\uDFE0-\uDFE6\uDFE8-\uDFED\uDFEF\uDFF0\uDF01\uDF03-\uDF07\uDF09\uDFA0-\uDFA2\uDFAA\uDF11-\uDF20\uDF0C\uDF00\uDF08\uDF02\uDF0A\uDF83\uDF84\uDF86-\uDF8B\uDF8D-\uDF91\uDF80\uDF81\uDFAB\uDFC6\uDFC5\uDFC0\uDFD0\uDFC8\uDFC9\uDFBE\uDFB3\uDFCF\uDFD1-\uDFD3\uDFF8\uDFA3\uDFBD\uDFBF\uDFAF\uDFB1\uDFAE\uDFB0\uDFB2\uDCCF\uDC04\uDFB4\uDFAD\uDFA8\uDF92\uDFA9\uDF93\uDFBC\uDFB5\uDFB6\uDFA4\uDFA7\uDFB7-\uDFBB\uDFA5\uDFAC\uDFEE\uDFF9\uDFE7\uDFA6\uDD8E\uDD91-\uDD9A\uDE01\uDE36\uDE2F\uDE50\uDE39\uDE1A\uDE32\uDE51\uDE38\uDE34\uDE33\uDE3A\uDE35\uDFC1\uDF8C])|\u26F7\uFE0F?|\u26F9(?:(?:\uFE0F(?:\u200D(?:[\u2642\u2640]\uFE0F?))?|\uD83C(?:[\uDFFB-\uDFFF](?:\u200D(?:[\u2642\u2640]\uFE0F?))?)|\u200D(?:[\u2642\u2640]\uFE0F?)))?|[\u2618\u26F0\u26E9\u2668\u26F4\u2708\u23F1\u23F2\u2600\u2601\u26C8\u2602\u26F1\u2744\u2603\u2604\u26F8\u2660\u2665\u2666\u2663\u265F\u26D1\u260E\u2328\u2709\u270F\u2712\u2702\u26CF\u2692\u2694\u2699\u2696\u26D3\u2697\u26B0\u26B1\u26A0\u2622\u2623\u2B06\u2197\u27A1\u2198\u2B07\u2199\u2B05\u2196\u2195\u2194\u21A9\u21AA\u2934\u2935\u269B\u2721\u2638\u262F\u271D\u2626\u262A\u262E\u25B6\u23ED\u23EF\u25C0\u23EE\u23F8-\u23FA\u23CF\u2640\u2642\u2695\u267E\u267B\u269C\u2611\u2714\u2716\u303D\u2733\u2734\u2747\u203C\u2049\u3030\u00A9\u00AE\u2122]\uFE0F?|[\u0023\u002A\u0030-\u0039](?:\uFE0F\u20E3|\u20E3)|[\u2139\u24C2\u3297\u3299\u25FC\u25FB\u25AA\u25AB]\uFE0F?|[\u2615\u26EA\u26F2\u26FA\u26FD\u2693\u26F5\u231B\u23F3\u231A\u23F0\u2B50\u26C5\u2614\u26A1\u26C4\u2728\u26BD\u26BE\u26F3\u267F\u26D4\u2648-\u2653\u26CE\u23E9-\u23EC\u2B55\u2705\u274C\u274E\u2795-\u2797\u27B0\u27BF\u2753-\u2755\u2757\u26AB\u26AA\u2B1B\u2B1C\u25FE\u25FD])$/;
      return EmojiPattern.test(s);
    },

    hideDropDown(e) {
      this.cancelHideMessageActions();
      this.dropDown.more = false;
      this.dropDown.emoji = false;
      this.menuOther = null;
    },

    reachedEndOfListForMessage(reached, entry) {
      if (reached && !this.hasScrolledToBottom && this.hasMoreOlderMessages && !this.loadingOnScroll) {
        this.getMessageList(this.params, true, 'older');
      }
    },

    resetMessageListParams() {
      this.params.page = 1;
      delete this.params.last_message_id;
      this.messageLastPage = 1;
      this.hasMoreOlderMessages = true;
      this.onScrollMessageId = null;
    },

    resetParam() {
      this.resetMessageListParams();
    },

    replyChat(message) {
      this.replyMessager.active = true;
      this.replyMessager.message = message;
      this.form.reply_to_msg_id = message.id
      this.setHeightChatContent();
      this.setScrollBottomOffset(160);
      $('#input-chat').focus();
    },

    closeReplyTemplate() {
      this.replyMessager.active = false;
      this.replyMessager.message = [];
      this.form.reply_to_msg_id = null;
      if(this.form_input.isEdit){
        this.form_input.message = '';
        this.form_input.isEdit = false;
        this.form.message_id = null;
      }
      this.setHeightChatContent();
      this.setScrollBottomOffset(100);
    },

    /**
     * Auto-grow textarea: gộp nhiều sự kiện input trong một animation frame;
     * đồng bộ chiều cao footer / chat-content debounce để không gọi jQuery/DOM liên tục.
     */
    resizeTextarea() {
      if (this.resizeTextareaRafId != null) {
        cancelAnimationFrame(this.resizeTextareaRafId);
      }
      this.resizeTextareaRafId = requestAnimationFrame(() => {
        this.resizeTextareaRafId = null;
        this.applyTextareaResize();
      });
    },

    applyTextareaResize() {
      const element = this.$refs["textareaMessage"];
      const layout = this.$refs["resizeLayout"];
      if (!element || !element.$el || !layout || !layout.$el) {
        return;
      }
      const el = element.$el;
      const maxH = 180;
      el.style.height = "5px";
      const sh = el.scrollHeight;
      const nextH = Math.min(sh, maxH);
      el.style.height = `${nextH}px`;

      layout.$el.style.height = `${nextH + this.chatComposerFieldChromePx}px`;
      if (this.$store.state.chat.chatGroupSelected.type === "GROUP") {
        const mentionable = this.$el.querySelector(".reply-section .mentionable");
        if (mentionable) {
          mentionable.style.height = `${Math.max(this.chatComposerTextareaMinPx, nextH)}px`;
        }
      }
      const hl = $(el).data("highlighter");
      if (hl) hl.updateSizePosition(true);

      this.scheduleChatFooterLayoutSync();
    },

    scheduleChatFooterLayoutSync() {
      if (this.footerLayoutDebounceTimer != null) {
        clearTimeout(this.footerLayoutDebounceTimer);
      }
      this.footerLayoutDebounceTimer = setTimeout(() => {
        this.footerLayoutDebounceTimer = null;
        const footer = document.getElementsByClassName('chat-footer')[0];
        if (footer) {
          this.setScrollBottomOffset(footer.offsetHeight + 20);
        }
        this.setHeightChatContent();
      }, 100);
    },


    setHeightChatContent() {
      this.$nextTick(() => {
        const messager = this.$refs.messager;
        const chatContent = document.getElementById('chat-content');
        const footer = document.getElementsByClassName('chat-footer')[0];
        if (!messager || !chatContent || !footer) {
          return;
        }
        let pinHeight = 0;
        const pinEl = messager.querySelector('.pin-message-container, .pinned-message, [class*="pin-message"]');
        if (pinEl) {
          pinHeight = pinEl.offsetHeight || 0;
        }
        const available = messager.clientHeight - footer.offsetHeight - pinHeight - 4;
        chatContent.style.height = `${Math.max(120, available)}px`;
      });
    },

    async scrollToMessage(message_id) {
      this.hasScrolledToBottom = false;
      const messageId = Number(message_id);
      const inList = this.messageList.some((element) => Number(element.id) === messageId);
      if (!inList) {
        this.onScrollMessageId = message_id;
        this.scrollAnimaiton = true;

        let safety = 0;
        while (
          !this.messageList.some((element) => Number(element.id) === messageId) &&
          this.hasMoreOlderMessages &&
          safety < CHAT_SCROLL_TO_MESSAGE_MAX_FETCHES
        ) {
          safety += 1;
          await this.getMessageList(this.params, true, 'older');
        }

        if (!this.messageList.some((element) => Number(element.id) === messageId)) {
          this.onScrollMessageId = null;
          this.scrollAnimaiton = false;
          this.$store.dispatch(
            "alerts/error",
            "Không tìm thấy tin nhắn trong phạm vi đã tải. Hãy cuộn lên để tải thêm.",
          );
          return;
        }
      }

      const scrollWhenReady = (attempt = 0) => {
        const elementId = document.getElementById(`message-${message_id}`);
        if (elementId) {
          elementId.scrollIntoView({ behavior: 'smooth' });
          elementId.classList.add('shake');
          setTimeout(() => {
            elementId.classList.remove('shake');
          }, 1500);
          return;
        }
        if (attempt < 20) {
          setTimeout(() => scrollWhenReady(attempt + 1), 80);
        }
      };
      this.$nextTick(() => scrollWhenReady());
    },

    clearUserInfoPopoverTimers() {
      if (this.userInfoPopoverShowTimer != null) {
        clearTimeout(this.userInfoPopoverShowTimer);
        this.userInfoPopoverShowTimer = null;
      }
      if (this.userInfoPopoverHideTimer != null) {
        clearTimeout(this.userInfoPopoverHideTimer);
        this.userInfoPopoverHideTimer = null;
      }
    },

    cancelHideUserInfoPopover() {
      if (this.userInfoPopoverHideTimer != null) {
        clearTimeout(this.userInfoPopoverHideTimer);
        this.userInfoPopoverHideTimer = null;
      }
    },

    hideUserInfoPopover() {
      this.clearUserInfoPopoverTimers();
      this.userInfoPopover.active = false;
      this.userInfoPopover.message_id = null;
      this.userInfoPopover.user = null;
      this.userInfoPopover.placement = 'top';
    },

    getMessengerTopbarBottom() {
      const topbar = document.querySelector('.main-header');
      if (topbar) {
        return topbar.getBoundingClientRect().bottom;
      }
      const shell = document.querySelector('.main-panel.has-top-navbar');
      if (shell) {
        const value = getComputedStyle(shell).getPropertyValue('--app-screen-topbar-height');
        const parsed = parseFloat(value);
        if (Number.isFinite(parsed) && parsed > 0) {
          return parsed;
        }
      }
      return 64;
    },

    positionUserInfoPopover(anchorEl) {
      const popoverHeight = 180;
      const popoverWidth = 371;
      const gap = 10;
      const viewportPadding = 8;
      const rect = anchorEl.getBoundingClientRect();
      const topbarBottom = this.getMessengerTopbarBottom();
      const spaceAbove = rect.top - topbarBottom;
      const placement = spaceAbove >= popoverHeight + gap ? 'top' : 'bottom';
      let top = placement === 'top'
        ? rect.top - popoverHeight - gap
        : rect.bottom + gap;
      let left = rect.left;
      const maxLeft = window.innerWidth - popoverWidth - viewportPadding;
      left = Math.max(viewportPadding, Math.min(left, maxLeft));
      top = Math.max(topbarBottom + viewportPadding, top);
      const maxTop = window.innerHeight - popoverHeight - viewportPadding;
      if (top > maxTop) {
        top = maxTop;
      }
      this.userInfoPopover.placement = placement;
      this.userInfoPopoverStyle = {
        top: `${Math.round(top)}px`,
        left: `${Math.round(left)}px`,
      };
    },

    showUserInfoPopover(e, mess) {
      if (!mess || !mess.sender || mess.sender.id === this.user.id) {
        return;
      }
      const anchorEl = e && e.currentTarget
        ? e.currentTarget
        : (e && e.target && e.target.closest ? e.target.closest('.block-avatar') : null);
      if (!anchorEl) {
        return;
      }
      this.cancelHideUserInfoPopover();
      this.userInfoPopover.active = true;
      this.userInfoPopover.message_id = mess.id;
      this.userInfoPopover.user = mess.sender;
      this.positionUserInfoPopover(anchorEl);
    },

    scheduleShowUserInfoPopover(e, mess) {
      this.clearUserInfoPopoverTimers();
      this.userInfoPopoverShowTimer = setTimeout(() => {
        this.userInfoPopoverShowTimer = null;
        this.showUserInfoPopover(e, mess);
      }, 140);
    },

    scheduleHideUserInfoPopover() {
      this.cancelHideUserInfoPopover();
      if (this.userInfoPopoverShowTimer != null) {
        clearTimeout(this.userInfoPopoverShowTimer);
        this.userInfoPopoverShowTimer = null;
      }
      this.userInfoPopoverHideTimer = setTimeout(() => {
        this.userInfoPopoverHideTimer = null;
        this.hideUserInfoPopover();
      }, 180);
    },

    onMouseoverUserInfo(e, mess) {
      this.scheduleShowUserInfoPopover(e, mess);
    },

    onMouseleaveUserInfo() {
      this.scheduleHideUserInfoPopover();
    },

    onUserInfoPopoverEnter() {
      this.cancelHideUserInfoPopover();
    },

    scrollChatContent({ target: { scrollTop, clientHeight, scrollHeight }}){
      if (this.userInfoPopover.active) {
        this.hideUserInfoPopover();
      }
      const atBottom = this.checkIsAtBottom(scrollTop, clientHeight, scrollHeight);
      if (this.stickToBottomOnOpen && !atBottom) {
        const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
        if (distanceFromBottom > 120) {
          this.cancelStickToBottomOnOpen();
        }
      }
      this.hasScrolledToBottom = atBottom;
      if (atBottom) {
        this.clearPendingNewMessages();
      }
    },

    getChatContentEl() {
      return document.getElementById('chat-content');
    },

    checkIsAtBottom(scrollTop, clientHeight, scrollHeight) {
      const threshold = 80;
      const top = scrollTop != null ? scrollTop : (this.getChatContentEl()?.scrollTop || 0);
      const height = clientHeight != null ? clientHeight : (this.getChatContentEl()?.clientHeight || 0);
      const full = scrollHeight != null ? scrollHeight : (this.getChatContentEl()?.scrollHeight || 0);
      return Math.ceil(top) + Math.ceil(height) + threshold >= full;
    },

    clearPendingNewMessages() {
      this.pendingNewMessageCount = 0;
    },

    isOwnChatMessage(message) {
      if (!message || !message.sender) {
        return false;
      }
      return Number(message.sender.id) === Number(this.user.id);
    },

    shouldCountPendingNewMessage(message) {
      if (!message || this.isOwnChatMessage(message)) {
        return false;
      }
      if (message.type === MESSAGE_CHAT_TYPE.SYSTEM) {
        return false;
      }
      return true;
    },

    afterIncomingMessageAppended(message, { forceScroll = false } = {}) {
      const isOwn = forceScroll || this.isOwnChatMessage(message);
      this.$nextTick(() => {
        setTimeout(() => {
          const atBottom = this.checkIsAtBottom();
          if (isOwn) {
            this.scrollChatToBottom({ smooth: false });
            this.stickToBottomOnOpen = false;
            this.hasScrolledToBottom = true;
            this.clearPendingNewMessages();
            this.persistMessageCache(this.form.group_id);
            return;
          }
          if (atBottom || this.hasScrolledToBottom || this.stickToBottomOnOpen) {
            this.scrollChatToBottom({ smooth: false });
            this.hasScrolledToBottom = true;
            this.clearPendingNewMessages();
          } else if (this.shouldCountPendingNewMessage(message)) {
            this.pendingNewMessageCount += 1;
            this.hasScrolledToBottom = false;
          }
          this.persistMessageCache(this.form.group_id);
        }, 50);
      });
    },

    scrollChatToBottom({ smooth = false } = {}) {
      const chatEl = this.getChatContentEl();
      if (!chatEl) {
        return;
      }
      if (smooth && typeof chatEl.scrollTo === 'function') {
        chatEl.scrollTo({ top: chatEl.scrollHeight, behavior: 'smooth' });
        return;
      }
      chatEl.scrollTop = chatEl.scrollHeight;
    },

    beginStickToBottomOnOpen(token) {
      const activeToken = token != null ? token : this.conversationOpenScrollToken;
      this.stickToBottomOnOpen = true;
      this.clearPendingNewMessages();
      this.attachStickToBottomObserver(activeToken);
      this.ensureConversationScrolledToBottom(activeToken);
    },

    cancelStickToBottomOnOpen() {
      this.stickToBottomOnOpen = false;
      this.detachStickToBottomObserver();
    },

    attachStickToBottomObserver(token) {
      this.detachStickToBottomObserver();
      if (typeof ResizeObserver === 'undefined') {
        return;
      }
      const chatEl = this.getChatContentEl();
      if (!chatEl) {
        return;
      }
      this.stickToBottomRoToken = token;
      this.stickToBottomRo = new ResizeObserver(() => {
        if (this.stickToBottomRoToken !== this.conversationOpenScrollToken) {
          return;
        }
        if (!this.stickToBottomOnOpen) {
          return;
        }
        this.scrollChatToBottom({ smooth: false });
        if (this.checkIsAtBottom()) {
          this.hasScrolledToBottom = true;
          this.clearPendingNewMessages();
        }
      });
      this.stickToBottomRo.observe(chatEl);
      if (chatEl.firstElementChild) {
        this.stickToBottomRo.observe(chatEl.firstElementChild);
      }
    },

    detachStickToBottomObserver() {
      if (this.stickToBottomRo) {
        this.stickToBottomRo.disconnect();
        this.stickToBottomRo = null;
      }
      this.stickToBottomRoToken = null;
    },

    /**
     * Mở / chuyển cuộc trò chuyện — luôn đưa viewport về tin mới nhất.
     * Retry vài lần vì DOM/ảnh có thể render trễ sau khi messageList đổi.
     */
    ensureConversationScrolledToBottom(token, attempt = 0) {
      const activeToken = token != null ? token : this.conversationOpenScrollToken;
      if (activeToken !== this.conversationOpenScrollToken) {
        return;
      }
      this.$nextTick(() => {
        const chatEl = this.getChatContentEl();
        if (!chatEl) {
          if (attempt < 8) {
            setTimeout(() => this.ensureConversationScrolledToBottom(activeToken, attempt + 1), 80);
          }
          return;
        }
        this.scrollChatToBottom({ smooth: false });
        const atBottom = this.checkIsAtBottom();
        if (atBottom) {
          this.hasScrolledToBottom = true;
          this.clearPendingNewMessages();
          if (attempt < 8) {
            setTimeout(() => this.ensureConversationScrolledToBottom(activeToken, attempt + 1), 100);
          } else {
            this.stickToBottomOnOpen = false;
            this.detachStickToBottomObserver();
          }
          return;
        }
        if (attempt < 14) {
          setTimeout(() => this.ensureConversationScrolledToBottom(activeToken, attempt + 1), 100);
          return;
        }
        this.stickToBottomOnOpen = false;
        this.hasScrolledToBottom = false;
        this.detachStickToBottomObserver();
      });
    },

    scrollToBottom(){
      this.clearPendingNewMessages();
      this.stickToBottomOnOpen = false;
      this.hasScrolledToBottom = true;
      this.detachStickToBottomObserver();
      const chatEl = this.getChatContentEl();
      if (!chatEl) {
        return;
      }
      if (typeof $(chatEl).animate === 'function') {
        $(chatEl).animate({ scrollTop: chatEl.scrollHeight });
      } else {
        this.scrollChatToBottom({ smooth: true });
      }
    },

    pinMessageToList(message_id, is_pin = true) {
      let text = is_pin ? 'ghim tin nhắn' : 'bỏ ghim tin nhắn'
      this.$modal.show('dialog', {
        title: text.toLocaleUpperCase(),
        text: 'Bạn có chắc muốn ' + text,
        buttons: [
          {
            title: 'Không',
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'Đồng ý',
            handler: () => {
              this.$refs.pinMessage
              .hanldeMessage(
                message_id, is_pin ? TEXT_CHAT_SYSTEM.PIN_MESSAGE : TEXT_CHAT_SYSTEM.UNPIN_MESSAGE
              );
              this.$modal.hide('dialog')
            }
          }
        ]
      });
    },

    expandPollVoteGroup(groupKey) {
      if (!groupKey) return;
      this.$set(this.expandedPollVoteGroups, groupKey, true);
    },
    getPollVoteRunInfo(index) {
      const messages = this.messageList || [];
      const current = messages[index];
      if (!isPollVoteActivityMessage(current)) {
        return null;
      }
      let start = index;
      while (start > 0 && isPollVoteActivityMessage(messages[start - 1])) {
        start -= 1;
      }
      let end = index;
      while (end < messages.length - 1 && isPollVoteActivityMessage(messages[end + 1])) {
        end += 1;
      }
      const length = end - start + 1;
      return {
        start,
        end,
        lastIndex: end,
        length,
        groupKey: `pv-${messages[start].id}-${messages[end].id}`,
      };
    },
    pollVoteRunGroupKey(index) {
      return this.getPollVoteRunInfo(index)?.groupKey || '';
    },
    shouldShowPollVoteExpandButton(index) {
      const run = this.getPollVoteRunInfo(index);
      if (!run || run.length <= 3 || this.expandedPollVoteGroups[run.groupKey]) {
        return false;
      }
      return index === run.lastIndex;
    },
    shouldRenderMessageAtIndex(mess, index) {
      const visible = (mess.sender && (mess.delete_status !== 1 || mess.sender.id !== this.user.id))
        || this.chatGroupSelected.type === 'BOT'
        || mess.type === MESSAGE_CHAT_TYPE.SYSTEM
        || mess.type === MESSAGE_CHAT_TYPE.ANNOUNCEMENT;
      if (!visible) {
        return false;
      }
      if (!isPollVoteActivityMessage(mess)) {
        return true;
      }
      const run = this.getPollVoteRunInfo(index);
      if (!run || run.length <= 3 || this.expandedPollVoteGroups[run.groupKey]) {
        return true;
      }
      return index === run.lastIndex;
    },
    openPollVoteModal(payload = {}) {
      const pollMessageId = payload.pollMessageId;
      const pollId = payload.pollId;
      let mess = null;
      if (pollMessageId != null) {
        mess = this.messageList.find((row) => Number(row.id) === Number(pollMessageId));
      }
      if (!mess && pollId != null) {
        mess = this.messageList.find((row) => row.poll && Number(row.poll.id) === Number(pollId));
      }
      if (!mess) return;
      this.$modal.show('poll-vote-modal', { mess });
    },
    showListAddMember(system_note) {
      let text = '';
      if(!system_note) return;

      JSON.parse(system_note).forEach(function(item){
        text += `<div class="fullname-system-note">
          <a target="_blank" href="/profile/${item.id}">${item.fullname}</a>
        </div>`;
      });

      this.$modal.show('dialog', {
        title: '',
        text: text
      })
    },

    pickMessageType(value) {
      this.composerMessageCategory = value;
      this.messageTypePickerOpen = false;
    },

    closeMessageTypePicker() {
      this.messageTypePickerOpen = false;
    },

    // reset
    setScrollBottomOffset(px) {
      const el = this.$refs.scrollBottomAnchor || this.$refs.scrollBottom;
      if (el && el.style) {
        el.style.bottom = `${px}px`;
      }
    },

    resetChatContent() {
      try {
        this.form.message = '';
        this.form_input.message = '';
        this.form.file_ids = [];
        this.form.type = MESSAGE_CHAT_TYPE.TEXT;
        delete this.form.system_note;
        this.form.tag_list = {};
        this.form.category = null;
        this.composerMessageCategory = '';
        this.messageTypePickerOpen = false;
        this.medias.forEach((m) => {
          if (m && m._previewObjectUrl) {
            URL.revokeObjectURL(m._previewObjectUrl);
          }
        });
        this.medias = [];
        this.createChat.status = '';
        this.mentions = [];
        this.replyMessager.active = false;
        this.replyMessager.message = [];
        this.form.reply_to_msg_id = null;
        this.setScrollBottomOffset(100);
        this.onScrollMessageId = null;
        this.form_input.isEdit = false;
        this.isFastMessage = false;
        delete this.form.poll;
        this.setHeightChatContent();
        if (this.$modal && typeof this.$modal.hide === 'function') {
          this.$modal.hide('create-poll-chat-modal');
        }
        const mentionableEl = this.$el && this.$el.querySelector
          ? this.$el.querySelector('.reply-section .mentionable')
          : null;
        if (mentionableEl) {
          mentionableEl.style.height = '';
        }
        this.$nextTick(() => this.resizeTextarea());

        if (this.$store.state.chat.chatGroupSelected.type === 'GROUP') {
          const $marks = $('.highlightTextarea-container mark');
          if ($marks.length) {
            $marks.css('background-color', '#FFF');
          }
        }

        this.checkIsHasUser();
      } catch (err) {
        messengerDebugLog('resetChatContent.error', {
          message: err && err.message ? err.message : String(err),
          hasScrollBottomRef: !!this.$refs.scrollBottom,
        });
      }
    },

    applyComposeDraftIfAny() {
      const draft = this.$store.state.chat.composeDraftMessage;
      if (draft == null || String(draft).trim() === "") {
        return;
      }
      const text = String(draft);
      this.$store.commit("chat/setComposeDraftMessage", null);
      this.$nextTick(() => {
        this.form_input.message = text;
        this.form.message = text;
        this.$nextTick(() => {
          const el = document.getElementById("input-chat");
          if (el && typeof el.focus === "function") {
            el.focus();
          }
          if (typeof this.resizeTextarea === "function") {
            this.resizeTextarea();
          }
        });
      });
    },

    setCacheChatMessage(message){
      const gid = String(this.form.group_id || '');
      if (!gid || !message) {
        return;
      }
      const current = getCacheMessages(this.cacheChatMessages, gid);
      const next = appendChatMessageIfNew(current, message);
      this.persistMessageCache(gid, next);
    },

    shareMessage(message){
      this.$modal.show('share-message-modal', {message : message});
    },

    async shareMessageToUser({user, message}){
      // if(!this.shareMessages.includes(user_id)){
      //   this.push(user_id)
      // }
// console.log(message, user);return;
      void user;
      void message;
    },

    openModalMessageHistory(message){
      let list = [];
      if(this.isAdmin && message.history_message !== null && message.history_message.length > 0){
        list = message.history_message;
        // console.log(message);
        // list.push({
        //   text: message.text,
        //   time: moment(message.updated_at).format('yyyy-MM-DD HH:mm:ss'),
        // })
        this.$modal.show('list-message-history-modal', {
          historyList: list
        });
      }
    },

    createPollMessage(pollData){
      this.form.poll = pollData;
      this.form_input.message = 'poll';
      this.postMessage();
      // console.log(pollData);
    },

    tagContentChat(mess){

      let data = {};
      const otherKeys = [];
      if(mess.tag_list){
        data = JSON.parse(mess.tag_list);
        for (let key in data) {
          if (key.startsWith("other")) {
            otherKeys.push(data[key]);
          }
        };
      }


      return {
        category: mess.category,
        date: data.date ?? null,
        place: data.place ?? null,
        team: data.team ?? null,
        others: otherKeys
      };
    },

    async postMessageReport(message){
      this.form.message = message.message;
      this.form_input.message = message.message;
      this.form.type = message.type;
      this.form.category = message.category;
      this.composerMessageCategory = message.category == null || message.category === '' ? '' : String(message.category);
      this.form.tag_list = message.tag_list;
      this.form.file_ids = message.file_ids;
      this.form_input.file_ids = message.file_ids;
      this.form.text = message.text;
      this.medias = message.medias;

      await this.postMessage();
      this.$modal.hide('report-chat-modal');
    },

    openSearchChat(e){
      if(e.target.localName === 'mark'){
        this.searchKeyword = e.target.innerText;
        this.getChatInfo('search');
      }
    },

    async postMulti(e){
      if(e){
        const formData = this.dataSplitFile.dataSplit;
        this.resetChatContent();

        const orders = ["file", "image", "video"];
        for (let index = 0; index < orders.length; index++) {
          if(index === 0){
            let message = formData[orders[index]];
            if(message){
              message.mobile_local_id = Date.now().toString();
              this.createMessage(message);
            }
          }else{
            setTimeout(() => {
              let message = formData[orders[index]];
              if(message){
                message.mobile_local_id = Date.now().toString();
                this.createMessage(message);
              }
            }, index * 1000);
          }
        }
      }else{
        const formData = this.dataSplitFile.dataOrigin;
        formData.type = MESSAGE_CHAT_TYPE.FILE;
        await this.createMessage(formData);
      }
      this.$refs.fileUpload.value = '';
      this.$modal.hide('confirm-file-modal');
    },

    showRuleModal(){
      let content = this.$store.state.chat.chatGroupSelected.description ?? 'Không có mô tả...';
      this.$modal.show('update-rule-group', {content: content});
    },

    sendSticker(sticker){
      if (!sticker || !sticker.file_id || !sticker.image_url) {
        this.$store.dispatch("alerts/error", 'Không thể gửi sticker này. Vui lòng thử lại.');
        return;
      }
      this.medias = [
        {
          file_id: sticker.file_id,
          extension: null,
          path: sticker.image_url,
          thumbnail: sticker.thumbnails || sticker.thumbnail || null,
          url: sticker.image_url,
          single_post_id: null,
          width: null,
          height: null,
          type: 'image'
        }
      ];
      this.form.system_note = '{"sticker":"1"}';
      this.form.type = MESSAGE_CHAT_TYPE.IMAGE;
      this.form.file_ids = [sticker.file_id];
      this.form_input.file_ids = [sticker.file_id];
      this.form.category = null;
      this.composerMessageCategory = '';
      this.postMessage();
    },

    openMenuOther(id){
      this.menuOther = id
    },

    async changeCategory(message, category){
      const form = {
        message_id: message.id,
        message: message.text,
        category: category
      };

      await ChatService.editMessageChat(form).then(res => {
          if (res.status) {
            this.messageList.map((mess, index) => {
              if (mess.id == res.data.id) {
                mess.history_message = res.data.history_message;
                mess.category = res.data.category;
              }
            });
          }else{
            this.$store.dispatch("alerts/error", 'Đã có lỗi xảy ra! Vui lòng thử lại!');
          }
        });
    },

    async deleteReaction(message){
      await ChatService.deleteReaction({message_id: message.id}).then(res => {
          if (res.status) {
            this.messageList.map((mess, index) => {
              if (mess.id == res.data.message_id) {
                mess.reaction_stats = res.data.reaction_stats;
                mess.like_count = res.data.like_count;
                mess.is_acc_mention = 0;
              }
            });
          }else{
            this.$store.dispatch("alerts/error", 'Đã có lỗi xảy ra! Vui lòng thử lại!');
          }
        });
    },

    checkIsHasUser(){
      const store = this.$store.state.auth.user;
      if(!store.id){
        this.$store.dispatch("alerts/error", 'Hết phiên đăng nhập, tự động chuyển đến trang đăng nhập!');
        setTimeout(() => {
          window.app.$store.dispatch("redirectToLogin");
        }, 1500);
      }
    }
  },
}

</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
@import "src/assets/scss/messager/messager";
.v-popup-hidden{
  .v-popper__popper{
    display: none;
  }
}
.mention-selected {
  background: #E0E0E0 !important;
}
.mention-item {
  padding: 2px 8px;
  border-radius: 4px;
  &:hover{
    cursor: pointer;
  }
  .md-avatar {
    border: 1px solid #dbdbdb;
  }
  .md-list.md-theme-default{
    background-color: unset;
  }
  .md-list-item .md-list-item-container .md-ripple{
    padding: 0;
  }
}
.mentionable {
    width: 100%;
    min-height: 36px;
    box-sizing: border-box;
}
.v-popper__inner{
  padding: 10px 5px;
}
.message-list-history{
  height: 100%;
  overflow: hidden;
  .velmld-overlay{
    background: transparent !important;
  }
}
.calcHeightContent {
  height: calc(
    100vh - var(--app-global-topbar-height, 0px) - 233px
  ) !important;
}

.user-tag {
  color: #2274f8;
  border-radius: 6px;
}

.highlightTextarea {
  width: 100% !important;

  .highlightTextarea-container {
    .highlightTextarea-highlighter {
      mark {
        padding: 0px;
        border-radius: 0.4em;
      }
    }
  }
}

.chat-content {
  background-color: rgb(242, 240, 238);
  overflow-x: hidden;
  width: 100%;
  overflow-y: scroll !important;
  flex: 1 1 0%;
  height: calc(100vh - var(--app-global-topbar-height, 0px) - 130px);
  overflow: auto;

  .chat-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    width: 100%;
    margin: 0px auto;
    overflow: hidden;

    .icon-action-note img {
      width: 18px;
    }

    .new-conversation {
      background-image: url("/img/chat/create_user_chat_bg.png");
      background-size: contain;
      box-shadow: 0px 0px 4px 0px #00000024;
      width: 500px;
      height: 90px;
    }

    .chat-welcome-empty {
      justify-content: center;
      margin: 48px auto 24px;
      width: 100%;
      max-width: 520px;

      &__card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        padding: 28px 24px;
        text-align: center;
      }

      &__verified {
        font-size: 28px !important;
        width: 28px;
        min-width: 28px;
        height: 28px;
        color: #16a34a !important;
        margin-bottom: 12px;
      }

      &__title {
        margin: 0 0 10px;
        font-size: 18px;
        font-weight: 600;
        color: #5000a1;
      }

      &__text {
        margin: 0;
        font-size: 14px;
        line-height: 1.5;
        color: #5f6368;
      }
    }

    .new-chat {
      line-height: 1.4;
      background-image: url("/img/chat/new_conversation.jpg");
      background-size: contain;
      width: 500px;
      height: 90px;
      margin: 30px auto 16px;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);

      span {
        color: #5000a1;
        font-size: 16px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;

        strong {
          color: #ed660e;
        }
        .new-chat-target-name {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          flex-wrap: wrap;
          vertical-align: baseline;
        }
        .new-chat-target-name__inner {
          display: inline;
        }
        .official-team-verified {
          font-size: 18px !important;
          width: 18px;
          min-width: 18px;
          height: 18px;
          color: #16a34a !important;
          flex-shrink: 0;
        }
      }
    }
    .message-item {
      display: flex;
      flex-direction: column;
      overflow-wrap: break-word;
      font-size: 14px;
      position: relative;
      /* Browser-native virtualization — giảm DOM paint khi list dài (Phase 3 OOM). */
      content-visibility: auto;
      contain-intrinsic-size: auto 88px;

      &:hover,
      &.message-item--actions-open {
        z-index: 30;
        content-visibility: visible;
      }

      &.item-mine {
        padding: 0px 12px 0px 150px;
        .dmnXwr {
          margin-right: 138px;
        }
      }
      &.item-opposite {
        padding: 0px 150px 0px 12px;
        .dmnXwr {
          margin-left: 138px;
        }
      }
      &.item-center {
        padding: 0px 20px;
      }

      &.poll-vote-activity-item {
        align-items: center;
        width: 100%;
        margin-bottom: 8px;
      }

      .message-body.announcement-center {
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 100%;

        .message-content-wrapper {
          width: 100%;
          max-width: 680px;
          margin-left: auto;
          margin-right: auto;
        }

        .message-status {
          text-align: center;
          width: 100%;
          max-width: 680px;

          .status-action {
            margin-left: auto;
            margin-right: auto;
          }
        }
      }

      .announcement-center-card {
        width: 100%;
        max-width: 680px;
        margin: 0 auto 10px;
        padding: 12px 14px;
        background: #fff;
        border: 1px solid #e8e7e7;
        border-left: 4px solid #e65100;
        border-radius: 12px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
      }

      .announcement-center-card__top-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin-bottom: 10px;
        flex-wrap: wrap;
      }

      .announcement-center-card__top-left {
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px 10px;
        min-width: 0;
        flex: 1;
      }

      .announcement-center-card__kind {
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.08em;
        color: #e65100;
        flex-shrink: 0;
      }

      .announcement-center-card__status-badge {
        font-size: 11px;
        font-weight: 600;
        line-height: 1.2;
        padding: 4px 10px;
        border-radius: 999px;
        background: #fff3e0;
        color: #e65100;
        border: 1px solid #ffcc80;
        white-space: normal;
        max-width: 100%;
      }

      .announcement-center-card__status-badge--expired {
        background: #efebe9;
        color: #5d4037;
        border-color: #d7ccc8;
      }

      .announcement-center-card__title-row {
        margin-bottom: 10px;
      }

      .announcement-center-card__heading {
        color: #1a1a1a;
        font-size: 15px;
        line-height: 1.35;
        display: block;
      }

      .announcement-center-card__inline-actions {
        flex-shrink: 0;
        position: relative;
        z-index: 4;

        .container_popup {
          display: flex;
          align-items: center;
          grid-gap: 3px;
          background: #ffffff;
          box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
          border-radius: 6px;
          padding: 4px 8px;
          position: relative;
        }

        .action {
          display: flex;
          cursor: pointer;
          align-items: center;
          justify-content: center;
          min-width: 28px;
          min-height: 28px;

          .icon_history_action {
            max-width: 24px;
            padding: 1px;
            cursor: pointer;
          }

          &:hover {
            background: #dbe3ff;
            border-radius: 2px;
          }
        }
      }

      .announcement-center-card__action-bar {
        margin: 0;
          display: flex;
      }

      .announcement-center-card__popup-anchor {
        position: relative;
      }

      .announcement-center-card__emoji-popup.actionPopup.emojis {
        position: absolute;
        bottom: 100%;
        left: 0;
        margin-bottom: 6px;
        top: auto;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 5px;
        width: max-content;
        max-width: 280px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 0 4px 2px rgb(0 0 0 / 10%);
        padding: 8px 12px;
        z-index: 20;

        .emoji_icon {
          width: 32px;
          height: 32px;
          cursor: pointer;
        }
      }

      .announcement-center-card__more-popup.actionPopup.menu {
        position: absolute;
        bottom: 100%;
        right: 0;
        left: auto;
        margin-bottom: 6px;
        top: auto;
        width: max-content;
        min-width: 200px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 0 4px 2px rgb(0 0 0 / 10%);
        padding: 6px 0;
        z-index: 20;

        .more_action {
          padding: 8px 12px;
          white-space: nowrap;

          &:hover {
            cursor: pointer;
            background: #f1f1f185;
          }
        }

        .recovery_message,
        .delete_message {
          color: var(--app-color-red, #c62828);
        }

        .category_message_change {
          position: relative;

          .menu-icon-arrow-right {
            position: absolute;
            right: -6px;
            top: 50%;
            transform: translate(2px, -50%);
          }

          .menuOtherOption {
            position: absolute;
            top: -51px;
            right: -154px;
            padding: 10px;

            .listOther {
              background: #fff;
              box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.1);
              border-radius: 10px;

              .report-category {
                padding: 5px 10px;
              }
            }
          }
        }
      }

      .announcement-center-card__footer-row {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 12px 24px;
        flex-wrap: wrap;
        margin-bottom: 10px;
      }

      .announcement-center-card__expiry-inline {
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
      }

      .announcement-center-card__expiry-time--none {
        color: #9e9e9e;
        font-style: italic;
      }

      .announcement-center-card__label {
        font-size: 12px;
        color: #757575;
        margin-right: 6px;
      }

      .announcement-center-card__creator {
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
      }

      .announcement-center-card__avatar {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        object-fit: cover;
        border: 1px solid #eee;
      }

      .announcement-center-card__name {
        font-size: 13px;
        font-weight: 500;
      }

      .announcement-center-card__expiry {
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
      }

      .announcement-center-card__expiry-time {
        font-size: 13px;
      }

      .announcement-center-card__expired-badge {
        font-size: 11px;
        background: #efebe9;
        color: #5d4037;
        padding: 2px 8px;
        border-radius: 4px;
      }

      .announcement-center-card__kv-list {
        list-style: none;
        margin: 0 0 10px;
        padding: 0;
        border-top: 1px solid #eee;
      }

      .announcement-center-card__kv-item {
        padding: 8px 0;
        border-bottom: 1px solid #f3f3f3;

        &:last-child {
          border-bottom: none;
        }
      }

      .announcement-center-card__kv-title {
        font-size: 12px;
        font-weight: 600;
        color: #444;
        margin-bottom: 4px;
      }

      .announcement-center-card__kv-content {
        font-size: 13px;
        color: #333;

        a {
          color: #198eeb;
          text-decoration: underline;
          word-break: break-all;
        }
      }

      .announcement-center-card__message {
        font-size: 14px;
        line-height: 1.45;
        padding: 8px 0;
        border-top: 1px solid #eee;

        a {
          color: #198eeb;
          text-decoration: underline;
          word-break: break-all;
        }
      }

      .announcement-center-card__attachments {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #eee;
      }

      .announcement-center-card__linkmetadata {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #eee;

        .metadata-message {
          margin-top: 0;
        }
      }

      &:hover .historyAction,
      &.message-item--actions-open .historyAction {
        visibility: visible !important;
      }

      .dmnXwr {
        padding: 10px;
        text-align: center;
        color: rgb(118, 113, 113);
        font-size: 12px;
      }
      .message {
        align-items: center;
        display: flex;
        position: relative;
        border-bottom: none !important;

        .message-user-info {
          position: relative;

          &:hover {
            cursor: pointer;
          }
        }

        .message-sender {
          align-self: flex-start;
          display: flex;
          flex-shrink: 0;

          .block-avatar {
            width: 32px;
            height: 32px;
            margin-right: 5px;
          }

          .app-avatar--user {
            height: 32px;
            width: 32px;
            border-width: 1px;
            border-style: solid;
            border-color: rgb(242, 242, 242);
            border-image: initial;
          }

          .app-avatar {
            background-position: 50% center;
          }

          .app-avatar {
            background-color: rgb(241, 242, 244);
            background-size: cover;
            display: flex;
            position: relative;
            border-radius: 50%;
            overflow: hidden;
            aspect-ratio: 1 / 1;
            flex-shrink: 0;

            .image-template__img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .mr-2, .mx-2 {
            margin-right: 0.5rem !important;
          }
        }


        .message-body--poll-vote-activity {
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          display: flex;
        }

        .poll-vote-expand-row {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          margin-bottom: 8px;
        }

        .poll-vote-expand-btn {
          appearance: none;
          -webkit-appearance: none;
          border: 0;
          background: transparent;
          box-shadow: none;
          outline: none;
          color: #1b74e4;
          font-size: 14px;
          font-weight: 500;
          padding: 0;
          margin: 0;
          cursor: pointer;
          line-height: 20px;

          &:hover {
            text-decoration: underline;
          }
        }

        .poll-message-wrapper{
          margin: auto;
        }
        .message-body {
          display: flex;
          flex-grow: 1;
          justify-content: space-between;

          .message-content-wrapper {
            .isOnlyEmoji {
              background-color: #0000 !important;
              border: none !important;
              width: auto !important;
              padding-top: 0 !important;
              padding-bottom: 0 !important;

              .content-display {
                height: 50px;

                .emoji {
                  font-size: 44px !important;
                  margin-bottom: 4px;
                  right: -0.3em;
                  top: auto;
                  line-height: 50px;
                  position: relative;
                  z-index: 1;
                }

                .content-display-timestamp {
                  margin-top: 5px;
                }

              }
            }

            .message-text {
              background-color: #FFF;
              color: var(--spectrum-global-color-contentPrimary);
              border-radius: 12px;
              min-width: 90px;
              max-width: 700px;
              font-size: 16px;
              padding: 8px 12px;
              border: 1px solid #dfdfdf;
              white-space: pre-wrap;
              .card-media img, .message-file .file-item {
                border-radius: 0px !important;
              }
            }

            .message-media {
              align-items: flex-end;
              display: flex;
              flex-direction: row;
              position: relative;
              &:hover .pophover-datetime {
                visibility: visible !important;
              }
              .message-action {
                position: relative;
                  width: 100%;

                .message-text-action {
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                }
              }


              .image-message {
                width: 230px;
                height: auto;
                background-color: rgb(242, 242, 242);
                border: none;
                border-radius: 15px;
                display: flex;
                -webkit-box-pack: center;
                justify-content: center;
                -webkit-box-align: center;
                align-items: center;
                margin: 0px;
                max-width: 230px !important;
                position: relative;

                img {
                  max-height: 350px;
                  overflow: hidden;
                  min-height: 30px;
                  object-fit: cover;
                  border-radius: 15px;
                }

                .quality-label {
                  position: absolute;
                  top: 10px;
                  left: 10px;
                  background: rgb(0 0 0 / 41%);
                  border-radius: 4px;
                  padding: 2px 5px;
                  color: rgb(255 255 255);
                  font-size: 11px;
                }
              }

              .video-message {
                align-items: center;
                position: relative;
                text-align: center;
                width: 100%;
                max-width: 400px;
                overflow: hidden;
                margin: 5px 0 0 0;

                .video-content {
                  /* Cần bề ngang cụ thể: toàn bộ con là absolute → 100% cha có thể suy ra 0 trong flex */
                  width: 400px;
                  max-width: 100%;
                  background-color: rgb(242, 242, 242);
                  border: none;
                  border-radius: 15px;
                  display: block;
                  margin: 0px;
                  position: relative;
                  overflow: hidden;

                  .video {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    background-color: rgb(242, 242, 242);
                  }
                }
              }

              .file-message {

              }
            }

            .message-file {
              .file-item {
                background-color: #FFF2DA;
                padding: 0.5rem 0.7rem;
                position: relative;
                border: 1px solid #f0bb58;
                border-radius: 4px;
                margin-top: 8px;
                max-width: 450px;

                .fileData {
                  display: flex;
                  align-items: center;

                  .file-thumb {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 0.5rem;
                    width: 40px;
                    height: 40px;
                    flex-shrink: 0;
                  }

                  .file-icon {
                    width: 40px;
                    height: 40px;
                    display: block;
                    object-fit: contain;
                  }
                }
              }

              .file-item:hover {
                background-color: #ffe9be;
              }

              .file-open {
                margin-left: 10px;
                display: flex;
                align-items: center;
                gap: 6px;
                flex-shrink: 0;

                .open {
                  background: #ffffff;
                  border: 1px solid #3798ff;
                  border-radius: 6px;
                  color: #0065D0;
                  font-size: 12px;
                  padding: 5px 10px;
                  font-weight: 500;
                  cursor: pointer;
                  white-space: nowrap;

                  &:hover {
                    background: #3798ff;
                    color: #FFFFFF;
                  }
                }

                .open--view {
                  border-color: #20a464;
                  color: #12814b;

                  &:hover {
                    background: #20a464;
                    color: #ffffff;
                  }
                }
              }
            }


            .history__action {
              display: flex;
              flex-direction: row;
              z-index: 999;
              visibility: hidden;
              opacity: 0;
            }

            .sender-name {
              align-items: center;
              color: #545454;
              display: flex;
              font-size: 12px;
              font-weight: 600;
              min-height: 20px;
            }

            .content-display-timestamp {
              font-size: 11px;
              margin-top: 1px;
              color: #6c6c6c;
            }

            .typeActionHistory {
              margin: 0 10px 20px 10px !important;
            }

            .pophover-datetime {
              position: absolute;
              top: 38px;
              width: max-content;
              background-color: rgba(0, 0, 0, 0.27);
              color: #fff;
              padding: 0 4px;
              font-size: 10px;
              margin: 0;
              border-radius: 5px;
              z-index: 10;
              visibility: hidden;
              &:hover {
                visibility: hidden !important;
              }
            }
            .historyAction {
              margin: 0 10px 0 10px;
              padding: 2px 8px;
              position: absolute;
              // right: -115px;
              top: 0;
              // background: #ffffff;
              // box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
              // border-radius: 6px;
              visibility: hidden;
              z-index: 40;

              .slide-fade-enter-active {
                transition: all 0.3s ease-out;
              }

              .slide-fade-leave-active {
                transition: all 0.15s cubic-bezier(1, 0.5, 0.5, 1);
              }

              .slide-fade-enter-from,
              .slide-fade-leave-to {
                transform: translateY(20px);
                opacity: 0;
              }

              .container_popup {
                display: flex;
                align-items: center;
                grid-gap: 3px;
                background: #ffffff;
                box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
                border-radius: 6px;
                padding: 4px 8px;
                position: relative;
              }

              .action {
                width: 100%;
                height: 100%;
                display: flex;
                cursor: pointer;
                .icon_history_action {
                  max-width: 24px;
                  padding: 1px;
                  cursor: pointer;
                }

                &:hover {
                  background: #dbe3ff;
                  border-radius: 2px;
                }

              }

              .emoticon {
                .reaction-love{
                  height: 100%;
                  width: 100%;
                }
                .actionPopup {
                  position: absolute;
                  bottom: 34px;
                  width: max-content;
                  height: max-content;
                  background: #fff;
                  border-radius: 10px;
                  box-shadow: 0px 0 4px 2px rgb(0 0 0 / 10%);
                  padding: 8px 12px;
                  grid-gap: 5px;
                  align-items: center;
                  z-index: 50;
                  &.menu {
                    right: 0px;
                  }
                  .category_message_change{
                    position: relative;
                    .menu-icon-arrow-right {
                      position: absolute;
                      right: -6px;
                      top: 50%;
                      transform: translate(2px, -50%);
                    }
                    .menuOtherOption{
                      position: absolute;
                      top: -51px;
                      right: -154px;
                      padding: 10px;
                      .listOther {
                        background: #fff;
                        box-shadow: 0px 0 4px 2px rgba(0, 0, 0, 0.1);
                        border-radius: 10px;
                        .report-category {
                            padding: 5px 10px;
                        }
                      }
                    }
                  }
                  .more_action {
                    padding: 5px;

                    &:hover {
                      cursor: pointer;
                      background: #f1f1f185;
                    }
                }
              }

                .recovery_message, .delete_message {
                  color: var(--app-color-red);
                }

                .emoji_icon {
                  width: 32px;
                  height: 32px;
                  margin: 0px 1px;
                  transition: all .2s ease-in-out;
                  background-color: #fff;

                  &:hover {
                    cursor: pointer;
                    transform: scale(1.5);
                  }
                }
              }
            }
            .replyMessager{
              .historyAction {
                top: 50px !important;
              }
              .pophover-datetime {
                top: 88px !important;
              }
            }
            .message_recall {
              border: 1px solid var(--app-color-sliver);
              border-radius: 10px;
              padding: 10px 15px;
              background: #fff;
              color: #8e8e8e;
            }
          }


          .messenger__action-note-detail {
            width: 100%;
            height: auto;
            pointer-events: auto;
            margin: 10px;
            display: flex;
            -webkit-box-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            align-items: center;

            .action-note-content {
              margin: 0px;
              padding: 0px;
              .other-member {
                &:hover{
                 cursor: pointer;
                 text-decoration: underline !important;
                 color: #0398db !important;
                }
                color: var(--md-theme-default-primary-on-background, #9c27b0);
              }
            }
          }

          .report-ckeditor{
            line-height: 0.5;
            margin: 10px 0 10px;
            p {
              margin: 0;
            }
            ol{
              padding-left: 15px;
            }
            ul{
              // padding-left: 1.5rem;
              display: flex;
              flex-direction: column;
              list-style: none;
              padding-left: 0;
              li{
                position: relative;
                padding-left: 15px;
                // margin: 5px;
                line-height: 20px;
                &::before{
                  content: "";
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translateY(-50%);
                  width: 5px;
                  height: 5px;
                  border-radius: 50%;
                  background-color: black;
                }
              }
            }
            s {
              text-decoration: line-through;
            }
          }
        }

        .spacing-top {
          margin-top: 8px;
        }

        .mine {
          justify-content: flex-end !important;
          .emojis {
            right: -80px;
          }
          .message-text {
            background-color: #e7f2ff !important;
          }

          .content-display-timestamp {
            text-align: end;
          }

          .message-media {
            flex-direction: row-reverse !important;
          }

          .message-text-action {
            align-items: flex-end !important;
          }
          .historyAction{
            left: -120px;
          }
          .pophover-datetime{
            left: -102px;
          }
        }

        .opposite {

          .isOnlyEmoji {
            .emoji {
              left: -0.3em;
            }
          }

          .emojis {
            right: -60px;
            justify-content: start;
          }

          .historyAction{
            right: -120px;
          }
          .pophover-datetime{
            right: -102px;
          }

        }

        .emoji-wrapper {
          cursor: pointer;
          border: 1px solid #d8d8d8;
          border-radius: 16px;
          background: white;
          padding: 3px 7px;
          margin-right: 1px;
          display: flex;
          align-items: center;
        }

        .message-body {
          display: flex;
          flex-grow: 1;
          justify-content: space-between;

          .message-status {
            text-align: right;
            .error-send {
              margin-top: 5px;
              color: var(--app-color-red);

              .reSendMessage {
                text-decoration: underline;
              }
            }
            .messager-sended, .messager-sending{
              margin-top: 5px;
              grid-gap: 5px;
              img{
                width: 15px;
                height: 15px;
              }
            }
            .messager-send{
              margin-top: 5px;
              img{
                width: 20px;
                height: 20px;
              }
            }
            .status-action {
              font-size: 11px;
              border-radius: 10px;
              padding: 0 6px;
              display: flex;
              margin-left: auto;
              width: fit-content;
              align-items: center;
              background: #CDCFD0;
              color: #fff;
              i{
                color: #fff;
              }
              .md-icon {
                font-size: 14px !important;
                margin: 0 4px 0 0;
              }
            }
          }
        }
        // css link_metadata
        .metadata-message{
          margin-top: 10px;
          .container-metadata {
            width: 100%;
            display: flex;
            text-decoration: none;
            font-weight: normal;
            font-size: 15px;
            border: 1px solid #0000002e;
            position: relative;
            overflow: hidden;
            background-color: #fff;
            border-radius: 12px;
            margin-top: 2px;
            .metadata-image {
              display: flex;
              -webkit-box-align: center;
              align-items: center;
              -webkit-box-pack: center;
              justify-content: center;
              height: 90px;
              width: 120px;
              position: relative;
              background-color: #d8d5d6;
              overflow: hidden;
              border-right: 1px solid transparent;
            }
            .metadata-content {
              -webkit-box-flex: 1;
              flex-grow: 1;
              padding: 6px 12px;
              width: 100vh;
              max-width: 500px;
              .title{
                margin: 5px 0 5px;
                font-weight: 700;
              }
              .description {
                margin: 0px;
                font-size: 14px;
              }
              .domain{
                margin: 0 0 5px;
                font-size: 14px;
              }
            }
          }
        }
      }

      .message-seen-inline {
        bottom: 0px;
        position: absolute;
        right: 6px;
      }

      .message-seen {
        display: flex;
        justify-content: flex-end !important;

        .iysmYH {
          border-radius: 50%;
          box-sizing: border-box;
          min-width: 18px;
          min-height: 18px;
          border: 1px solid rgb(242, 242, 242);
          background-color: #30a960;
          display: flex;
          -webkit-box-pack: center;
          justify-content: center;
          -webkit-box-align: center;
          align-items: center;
          width: 18px;
          height: 18px;
        }

        .daIMPk {
          display: inline-block;
          transform: rotate(45deg);
          height: 7px;
          width: 4.5px;
          border-bottom: 2px solid rgb(255, 255, 255);
          border-right: 2px solid rgb(255, 255, 255);
          border-radius: 1px;
          margin-top: -1px;
        }
      }
    }
  }

}

/* Icon đính kèm: dùng chung footer chat + modal Tạo thông báo (gom trái, không dàn đều). */
.messager-attach-toolbar-icons {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  flex: 0 0 auto;
  max-width: 100%;

  .md-icon.footer-icon,
  img.footer-icon {
    flex: 0 0 auto;
    margin-right: 0 !important;
      cursor: pointer;
  }
}

.chat-footer {
  position: relative;
  width: 100%;
  bottom: 0px;
  background-color: white;
  border-top: 1px solid #e5e5e5;
  overflow: visible;
  //position: absolute;

  .reply-section {
    overflow: visible;

    .chat-footer__toolbar {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      gap: 8px 12px;
      padding: 6px 10px 4px;
      border-bottom: 1px solid #f0f0f0;
      background: #fafafa;

      /* Chi tiết flex/gap: class messager-attach-toolbar-icons (dùng chung modal thông báo). */
      .chat-footer__toolbar-icons {
        flex: 0 0 auto;
        max-width: 100%;
      }

      /* Chiều rộng theo nội dung (wrap-width), không kéo full hàng; hẹp màn hình thì max-width 100%. */
      .chat-footer__toolbar-type {
        flex: 0 1 auto;
        width: fit-content;
        max-width: 100%;
        margin-left: auto;
      }

      .message-type-picker {
        position: relative;
        z-index: 100;
      }

      .chat-footer__message-type-trigger {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        width: max-content;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        height: 32px;
        padding: 4px 8px 4px 10px;
        border: none;
          background: transparent;
        font-weight: 500;
        font-family: inherit;
        cursor: pointer;
        line-height: 1.2;
        text-align: left;

        .message-type-picker__trigger-icon {
          font-size: 18px !important;
          width: 20px;
          min-width: 20px;
          height: 20px;
          margin: 0 !important;
          color: inherit !important;
        }

        .message-type-picker__trigger-label {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: min(220px, 52vw);
        }

        .message-type-picker__chevron {
          font-size: 20px !important;
          width: 20px;
          min-width: 20px;
          margin: 0 0 0 2px !important;
          color: inherit !important;
          opacity: 0.85;
            font-weight:500;
        }

        &.message-type-picker__trigger--icon-only {
          padding: 4px 8px;
          gap: 4px;

          .message-type-picker__chevron {
            margin-left: 0 !important;
          }
        }

        &.message-type-pill--normal {
          color: #505050;
        }

        &.message-type-pill--default {
          color: #18a619;
          font-weight:600;
        }

        &.message-type-pill--report {
          color: #376bfb;
          font-weight:600;
        }

        &.message-type-pill--reward {
          color: #ff7b00;
          font-weight:600;
        }

        &.message-type-pill--discipline {
          color: #d14343;
          font-weight:600;
        }

        &:focus {
          outline: none;
          box-shadow: 0 0 0 2px rgba(25, 142, 235, 0.25);
        }

        &.message-type-pill--default:focus,
        &.message-type-pill--report:focus,
        &.message-type-pill--reward:focus,
        &.message-type-pill--discipline:focus {
          box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.35);
        }
      }

      /* Mở lên tránh bị cắt phía dưới (viewport / messager overflow). */
      .message-type-picker__panel {
        position: absolute;
        right: 0;
        bottom: calc(100% + 4px);
        top: auto;
        z-index: 10050;
        min-width: 100%;
        width: max-content;
        max-width: min(320px, 92vw);
        max-height: min(280px, 42vh);
        overflow-y: auto;
        padding: 4px 0;
        background: #fff;
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.14);
      }

      .message-type-picker__option {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        margin: 0;
        padding: 8px 12px;
        border: none;
        background: transparent;
        cursor: pointer;
        font-size: 13px;
        font-weight: 500;
        font-family: inherit;
        color: #333;
        text-align: left;

        &:hover {
          background: #f5f5f5;
        }

        &.is-active {
          background: #e8f4fd;
        }
      }

      .message-type-picker__option-icon {
        font-size: 20px !important;
        width: 22px;
        min-width: 22px;
        margin: 0 !important;
        color: #555 !important;
      }

      .message-type-picker__option-spacer {
        display: inline-block;
        width: 22px;
        min-width: 22px;
        flex-shrink: 0;
      }

      .message-type-picker__option-label {
        flex: 1;
        min-width: 0;
      }

      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }

      /* img SVG: tránh content-box (32px + padding → lớn hơn md-icon ~32px tổng). */
      .upload-file.footer-icon {
        box-sizing: border-box !important;
        width: 32px !important;
        height: 32px !important;
        padding: 6px !important;
        object-fit: contain;
        object-position: center;
        cursor: pointer;
        border-radius: 4px;
        flex-shrink: 0;

        &:hover {
          background: #0099ff1f;
        }
      }
    }

    .chat-footer__composer-row {
      .md-list-item-content {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        width: 100%;
        max-width: 100%;
      }

      .text-input {
        flex: 1 1 auto;
        min-width: 0;
        align-self: center;
        min-height: 48px;
      }

      .sticker--footer-right,
      .img-emoji,
      .img-send {
        flex-shrink: 0;
        align-self: center;
      }
    }

    .md-list-item{
      .md-button-clean{
        overflow: inherit;
      }
      // vue-material: .md-list-item-content > .md-icon:first-child { margin-right: 32px } kéo giãn icon ảnh
      .md-list-item-content > .md-icon {
        margin-right: 0 !important;
      }
    }
    .text-input {
      margin: 0;
      padding: 6px 0;
      max-height: 200px;
      border-bottom: none !important;
      box-shadow: none !important;
      min-height: 48px;
      &::after,
      &::before {
        display: none !important;
      }
      #input-chat {
        //min-height: fit-content;
        padding: 8px 8px 0;
        //resize: inherit;
        width: 100% !important;
        min-height: 36px;
        max-height: 180px;
        overflow-x: hidden;
        overflow-y: auto;
        background-color: transparent;
        border-radius: 4px;
        font-size: 1rem;
        color: #000;
        resize: none;
        border: none !important;
        box-shadow: none !important;
        /* Vẫn cuộn được khi quá max-height; không hiện thanh scrollbar (tránh nhấp nháy / chiếm chỗ). */
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
          width: 0;
          height: 0;
          background: transparent;
        }
      }
    }

    .emoji {
      bottom: 55px;
      right: 40px;
      top: auto;
      z-index: 100;
    }
    .fast-message {
      position: relative;
      width: 100%;
      box-sizing: border-box;
      background: #fff;
      border-bottom: 1px solid #dbdbdb;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 10px;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      padding: 8px 10px;
      flex-shrink: 0;
      -webkit-overflow-scrolling: touch;

      .f-message {
        flex: 0 0 auto;
        width: max-content;
        padding: 2px 6px;
        background: #ffff00;
        font-size: 14px;
        &:hover {
          cursor: pointer;
          background: #eaea00;
        }
      }
    }
  }

  .tag {
    top: -228px;
    height: 240px;
    width: 270px;
    position: absolute;
    left: 90px;
    background: white;
    display: block;
    box-shadow: 0px 4px 20px 0px rgb(52 73 94 / 20%);
    border-radius: 5px;
    z-index: 998;

    .md-avatar {
      height: 32px !important;
      width: 32px !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      min-width: auto;
    }

    .md-list-item {
      margin-left: 0px;
    }
  }

  .md-ripple {
    padding: 0px 12px 0px 6px !important;
  }

  .footer-icon {
    width: 32px !important;
    height: 32px !important;
    padding: 6px;
    cursor: pointer;
    border-radius: 4px;

    &:hover {
      background: #0099ff1f;
    }
  }

  .footer-icon-media {
    font-size: 22px !important;
    min-width: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .img-send {
    width: 32px !important;
    padding: 4px;
    margin-left: 6px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .md-input {
    margin-left: 10px;
    margin-right: 10px;
    border: none;
  }

  .file-upload__container {
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    padding: 15px;
    width: auto;
    .upload-file-chat {
      position: relative;
    }
    .file-upload-chat{
      .error-upload {
        width: 100% !important;
        left: 50% !important;
      }
    }
    .error-upload {
      position: absolute;
      top: 50%;
      left: 40%;
      transform: translate(-50%, -50%);
      color: red;
      background-color: #e3dedede;
      width: 60px;
      height: 60px;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 19px;
    }
    .photo-upload-item {
      background-color: #ededed;
      border: 1px solid #e8e7e7;
      border-radius: 3px;
      height: 52px;
      min-height: 52px;
      min-width: 52px;
      width: 52px;
      position: relative;
      text-align: center;
      margin-right: 15px;

      .file-img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }

    .file-upload-item {
      background-color: #ededed;
      border-radius: 5px;
      display: inline-block;
      position: relative;
      width: 220px;
      margin-right: 15px;

      .item-container {
        align-items: center;
        display: flex;
        padding: 6px;

        .url-colection-thumb {
          width: 30px;
        }

        .file-content {
          width: 166px;
        }

      }
    }

    .photo-delete__action {
      top: -6px;
      right: -6px;
      position: absolute;
      cursor: pointer;
      border-radius: 20px;
      background: #978ded;
      z-index: 10;
      i {
        font-size: 16px !important;
        color: white;
      }
    }

  }

  .active-send {
    color: #00a5bb;
  }

  .reply-messager {
    font-size: 14px;
    margin: 10px 30px 2px;
    border-left: 3px solid #0074ff;
    background: #ebebeb;
    padding: 10px 10px;
    border-radius: 5px;
    position: relative;

    .sender-reply, .edit-message {
      display: flex;
      margin-bottom: 2px;
      align-items: center;
      .material-icons {
        color: #6e6e6e;
        margin-right: 4px;
      }

      .reply-announcement-avatar {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 6px;
        flex-shrink: 0;
        border: 1px solid #ddd;
      }
    }

    .cancel-reply {
      position: absolute;
      top: 6px;
      right: 6px;

      .cancelRep {
        font-family: 'Material Icons';
        font-weight: normal;
        font-style: normal;
        font-size: 16px;
        line-height: 1;
        letter-spacing: normal;
        text-transform: none;
        display: inline-block;
        white-space: nowrap;
        word-wrap: normal;
        direction: ltr;
        -webkit-font-feature-settings: 'liga';
        -webkit-font-smoothing: antialiased;
      }
    }

    .templateType {
      margin-right: 10px;
      display: flex;
      align-items: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 100%;
      .material-symbols-outlined {
        font-size: 40px;
        color: #FFAE0D;
        margin-right: 4px;
      }
      .reply-file-icon {
        width: 32px;
        height: 32px;
        margin-right: 6px;
        flex-shrink: 0;
        object-fit: contain;
      }
      .text {
        font-weight: 500;
        color: #6a6a6a;
      }
      .reply-asset {
        width: auto;
        min-width: 40px;
        max-width: 70px;
        height: 40px;
        border-radius: 4px;
        margin-right: 6px;
        object-fit: cover;
      }
    }
  }
  .md-field.md-has-textarea:not(.md-autogrow):before {
    border-bottom: none !important;
    border-color: transparent !important;
  }
  .user-reply {
    position: absolute;
    min-width: 300px;
    height: 24px;
    top: -24px;
    padding-top: 2px;
    padding-left: 10px;
    border-top-right-radius: 12px;
    background: #d6dfe1f7;
    z-index: 100;

    span::after {
      display: inline-block;
      animation: dotty steps(1,end) 1s infinite;
      content: '';
    }

    @keyframes dotty {
      0%   { content: ''; }
      25%  { content: '.'; }
      50%  { content: '..'; }
      75%  { content: '...'; }
      100% { content: ''; }
    }
  }
}

.container-message {
  .image-content-wrapper-video {
    height: 250px;
    width: 350px;
  }

  .wrapper-image {
    height: 100%;
    cursor: pointer;
    .hd-quality {
      position: absolute;
      top: 10px;
      left: 10px;
      padding: 0 4px;
      border-radius: 4px;
      line-height: 16px;
      background: white;
      border: 1px solid #bfbfbf;
      font-size: 10px;
      font-weight: 600;
      color: black;
    }
  }

  .wrapper-image1 {
    margin: 5px 0px 5px;

    .card-media {
      max-width: 450px;
      max-height: 450px;
      text-align: center;

      video {
        max-width: 100%;
        min-height: 250px;
        position: relative;
        width: auto;
        height: 100%;
        box-sizing: border-box;
        margin: auto;
        object-fit: contain;
      }

      img {
        margin: auto;
        height: 100%;
        width: auto;
        max-width: 100%;
        object-fit: contain;
        border-radius: 6px;
        overflow: hidden;
        border: 1px solid #d5d5d5;
      }
    }
  }

  .wrapper-image2, .wrapper-image3, .wrapper-image4, .wrapper-image5 {
    margin: 0px 0px 5px;
    max-width: 400px;

    .card-media {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
        overflow: hidden;
        border: 1px solid #d5d5d5;
      }

      display: inline-block;
    }
  }

  .wrapper-image2 {
    .card-media:nth-child(1) {
      padding-bottom: 4px;
    }

    .card-media {
      height: 50%;
      width: 100%;

      .media-image {
        height: 200px;
      }
    }
  }

  .wrapper-image3 {
    width: 400px;
    height: 450px;

    .card-media:nth-child(1) {
      width: 100%;
      height: 60%;
    }

    .card-media:nth-child(2), .card-media:nth-child(3) {
      height: 40%;
      width: 50%;
    }

    .card-media:nth-child(1) {
      padding-bottom: 3px;
    }

    .card-media:nth-child(2) {
      padding-right: 3px;
    }
  }

  .wrapper-image4 {
    width: 400px;
    height: 400px;

    .card-media:nth-child(1), .card-media:nth-child(2), .card-media:nth-child(3), .card-media:nth-child(4) {
      width: 50%;
      height: 50%;
    }

    .card-media:nth-child(1) {
      padding-bottom: 3px;
      padding-right: 3px;
    }

    .card-media:nth-child(2) {
      padding-bottom: 3px;
    }

    .card-media:nth-child(3) {
      padding-right: 3px;
    }
  }

  .wrapper-image5 {
    width: 400px;
    height: 330px;

    .card-media:nth-child(1), .card-media:nth-child(2) {
      width: 50%;
      height: 60%;
    }

    .card-media:nth-child(3), .card-media:nth-child(4), .card-media:nth-child(5) {
      width: calc(100% / 3);
      height: 40%;
    }

    .card-media:nth-child(1) {
      padding-bottom: 3px;
      padding-right: 3px;
    }

    .card-media:nth-child(2) {
      padding-bottom: 3px;
    }

    .card-media:nth-child(3), .card-media:nth-child(4) {
      padding-right: 3px;
    }

    .card-media:nth-child(5) {
      position: relative;

      .total-image-other-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        background: black;
        opacity: 0.5;
        display: flex;
      }

      .total-image-other {
        position: absolute;
        top: 50%;
        align-self: center;
        text-align: center;
        width: 100%;
        color: white;
        font-size: 2rem;
        transform: translateY(-50%);
      }

      .countFile {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        background: rgba(0 0 0 / 52%);
        border-radius: 5px;
      }

      .totalCount {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 26px;
        color: #fff;
        font-weight: 700;
      }
    }
  }
  .messager{
    position: relative;
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;
    .scroll-bottom-anchor {
      position: absolute;
      left: 50%;
      bottom: 80px;
      transform: translateX(-50%);
      z-index: 101;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      pointer-events: none;

      > * {
        pointer-events: auto;
      }
    }

    .scroll-new-messages-pill {
      border: 1px solid #cfe4ff;
      background: #ffffff;
      color: #0079ff;
      border-radius: 20px;
      padding: 8px 16px;
      font-size: 13px;
      font-weight: 500;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
      cursor: pointer;
      white-space: nowrap;
    }

    .scroll-to-new-messager {
      position: relative;
      width: 40px;
      height: 40px;
      left: auto;
      bottom: auto;
      transform: none;
      display: flex;
      background: #ffffff;
      border: 1px solid #e2e2e2;
      border-radius: 100%;
      font-size: 40px;
      box-shadow: 0px 0px 4px 1px rgb(0 0 0 / 10%);
      .md-icon {
        color: #0079ff;
      }
    }
  }
  .chat-privacy {
    padding: 15px 10px;
    font-size: 13px;
    border-top: 1px solid #e1e1e1;
    width: 100%;
    * {
      text-align: center;
    }
    .team-leader-chatgroup {
      color: #178bde;
      font-weight: 500;
      &:hover{
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}

.loader {
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top: 3px solid #3498db;
  width: 30px;
  height: 30px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  position: absolute;
  top: 25px;
  left: 45%;
  z-index: 5;
}
.loading-holder{
    .loader-shimmer{
      animation-duration: 2.2s;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
      animation-name: shimmer;
      animation-timing-function: linear;
      background: #ddd;
      background: linear-gradient(to right, #f7f6f6 8%, #efefef 18%, #F6F6F6 33%);
      background-size: 1200px 100%;
      color: transparent;
      img{
        display: none;
      }
    }
}

@-webkit-keyframes shimmer {
    0% {
        background-position: -100% 0;
    }
    100% {
        background-position: 100% 0;
    }
}

@keyframes shimmer {
    0% {
        background-position: -1200px 0;
    }
    100% {
        background-position: 1200px 0;
    }
}

.announcement-compose-modal {
  .md-dialog-actions button {
    width: auto !important;
  }

  .announcement-compose-modal__char-count {
    font-size: 12px;
  }

  .announcement-compose-modal__textarea {
    min-height: 100px;
    resize: vertical;
  }

  .announcement-compose-modal__payload-block {
    margin-bottom: 0;
  }

  .announcement-compose-modal__hint {
    margin: 0 0 10px;
    line-height: 1.45;
    font-size: 13px;

    strong {
      font-weight: 600;
      color: #444;
    }
  }

  .announcement-compose-modal__payload-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 8px 10px;
    margin-bottom: 10px;
  }

  .announcement-compose-modal__kv-field {
    flex: 1 1 160px;
    min-width: 0;

    label {
      display: block;
      margin-bottom: 4px;
    }
  }

  .announcement-compose-modal__row-remove {
    flex: 0 0 auto;
    margin-bottom: 6px;
    color: #888;

    &:hover {
      color: #d14343;
    }

    .md-icon {
      font-size: 22px !important;
    }
  }

  .announcement-compose-modal__add-field {
    padding: 6px 10px;
      background-color: #5b49bf !important;
  }

  .announcement-compose-modal__attach-bar {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-top: 6px;
  }

  .announcement-compose-modal__file-strip {
    margin-top: 10px;
    max-height: 200px;
    overflow-x: auto;
    overflow-y: hidden;
    padding-top: 8px;

    .file-upload__container {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      gap: 8px;
      align-items: flex-start;
      padding: 10px 12px;
      border-bottom: 1px solid #e5e5e5;
    }

    .upload-file-chat {
      flex: 0 0 auto;
      position: relative;
    }

    .photo-upload-item {
      position: relative;
      background-color: #ededed;
      border: 1px solid #e8e7e7;
      border-radius: 6px;
      width: 88px;
      height: 88px;
      min-width: 88px;
      min-height: 88px;
      overflow: hidden;
      text-align: center;
      margin-right: 0;

      .p-relative {
        width: 100%;
        height: 100%;
      }

      .file-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 0;
        border: none;
        display: block;
      }
    }

    .file-upload-item {
      position: relative;
      background-color: #ededed;
      border-radius: 5px;
      display: inline-block;
      min-width: 200px;
      max-width: 260px;
      margin-right: 0;
    }

    .photo-delete__action {
      top: -6px;
      right: -6px;
      position: absolute;
      cursor: pointer;
      border-radius: 20px;
      background: #978ded;
      z-index: 10;

      i {
        font-size: 16px !important;
        color: white;
      }
    }
  }
}

.rule-modal{
  line-height: 2;
  margin: 10px 0 10px;
  p {
    margin: 0;
  }
  ol{
    padding-left: 15px;
  }
  ul{
    // padding-left: 1.5rem;
    display: flex;
    flex-direction: column;
    list-style: none;
    padding-left: 0;
    li{
      position: relative;
      padding-left: 15px;
      // margin: 5px;
      line-height: 20px;
      &::before{
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: black;
      }
    }
  }
  s {
    text-decoration: line-through;
  }
}

/* Host ẩn: panel được append sang #messenger-right-column (ContentLayout). */
.messenger-sidebar-host {
  display: none !important;
  width: 0;
  height: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  visibility: hidden;
}
</style>
